(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beni-aftersales-policy"] && !Shopify.designMode) return;
  try {
    
  // 售后政策页 H2 目录导航：客户端扫描当前区域正文的 <h2> 自动生成锚点导航。
  // 布局（是否两栏）已由服务端 class 决定，本脚本只负责：建导航项 + 高亮 + 点击平滑滚动。
  // sticky 定位由 CSS 负责，JS 不做几何计算 → 轻量、无布局抖动。
  class BeniAspToc extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._mqHandler = this._mqHandler.bind(this);
      this._onToggle = this._onToggle.bind(this);
      this._onDocClick = this._onDocClick.bind(this);
      this._observer = null;
      this._headings = [];
      this._links = [];
      this._dropLinks = [];
      this._isScrolling = false;
      this._scrollTimer = null;
      this._scrollIdle = null;
      this._active = false;
      this._open = false;
    }

    get _gap() { return Number(this.dataset.gap) || 0; }
    get _isMobile() { return !!(this._mq && this._mq.matches); }

    // 站点 header + 公告栏高度（不含 gap / 吸顶条）。
    _headerBase() {
      const cs = getComputedStyle(document.documentElement);
      const header = parseFloat(cs.getPropertyValue('--header-height'));
      const announce = parseFloat(cs.getPropertyValue('--beni-announcement-bar-height'));
      return (Number.isFinite(header) ? header : 80) + (Number.isFinite(announce) ? announce : 0);
    }

    // 滚动目标避让：桌面 = header + gap；移动 = header + 吸顶条自身高度 + 余量。
    _topOffset() {
      const base = this._headerBase();
      if (this._isMobile) {
        const barH = this._bar ? this._bar.offsetHeight : 0;
        return base + barH + 12;
      }
      return base + this._gap;
    }

    connectedCallback() {
      this._region = this.closest('.beni-asp__region');
      this._nav = this.querySelector('.beni-asp__toc-nav');
      this._list = this.querySelector('.beni-asp__toc-list');

      // 移动端吸顶条渲染在容器顶部（标题之上），仅当前生效区域的 toc 负责联动它。
      this._bar = null;
      this._toggle = null;
      this._drop = null;
      this._dropList = null;
      this._current = null;
      if (this.dataset.ownsBar === 'true') {
        const root = this.closest('.beni-asp');
        this._bar = root && root.querySelector('.beni-asp__toc-bar');
        if (this._bar) {
          this._toggle = this._bar.querySelector('.beni-asp__toc-toggle');
          this._drop = this._bar.querySelector('.beni-asp__toc-drop');
          this._dropList = this._bar.querySelector('.beni-asp__toc-drop-list');
          this._current = this._bar.querySelector('.beni-asp__toc-current');
        }
      }
      this._mq = window.matchMedia('(max-width: 749px)');

      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._mqHandler);
      } else if (this._mq.addListener) {
        this._mq.addListener(this._mqHandler);
      }

      // 桌面侧栏与移动吸顶条共用一套 H2 数据，两端都初始化（外壳由 CSS 按断点切换）。
      // section 重渲染时会 disconnect→connect，自动重建。
      this._init();
    }

    disconnectedCallback() {
      this._teardown();
      if (this._mq) {
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this._mqHandler);
        } else if (this._mq.removeListener) {
          this._mq.removeListener(this._mqHandler);
        }
      }
    }

    // 跨断点：关掉下拉、按新避让高度重建 observer。
    _mqHandler() {
      this._setOpen(false);
      if (this._observer) { this._observer.disconnect(); this._initObserver(); }
    }

    _init() {
      if (this._active) return;
      if (!this._region || !this._list) return;
      const content = this._region.querySelector('.beni-asp__content');
      if (!content) return;

      this._headings = Array.from(content.querySelectorAll('h2'));
      if (!this._headings.length) return;

      this._build();
      this._initObserver();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      if (this._toggle) this._toggle.addEventListener('click', this._onToggle);
      this._active = true;
      this._applyHash();
    }

    // 去掉导航标签开头的序号前缀（仅影响导航显示，不改正文标题/锚点）。
    // 覆盖：Part 1 / Part 1: / 1. / 1、 / 1) / 第一部分 等常见写法。
    _cleanLabel(text) {
      let s = String(text || '').trim();
      s = s.replace(/^part\s*\d+\s*[:：.、）)\-—]?\s*/i, '');
      s = s.replace(/^第[零一二三四五六七八九十百0-9]+(部分|章|节)\s*[:：.、）)\-—]?\s*/, '');
      s = s.replace(/^\d+\s*[.:：、）)\-—]\s*/, '');
      return s.trim() || String(text || '').trim();
    }

    _slug(text) {
      return String(text)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9一-龥]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    _ensureId(h, i) {
      if (h.id) return h.id;
      let base = this._slug(h.textContent);
      // 仅在空 / 以数字开头时才补前缀（数字开头的 id 对部分 CSS 选择器不友好）。
      if (!base) base = 'section-' + (i + 1);
      else if (/^\d/.test(base)) base = 'section-' + base;
      let id = base;
      let n = 2;
      while (document.getElementById(id)) { id = base + '-' + n; n++; }
      h.id = id;
      return id;
    }

    _makeLink(id, labelText) {
      const chevron =
        '<span class="beni-asp__toc-chevron" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
        '<path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>';
      const a = document.createElement('a');
      a.className = 'beni-asp__toc-link';
      a.href = '#' + id;
      a.innerHTML = '<span class="beni-asp__toc-label"></span>' + chevron;
      a.querySelector('.beni-asp__toc-label').textContent = labelText;
      a.addEventListener('click', this._onClick);
      return a;
    }

    _build() {
      this._list.innerHTML = '';
      if (this._dropList) this._dropList.innerHTML = '';
      this._links = [];
      this._dropLinks = [];

      this._headings.forEach((h, i) => {
        const id = this._ensureId(h, i);
        const label = this._cleanLabel(h.textContent);

        // 桌面侧栏项
        const li = document.createElement('li');
        const a = this._makeLink(id, label);
        a.dataset.tocIndex = i;
        li.appendChild(a);
        this._list.appendChild(li);
        this._links.push(a);

        // 移动下拉项
        if (this._dropList) {
          const dli = document.createElement('li');
          const da = this._makeLink(id, label);
          da.dataset.tocIndex = i;
          dli.appendChild(da);
          this._dropList.appendChild(dli);
          this._dropLinks.push(da);
        }
      });

      // 吸顶条初始标题 = 第一个小节
      if (this._current && this._headings.length) {
        this._current.textContent = this._cleanLabel(this._headings[0].textContent);
      }
    }

    _initObserver() {
      const clearance = this._topOffset();
      this._observer = new IntersectionObserver(
        (entries) => {
          if (this._isScrolling) return;
          const visible = entries
            .filter((e) => e.isIntersecting)
            .map((e) => this._headings.indexOf(e.target))
            .filter((i) => i >= 0);
          if (visible.length) this._setActive(Math.min.apply(null, visible));
        },
        { root: null, threshold: 0.01, rootMargin: '-' + clearance + 'px 0px -60% 0px' }
      );
      this._headings.forEach((h) => this._observer.observe(h));
    }

    _setActive(index) {
      this._links.forEach((link, i) => link.classList.toggle('is-active', i === index));
      this._dropLinks.forEach((link, i) => link.classList.toggle('is-active', i === index));
      // 吸顶条实时显示当前小节
      if (this._current && this._headings[index]) {
        this._current.textContent = this._cleanLabel(this._headings[index].textContent);
      }
    }

    _onClick(e) {
      const index = Number(e.currentTarget.dataset.tocIndex);
      const h = this._headings[index];
      if (!h || !h.isConnected || !h.getClientRects().length) return;
      e.preventDefault();
      this._isScrolling = true;
      this._setActive(index);
      this._setOpen(false); // 点项后收起下拉
      const top = h.getBoundingClientRect().top + window.pageYOffset - this._topOffset();
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (h.id && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + h.id);
      }
      clearTimeout(this._scrollTimer);
      this._scrollTimer = setTimeout(() => { this._isScrolling = false; }, 700);
    }

    _onToggle() { this._setOpen(!this._open); }

    _setOpen(open) {
      this._open = open;
      if (this._drop) this._drop.hidden = !open;
      if (this._toggle) this._toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        document.addEventListener('click', this._onDocClick, true);
      } else {
        document.removeEventListener('click', this._onDocClick, true);
      }
    }

    // 点面板外收起（toggle 与项都在 bar 内，不会误关）。
    _onDocClick(e) {
      if (!this._bar) return;
      if (!this._bar.contains(e.target)) this._setOpen(false);
    }

    // 滚动中禁用 nav 指针事件，避免浏览器把静止光标误判为 hover（sticky 移动时）。
    _onScroll() {
      if (!this._nav) return;
      this._nav.classList.add('is-scrolling');
      clearTimeout(this._scrollIdle);
      this._scrollIdle = setTimeout(() => {
        if (this._nav) this._nav.classList.remove('is-scrolling');
      }, 150);
    }

    // 深链：首次带 #hash 进入时，因 h2 的 id 是脚本生成的，浏览器原生跳转会落空，这里补跳一次。
    _applyHash() {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      let target = null;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return; }
      if (!target || this._headings.indexOf(target) < 0) return;
      requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.pageYOffset - this._topOffset();
        window.scrollTo({ top: top, behavior: 'auto' });
      });
    }

    _teardown() {
      if (!this._active) return;
      this._setOpen(false);
      window.removeEventListener('scroll', this._onScroll);
      if (this._observer) { this._observer.disconnect(); this._observer = null; }
      this._links.forEach((link) => link.removeEventListener('click', this._onClick));
      this._dropLinks.forEach((link) => link.removeEventListener('click', this._onClick));
      if (this._toggle) this._toggle.removeEventListener('click', this._onToggle);
      clearTimeout(this._scrollTimer);
      clearTimeout(this._scrollIdle);
      if (this._nav) this._nav.classList.remove('is-scrolling');
      this._links = [];
      this._dropLinks = [];
      this._headings = [];
      this._active = false;
    }
  }

  if (!window.customElements.get('beni-asp-toc')) {
    window.customElements.define('beni-asp-toc', BeniAspToc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beni-help-sidebar"] && !Shopify.designMode) return;
  try {
    
  class BeniHelpSidebar extends HTMLElement {
    constructor() {
      super();
      this._onNavClick = this._onNavClick.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._mqHandler = this._mqHandler.bind(this);
      this._onSectionChange = this._onSectionChange.bind(this);
      this._raf = null;
      this._scrollTimer = null;
      this._scrollIdle = null;
      this._refreshRaf = null;
      this._isScrolling = false;
      this._active = false;
      this._covered = [];
      this._observer = null;
    }

    get _bp() { return Number(this.dataset.breakpoint) || 990; }
    get _count() { return Math.max(1, Number(this.dataset.coveredCount) || 1); }
    get _gap() { return Number(this.dataset.gap) || 0; }
    get _indent() { return Number(this.dataset.indent) || 280; }

    // 顶部避让高度 = 实时 header 高度 + 公告栏高度 + gap。
    // --header-height 由 header.liquid / yg-header.liquid 维护；
    // --beni-announcement-bar-height 由公告栏维护（无/关闭/滚走时自动为 0px），故无需判断显示模式。
    _headerClearance() {
      const cs = getComputedStyle(document.documentElement);
      const header = parseFloat(cs.getPropertyValue('--header-height'));
      const announce = parseFloat(cs.getPropertyValue('--beni-announcement-bar-height'));
      const base = (Number.isFinite(header) ? header : 80) + (Number.isFinite(announce) ? announce : 0);
      return base + this._gap;
    }

    connectedCallback() {
      this.nav = this.querySelector('.beni-help-nav');
      this.links = Array.from(this.querySelectorAll('.beni-help-nav__link'));
      this._mq = window.matchMedia('(max-width: ' + (this._bp - 1) + 'px)');

      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._mqHandler);
      } else if (this._mq.addListener) {
        this._mq.addListener(this._mqHandler);
      }

      // 后台编辑器局部重渲染兄弟 section 时，DOM 节点被替换 → 覆盖引用失效，需刷新
      document.addEventListener('shopify:section:load', this._onSectionChange);
      document.addEventListener('shopify:section:unload', this._onSectionChange);

      // 仅桌面端初始化；移动端不做任何事
      if (!this._mq.matches) this._init();
    }

    disconnectedCallback() {
      this._teardown();
      if (this._refreshRaf) cancelAnimationFrame(this._refreshRaf);
      document.removeEventListener('shopify:section:load', this._onSectionChange);
      document.removeEventListener('shopify:section:unload', this._onSectionChange);
      if (this._mq) {
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this._mqHandler);
        } else if (this._mq.removeListener) {
          this._mq.removeListener(this._mqHandler);
        }
      }
    }

    // 重渲染/隐藏后刷新覆盖引用（indent 由 CSS 负责，这里只重建 observer / 绑定 / 定位）。
    // 延后一帧执行：shopify:section:unload 可能在节点真正移除前触发，延一帧才能读到最终 DOM。
    _onSectionChange() {
      if (this._mq.matches) return;
      if (this._refreshRaf) cancelAnimationFrame(this._refreshRaf);
      this._refreshRaf = requestAnimationFrame(() => {
        this._refreshRaf = null;
        if (!this.isConnected || this._mq.matches) return;
        if (!this._active) { this._init(); return; }
        const wrapper = this.closest('.shopify-section');
        if (!wrapper || !wrapper.isConnected) return;
        if (this._observer) this._observer.disconnect();
        this._unbindLinks();
        this._covered = this._collect(wrapper);
        if (!this._covered.length) { this._teardown(); return; }
        this._bindLinks();
        this._initObserver();
        this._layout();
        this._updatePin();
      });
    }

    _mqHandler() {
      // 跨断点：进移动端拆除，回桌面端重建
      if (this._mq.matches) this._teardown();
      else this._init();
    }

    _init() {
      if (this._active) return;
      const wrapper = this.closest('.shopify-section');
      if (!wrapper) return;

      this._covered = this._collect(wrapper);
      if (!this._covered.length) return;

      this._bindLinks();
      this._initObserver();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._layout();
      this._updatePin();
      this._active = true;
    }

    _collect(wrapper) {
      const out = [];
      let el = wrapper.nextElementSibling;
      while (el && out.length < this._count) {
        if (el.classList && el.classList.contains('shopify-section')) {
          out.push(el);
        }
        el = el.nextElementSibling;
      }
      // 缩进由 CSS 相邻兄弟链负责，这里仅返回覆盖引用供 observer / 点击 / 定位使用
      return out;
    }

    _bindLinks() {
      this.links.forEach((link) => {
        const pos = Number(link.dataset.position) || 0;
        const sec = this._covered[pos - 1];
        if (sec) {
          if (sec.id) link.setAttribute('href', '#' + sec.id);
          link.addEventListener('click', this._onNavClick);
          link.removeAttribute('aria-disabled');
        } else {
          link.setAttribute('aria-disabled', 'true');
        }
      });
    }

    _unbindLinks() {
      this.links.forEach((link) => link.removeEventListener('click', this._onNavClick));
    }

    _initObserver() {
      this._observer = new IntersectionObserver(
        (entries) => {
          if (this._isScrolling) return;
          const visible = entries
            .filter((e) => e.isIntersecting)
            .map((e) => this._covered.indexOf(e.target))
            .filter((i) => i >= 0);
          if (visible.length) this._setActive(Math.min.apply(null, visible) + 1);
        },
        { root: null, threshold: 0.01, rootMargin: '-' + this._headerClearance() + 'px 0px -60% 0px' }
      );
      this._covered.forEach((sec) => this._observer.observe(sec));
    }

    _setActive(position) {
      this.links.forEach((link) => {
        link.classList.toggle('is-active', (Number(link.dataset.position) || 0) === position);
      });
    }

    _onNavClick(e) {
      const link = e.currentTarget;
      const pos = Number(link.dataset.position) || 0;
      const sec = this._covered[pos - 1];
      // 目标被隐藏/移除（零尺寸或脱离文档）时不跳转，避免滚到错误位置
      if (!sec || !sec.isConnected || !sec.getClientRects().length) return;
      e.preventDefault();
      this._isScrolling = true;
      this._setActive(pos);
      const top = sec.getBoundingClientRect().top + window.pageYOffset - this._headerClearance();
      window.scrollTo({ top: top, behavior: 'smooth' });
      clearTimeout(this._scrollTimer);
      this._scrollTimer = setTimeout(() => { this._isScrolling = false; }, 700);
    }

    _onScroll() {
      // 滚动中禁用指针事件，避免 fixed 导航滑到静止光标下误触 :hover；停止后恢复
      if (this.nav) {
        this.nav.classList.add('is-scrolling');
        clearTimeout(this._scrollIdle);
        this._scrollIdle = setTimeout(() => {
          if (this.nav) this.nav.classList.remove('is-scrolling');
        }, 150);
      }
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        this._updatePin();
      });
    }

    _onResize() {
      this._layout();
      this._updatePin();
    }

    // 计算 fixed 侧栏左缘：对齐版心左缘 = page-width 外缘 + 版心 padding
    _layout() {
      if (!this._covered.length || !this.nav) return;
      const first = this._covered[0];
      const ref = first.querySelector('.page-width') || first;
      const rect = ref.getBoundingClientRect();
      // 覆盖 section 的 page-width 已被 CSS 设为 (版心 padding + indent)，
      // 反推出版心 padding；若链未命中（padding < indent）则该值本身即为版心 padding。
      const measuredPad = parseFloat(getComputedStyle(ref).paddingLeft) || 0;
      const basePad = measuredPad >= this._indent ? measuredPad - this._indent : measuredPad;
      this.nav.style.setProperty('--beni-help-left', (Math.max(0, rect.left) + basePad) + 'px');
    }

    // Sticky-rail 定位：top 以第一个锚点 section 为准，滚过 header 线后钉住，收底不压 footer。
    _updatePin() {
      if (!this._covered.length || !this.nav) return;
      // 仅用「在文档中且非零尺寸」的覆盖 section 作几何依据：
      // 隐藏/移除某个 section（尤其是首/尾）时其矩形为 0，会误翻转显隐，这里过滤掉。
      const visible = this._covered.filter((el) => el.isConnected && el.getClientRects().length > 0);
      if (!visible.length) { this.nav.classList.remove('is-visible'); return; }

      const vh = window.innerHeight || document.documentElement.clientHeight;
      const clearance = this._headerClearance();
      const first = visible[0].getBoundingClientRect();
      const last = visible[visible.length - 1].getBoundingClientRect();
      const navH = this.nav.offsetHeight;
      const maxTop = last.bottom - navH;

      // 显示条件：第一个 section 已进视口，且 header 线以下仍放得下导航
      // （尾部若已顶到 header 线附近则隐藏，避免被上拽盖住 header）
      const show = first.top < vh && maxTop >= clearance;
      this.nav.classList.toggle('is-visible', show);
      if (!show) return;

      // 贴第一个 section 顶部；滚到 header 线以上时钉在 header 线；末端收底。
      // 此处 maxTop >= clearance，故 top 恒 >= clearance，绝不越过 header 线。
      let top = Math.max(clearance, first.top);
      if (top > maxTop) top = maxTop;
      this.nav.style.top = Math.round(top) + 'px';
    }

    _teardown() {
      if (!this._active) return;
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this._observer) { this._observer.disconnect(); this._observer = null; }
      this._unbindLinks();
      clearTimeout(this._scrollIdle);
      clearTimeout(this._scrollTimer);
      if (this.nav) this.nav.classList.remove('is-visible', 'is-scrolling');
      this._covered = [];
      this._active = false;
    }
  }

  if (!window.customElements.get('beni-help-sidebar')) {
    window.customElements.define('beni-help-sidebar', BeniHelpSidebar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-attention"] && !Shopify.designMode) return;
  try {
    
  class YgAttentionSection extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.classList.add('is-ready');
      });
    }
  }

  if (!customElements.get('yg-attention-section')) {
    customElements.define('yg-attention-section', YgAttentionSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGBannerTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.handleClick = this.handleClick.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handlePointerCancel = this.handlePointerCancel.bind(this);
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      this.swipeState = null;
      this.suppressClick = false;
      this.addEventListener('click', this.handleClick);
      this.addEventListener('click', this.handleClickCapture, true);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerCancel);

      this.panelObserver = new MutationObserver(() => this.syncState());
      this.querySelectorAll('.yg-banner-tabs__panel').forEach((panel) => {
        this.panelObserver.observe(panel, {
          attributes: true,
          attributeFilter: ['class'],
        });
      });

      this.preloadVideoPosters();
      requestAnimationFrame(() => this.syncState());

      if (window.customElements.get('yg-video')) {
        this.syncVideos();
      } else {
        window.customElements.whenDefined('yg-video').then(() => this.syncVideos());
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('click', this.handleClickCapture, true);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerCancel);
      this.panelObserver?.disconnect();
    }

    handleClick(event) {
      if (!event.target.closest('.tab-title')) return;

      requestAnimationFrame(() => this.syncState());
    }

    handleClickCapture(event) {
      if (this.suppressClick && event.isTrusted) {
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
        return;
      }

      const tab = event.target.closest('.tab-title');
      if (!tab) return;

      if (tab.classList.contains('is-active')) {
        this.restartPanelVideo(this.getPanelForTab(tab));
        return;
      }

      if (tab.dataset.posterReady === 'true') return;

      const panel = this.getPanelForTab(tab);
      if (!panel || !panel.querySelector('.yg-video-placeholder')) return;

      event.preventDefault();
      event.stopPropagation();
      this.preparePanelPoster(panel).finally(() => {
        tab.dataset.posterReady = 'true';
        tab.click();
      });
    }

    handlePointerDown(event) {
      if (!this.mobileMedia.matches || !event.isPrimary || event.pointerType === 'mouse') return;

      this.swipeState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        currentX: event.clientX,
        startedAt: performance.now(),
        direction: null,
      };
    }

    handlePointerMove(event) {
      const swipeState = this.swipeState;
      if (!swipeState || event.pointerId !== swipeState.pointerId) return;

      const deltaX = event.clientX - swipeState.startX;
      const deltaY = event.clientY - swipeState.startY;
      swipeState.currentX = event.clientX;

      if (!swipeState.direction && Math.max(Math.abs(deltaX), Math.abs(deltaY)) >= 8) {
        swipeState.direction = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
      }

      if (swipeState.direction === 'vertical') {
        this.swipeState = null;
        return;
      }

      if (swipeState.direction === 'horizontal') event.preventDefault();
    }

    handlePointerUp(event) {
      const swipeState = this.swipeState;
      if (!swipeState || event.pointerId !== swipeState.pointerId) return;

      this.swipeState = null;
      const deltaX = event.clientX - swipeState.startX;
      const elapsed = Math.max(performance.now() - swipeState.startedAt, 1);
      const velocity = Math.abs(deltaX) / elapsed;
      const threshold = Math.min(72, Math.max(40, this.clientWidth * 0.12));

      if (swipeState.direction !== 'horizontal' || (Math.abs(deltaX) < threshold && velocity < 0.35)) return;

      const tabs = Array.from(this.querySelectorAll('.tab-title'));
      const activeIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
      const targetIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
      const targetTab = tabs[targetIndex];
      if (!targetTab) return;

      this.suppressClick = true;
      targetTab.click();
      window.setTimeout(() => {
        this.suppressClick = false;
      }, 400);
    }

    handlePointerCancel(event) {
      if (this.swipeState?.pointerId === event.pointerId) this.swipeState = null;
    }

    handleBlockSelect(event) {
      const blockId = event.target?.dataset?.blockId;
      if (!blockId) return;

      this.querySelector(`.tab-title[data-block-id="${blockId}"]`)?.click();
    }

    getPanelForTab(tab) {
      const tabs = Array.from(this.querySelectorAll('.tab-title'));
      const panels = Array.from(this.querySelectorAll('.yg-banner-tabs__panel'));
      return panels[tabs.indexOf(tab)];
    }

    restartPanelVideo(panel) {
      const video = panel?.querySelector('yg-video');
      if (!video) return;

      const restart = () => {
        video.classList.remove('is-media-ready');
        video.pauseVideo?.();
        video.playVideo?.();
        this.revealVideoAfterFirstFrame(video);
      };

      if (typeof video.pauseVideo === 'function' && typeof video.playVideo === 'function') {
        restart();
        return;
      }

      window.customElements.whenDefined('yg-video').then(restart);
    }

    preloadVideoPosters() {
      this.querySelectorAll('.yg-video-placeholder img').forEach((poster) => {
        this.loadPosterImage(poster, 'low');
      });
    }

    preparePanelPoster(panel) {
      const previewVideo = panel.querySelector('.yg-video-placeholder video[data-video-preview]');
      if (previewVideo) {
        return this.loadPosterVideoFrame(previewVideo).catch(() => undefined);
      }

      const poster = panel.querySelector('.yg-video-placeholder img');
      return poster ? this.loadPosterImage(poster, 'high') : Promise.resolve();
    }

    loadPosterVideoFrame(video) {
      if (video.classList.contains('is-loaded')) {
        return Promise.resolve();
      }

      const imageElement = video.closest('yg-image');
      const loadFrame = () => {
        imageElement?.applyResponsiveSrc?.();
        imageElement?.loadPreviewVideo?.(video);

        if (video.classList.contains('is-loaded')) {
          return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
          let timeoutId;
          const observer = new MutationObserver(() => {
            if (video.classList.contains('is-loaded')) handleLoad();
          });
          const cleanup = () => {
            video.removeEventListener('error', handleError);
            observer.disconnect();
            window.clearTimeout(timeoutId);
          };
          const handleLoad = () => {
            cleanup();
            requestAnimationFrame(() => requestAnimationFrame(resolve));
          };
          const handleError = () => {
            cleanup();
            reject(new Error('Video poster frame failed to load.'));
          };

          video.addEventListener('error', handleError, { once: true });
          observer.observe(video, { attributes: true, attributeFilter: ['class'] });
          timeoutId = window.setTimeout(handleError, 8000);
        });
      };

      if (typeof imageElement?.loadPreviewVideo === 'function') {
        return loadFrame();
      }

      return window.customElements.whenDefined('yg-image').then(loadFrame);
    }

    isImageReady(image) {
      return image.complete && image.naturalWidth > 0 && !image.hasAttribute('data-src');
    }

    loadPosterImage(image, priority = 'auto') {
      if (this.isImageReady(image)) return Promise.resolve();

      const isMobile = window.matchMedia?.('(max-width: 749px)').matches;
      const source = isMobile ? image.dataset.srcMobile || image.dataset.src : image.dataset.srcPc || image.dataset.src;

      image.loading = 'eager';
      image.fetchPriority = priority;

      if (source && image.hasAttribute('data-src')) {
        image.src = source;
        image.removeAttribute('data-src');
      }

      if (this.isImageReady(image)) {
        return image.decode?.().catch(() => undefined) || Promise.resolve();
      }

      return new Promise((resolve) => {
        let timeoutId;
        const finish = () => {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);
          window.clearTimeout(timeoutId);
          resolve();
        };

        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
        timeoutId = window.setTimeout(finish, 3000);
      });
    }

    syncState() {
      this.querySelectorAll('.tab-title').forEach((tab) => {
        const isActive = tab.classList.contains('is-active');
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.querySelectorAll('.yg-banner-tabs__panel').forEach((panel) => {
        const isActive = panel.classList.contains('is-active');
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.syncVideos();
    }

    syncVideos() {
      this.querySelectorAll('.yg-banner-tabs__panel').forEach((panel) => {
        const video = panel.querySelector('yg-video');
        if (!video) return;

        if (panel.classList.contains('is-active')) {
          video.classList.remove('is-media-ready');
          video.playVideo?.();
          this.revealVideoAfterFirstFrame(video);
        } else {
          video.classList.remove('is-media-ready');
          video.pauseVideo?.();
        }
      });
    }

    revealVideoAfterFirstFrame(videoBox) {
      const mediaContainer = videoBox.videoContainer;
      if (!mediaContainer) return;

      const htmlVideo = Array.from(mediaContainer.querySelectorAll('video')).find((video) => {
        return !videoBox.isResponsiveVideoHidden?.(video);
      });

      if (!htmlVideo) {
        const iframe = mediaContainer.querySelector('iframe');
        if (!iframe) return;

        const revealIframe = () => videoBox.classList.add('is-media-ready');
        iframe.addEventListener('load', revealIframe, { once: true });
        window.setTimeout(revealIframe, 1200);
        return;
      }

      const reveal = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => videoBox.classList.add('is-media-ready'));
        });
      };

      if (!htmlVideo.paused && htmlVideo.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        reveal();
        return;
      }

      htmlVideo.addEventListener('playing', reveal, { once: true });
    }
  }

  if (!window.customElements.get('yg-banner-tabs')) {
    window.customElements.define('yg-banner-tabs', YGBannerTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.ygGridSectionScrollInitialized) {
    window.ygGridSectionScrollInitialized = true;

    const scrollToGridTarget = (gridItem) => {
      const targetIndex = Number.parseInt(gridItem.dataset.scrollSectionIndex, 10);
      const sections = Array.from(document.querySelectorAll('#MainContent .shopify-section'));
      const targetSection = sections[targetIndex - 1];

      if (targetSection) {
        targetSection.style.scrollMarginTop = 'calc(var(--header-height, 0px) + 20px)';
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    document.addEventListener('click', (event) => {
      const gridItem = event.target.closest('.yg-grid-item[data-scroll-section-index]');

      if (gridItem) {
        scrollToGridTarget(gridItem);
      }
    });

    document.addEventListener('keydown', (event) => {
      const gridItem = event.target.closest('.yg-grid-item[data-scroll-section-index]');

      if (!gridItem || (event.key !== 'Enter' && event.key !== ' ')) {
        return;
      }

      event.preventDefault();
      scrollToGridTarget(gridItem);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-header"] && !Shopify.designMode) return;
  try {
    
  const YG_ANNOUNCEMENT_TRANSITION_FALLBACK = 450;
  let isYGAnnouncementTransitioning = false;

  class YGHeaderDropdownMegaMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.closest('details');
      this.triggerLabel = this.details?.querySelector(':scope > summary > span');
      this.list = this.querySelector('.yg-header-dropdown-mega-menu__list');
      this.handleToggle = this.handleToggle.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.details?.addEventListener('toggle', this.handleToggle);
      window.addEventListener('resize', this.handleResize);

      if (this.details?.open) this.requestAlignment();
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.handleToggle);
      window.removeEventListener('resize', this.handleResize);

      if (this.alignmentFrame) cancelAnimationFrame(this.alignmentFrame);
    }

    handleToggle() {
      if (this.details?.open) this.requestAlignment();
    }

    handleResize() {
      if (this.details?.open) this.requestAlignment();
    }

    requestAlignment() {
      if (this.alignmentFrame) cancelAnimationFrame(this.alignmentFrame);

      this.alignmentFrame = requestAnimationFrame(() => {
        this.alignmentFrame = null;
        this.alignWithTrigger();
      });
    }

    alignWithTrigger() {
      if (!this.triggerLabel || !this.list) return;

      const containerRect = this.getBoundingClientRect();
      const triggerRect = this.triggerLabel.getBoundingClientRect();
      const listRect = this.list.getBoundingClientRect();
      const maximumOffset = Math.max(0, containerRect.width - listRect.width);
      const triggerOffset = triggerRect.left - containerRect.left;
      const alignedOffset = Math.min(maximumOffset, Math.max(0, triggerOffset));

      this.style.setProperty('--yg-dropdown-menu-offset', `${alignedOffset}px`);
    }
  }

  if (!customElements.get('yg-header-dropdown-mega-menu')) {
    customElements.define('yg-header-dropdown-mega-menu', YGHeaderDropdownMegaMenu);
  }

  class YGHeaderOverlay extends HTMLElement {
    connectedCallback() {
      this.sectionHeader = this.closest('.section-header');
      this.headerWrapper = this.closest('.section-header')?.querySelector('.header-wrapper');
      this.detailsElements = Array.from(
        this.closest('.section-header')?.querySelectorAll(
          'header-menu > details, [data-yg-header-search] > details, header-drawer[data-yg-header-mobile-menu] > details'
        ) || []
      );
      this.desktopMenuElements = Array.from(
        this.closest('.section-header')?.querySelectorAll('header-menu') || []
      );
      this.summaryElements = this.detailsElements
        .map((details) => details.querySelector(':scope > summary'))
        .filter(Boolean);
      this.handleToggle = this.handleToggle.bind(this);
      this.handleSummaryClick = this.handleSummaryClick.bind(this);
      this.handleMenuMouseEnter = this.handleMenuMouseEnter.bind(this);
      this.handleMenuMouseLeave = this.handleMenuMouseLeave.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleDocumentReady = this.setupCartPopoverObserver.bind(this);
      this.panelResizeObserver = new ResizeObserver(() => this.updateState());
      this.detailsStateObserver = new MutationObserver(() => this.updateState());
      this.cartPopoverStateObserver = new MutationObserver(() => this.updateState());
      this.hoverCloseTimers = new Map();
      this.surfaceResetTimer = null;
      this.surfaceHeight = 0;
      this.headerHeight = this.headerWrapper?.offsetHeight || 0;
      this.isHomePage = document.body.classList.contains('template-index');
      this.isAboutPage = this.headerWrapper?.hasAttribute('data-yg-about-header') || false;
      this.announcementBar = document.querySelector('beni-announcement-bar');

      this.detailsElements.forEach((details) => details.addEventListener('toggle', this.handleToggle));
      this.detailsElements.forEach((details) => {
        this.detailsStateObserver.observe(details, {
          attributes: true,
          attributeFilter: ['class', 'open'],
        });
        details
          .querySelectorAll('.mega-menu__content, .yg-header-search__panel')
          .forEach((panel) => this.panelResizeObserver.observe(panel));
      });
      this.summaryElements.forEach((summary) => summary.addEventListener('click', this.handleSummaryClick, true));
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.handleDocumentReady, { once: true });
      } else {
        this.setupCartPopoverObserver();
      }
      this.desktopMenuElements.forEach((menu) => {
        menu.addEventListener('mouseenter', this.handleMenuMouseEnter);
        menu.addEventListener('mouseleave', this.handleMenuMouseLeave);
      });
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.updateState();
    }

    disconnectedCallback() {
      this.detailsElements?.forEach((details) => details.removeEventListener('toggle', this.handleToggle));
      this.summaryElements?.forEach((summary) => summary.removeEventListener('click', this.handleSummaryClick, true));
      this.desktopMenuElements?.forEach((menu) => {
        menu.removeEventListener('mouseenter', this.handleMenuMouseEnter);
        menu.removeEventListener('mouseleave', this.handleMenuMouseLeave);
      });
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('DOMContentLoaded', this.handleDocumentReady);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.hoverCloseTimers?.forEach((timer) => window.clearTimeout(timer));
      this.hoverCloseTimers?.clear();
      this.clearSurfaceReset();
      this.panelResizeObserver?.disconnect();
      this.detailsStateObserver?.disconnect();
      this.cartPopoverStateObserver?.disconnect();
    }

    setupCartPopoverObserver() {
      this.cartPopover = document.querySelector('beni-cart-popover');
      if (!this.cartPopover) return;

      this.cartPopoverStateObserver.observe(this.cartPopover, {
        attributes: true,
        attributeFilter: ['class'],
      });
      this.updateState();
    }

    handleToggle(event) {
      if (event.currentTarget.open) {
        this.detailsElements.forEach((details) => {
          if (details !== event.currentTarget && details.open) {
            this.closeDetails(details);
          }
        });
      } else {
        this.resetSearch(event.currentTarget);
      }

      requestAnimationFrame(() => this.updateState());
    }

    resetSearch(details) {
      details.querySelectorAll('predictive-search').forEach((predictiveSearch) => {
        predictiveSearch.querySelector('form')?.reset();
      });
    }

    handleSummaryClick(event) {
      const targetDetails = event.currentTarget.closest('details');
      const isPointerClick = event.detail > 0;

      if (isPointerClick && targetDetails?.closest('header-menu') && this.isHoverActivationEnabled()) {
        event.preventDefault();
        return;
      }

      this.detailsElements.forEach((details) => {
        if (details !== targetDetails && details.open) {
          this.closeDetails(details);
        }
      });

      if (!targetDetails?.open) {
        this.prepareDesktopMenuSurface(targetDetails);
        this.sectionHeader?.classList.add('shopify-section-header-sticky');
        this.sectionHeader?.classList.remove('shopify-section-header-hidden');
      }

      requestAnimationFrame(() => this.updateState());
    }

    handleMenuMouseEnter(event) {
      if (!this.isHoverActivationEnabled()) return;

      const targetDetails = event.currentTarget.querySelector(':scope > details');
      if (!targetDetails) return;

      this.cancelHoverClose(targetDetails);
      if (targetDetails.open) return;

      this.prepareDesktopMenuSurface(targetDetails);
      targetDetails.open = true;
      targetDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');

      this.detailsElements.forEach((details) => {
        if (details !== targetDetails && details.open) {
          this.closeDetails(details);
        }
      });

      this.sectionHeader?.classList.add('shopify-section-header-sticky');
      this.sectionHeader?.classList.remove('shopify-section-header-hidden');
    }

    handleMenuMouseLeave(event) {
      if (!this.isHoverActivationEnabled()) return;

      const targetDetails = event.currentTarget.querySelector(':scope > details');
      if (!targetDetails?.open) return;

      this.cancelHoverClose(targetDetails);
      const closeTimer = window.setTimeout(() => this.closeHoverMenu(targetDetails), 120);
      this.hoverCloseTimers.set(targetDetails, closeTimer);
    }

    cancelHoverClose(details) {
      const closeTimer = this.hoverCloseTimers.get(details);
      if (closeTimer) window.clearTimeout(closeTimer);

      this.hoverCloseTimers.delete(details);
      details.classList.remove('is-closing');
    }

    closeHoverMenu(details) {
      this.hoverCloseTimers.delete(details);
      if (!details.open) return;

      details.classList.add('is-closing');
      const closeTimer = window.setTimeout(() => this.closeDetails(details), 220);
      this.hoverCloseTimers.set(details, closeTimer);
    }

    isHoverActivationEnabled() {
      return (
        this.dataset.desktopMenuActivation === 'hover' &&
        window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches
      );
    }

    handleClick() {
      this.closeAll();
    }

    handleResize() {
      this.headerHeight = this.headerWrapper?.offsetHeight || 0;
      const openDesktopMenu = this.detailsElements.find((details) => {
        return details.open && details.closest('header-menu') && !details.classList.contains('is-closing');
      });

      if (openDesktopMenu) this.prepareDesktopMenuSurface(openDesktopMenu);
      if (this.hasAttribute('open')) this.updateState();
    }

    handleScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateFillState();
      });
    }

    closeAll() {
      this.detailsElements.forEach((details) => {
        if (!details.open) return;
        this.closeDetails(details);
      });
      this.updateState();
    }

    closeDetails(details) {
      this.cancelHoverClose(details);
      const owner = details.closest('header-menu, details-modal, header-drawer');

      if (owner?.matches('header-drawer') && owner.closeMenuDrawer) {
        details.classList.add('is-menu-closing');
        window.setTimeout(() => details.classList.remove('is-menu-closing'), 400);
        owner.closeMenuDrawer(new Event('click'), details.querySelector(':scope > summary'));
      } else if (owner?.close) {
        owner.close(false);
      } else {
        details.removeAttribute('open');
      }
    }

    clearSurfaceReset() {
      if (!this.surfaceResetTimer) return;

      window.clearTimeout(this.surfaceResetTimer);
      this.surfaceResetTimer = null;
    }

    prepareDesktopMenuSurface(details) {
      if (!details?.closest('header-menu') || !window.matchMedia('(min-width: 990px)').matches) return;

      const panel = details.querySelector(':scope > .mega-menu__content');
      const headerHeight = this.headerWrapper?.offsetHeight || 0;
      const panelHeight = panel?.offsetHeight || 0;
      if (!headerHeight || !panelHeight) return;

      const menuPanelHeights = this.desktopMenuElements.map((menu) => {
        return menu.querySelector(':scope > details > .mega-menu__content')?.offsetHeight || 0;
      });
      const canvasHeight = Math.ceil(headerHeight + Math.max(panelHeight, ...menuPanelHeights));
      const visibleHeight = Math.ceil(headerHeight + panelHeight);
      const visibleScale = Math.min(1, visibleHeight / canvasHeight);

      this.clearSurfaceReset();
      this.surfaceHeight = canvasHeight;
      this.headerWrapper.style.setProperty('--yg-header-surface-height', `${canvasHeight}px`);
      this.headerWrapper.style.setProperty('--yg-header-surface-canvas-height', `${canvasHeight}px`);
      this.headerWrapper.style.setProperty('--yg-header-surface-visible-height', `${visibleHeight}px`);
      this.headerWrapper.style.setProperty('--yg-header-surface-visible-scale', visibleScale.toFixed(5));
    }

    updateDesktopPanelState(openDetails) {
      const isDesktopPanel = Boolean(
        openDetails &&
          window.matchMedia('(min-width: 990px)').matches &&
          (openDetails.closest('header-menu') || openDetails.closest('[data-yg-header-search]'))
      );
      const isDesktopMenu = Boolean(isDesktopPanel && openDetails.closest('header-menu'));

      this.headerWrapper?.classList.toggle('is-desktop-panel-open', isDesktopPanel);
      this.headerWrapper?.classList.toggle('is-desktop-menu-open', isDesktopMenu);

    }

    updateSurfaceHeight(openDetails) {
      if (openDetails?.closest('header-menu')) {
        this.clearSurfaceReset();
        return;
      }

      const headerHeight = this.headerWrapper?.offsetHeight || 0;
      if (!this.headerWrapper || !headerHeight) return;

      if (openDetails) {
        const openPanel = openDetails.querySelector(
          ':scope > .mega-menu__content, :scope > .yg-header-search__panel, :scope > .menu-drawer'
        );
        const nextHeight = Math.ceil(headerHeight + (openPanel?.offsetHeight || 0));

        this.clearSurfaceReset();
        this.surfaceHeight = nextHeight;
        this.headerWrapper.style.setProperty('--yg-header-surface-height', `${nextHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-canvas-height', `${nextHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-visible-height', `${nextHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-visible-scale', '1');
        return;
      }

      if (!this.surfaceHeight) {
        this.surfaceHeight = headerHeight;
        this.headerWrapper.style.setProperty('--yg-header-surface-height', `${headerHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-canvas-height', `${headerHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-visible-height', `${headerHeight}px`);
        this.headerWrapper.style.setProperty('--yg-header-surface-visible-scale', '1');
        return;
      }

      if (this.surfaceResetTimer || this.surfaceHeight === headerHeight) return;

      this.surfaceResetTimer = window.setTimeout(() => {
        this.surfaceResetTimer = null;
        this.surfaceHeight = headerHeight;
        this.headerWrapper?.style.setProperty('--yg-header-surface-height', `${headerHeight}px`);
        this.headerWrapper?.style.setProperty('--yg-header-surface-canvas-height', `${headerHeight}px`);
        this.headerWrapper?.style.setProperty('--yg-header-surface-visible-height', `${headerHeight}px`);
        this.headerWrapper?.style.setProperty('--yg-header-surface-visible-scale', '1');
      }, 220);
    }

    getFillThreshold() {
      const isOnlyTop = this.sectionHeader?.classList.contains('shopify-header-only-top');
      const hasTransparentHeader =
        this.sectionHeader?.hasAttribute('allow-transparency') ||
        this.headerWrapper?.hasAttribute('allow-transparency');

      if (!isOnlyTop && !hasTransparentHeader) return 0;

      return this.headerHeight;
    }

    updateFillState(openDetails) {
      if (!this.announcementBar?.isConnected) {
        this.announcementBar = document.querySelector('beni-announcement-bar');
      }

      const activeDetails = openDetails || this.detailsElements.find((details) => {
        const isMobileDrawer = details.closest('header-drawer[data-yg-header-mobile-menu]');

        return details.open && (!isMobileDrawer || details.classList.contains('menu-opening'));
      });
      const isOnlyTop = this.sectionHeader?.classList.contains('shopify-header-only-top');
      const isHeaderHidden = this.sectionHeader?.classList.contains('shopify-section-header-hidden');
      const isHomeHeroHeaderActive = this.isHomeHeroHeaderActive();
      const isMobileCartPopoverOpen =
        window.matchMedia('(max-width: 989px)').matches && this.cartPopover?.classList.contains('active');
      const shouldFill =
        Boolean(activeDetails) ||
        isMobileCartPopoverOpen ||
        (!isHomeHeroHeaderActive && !isOnlyTop && !isHeaderHidden && window.scrollY > this.getFillThreshold());

      if (!isYGAnnouncementTransitioning) {
        this.headerWrapper?.classList.toggle('is-filled', shouldFill);
      }
    }

    isHomeHeroHeaderActive(scrollTop = window.scrollY) {
      if (this.isAboutPage) {
        return !this.sectionHeader?.classList.contains('yg-about-covered');
      }

      if (!this.isHomePage) return false;

      const announcementControlsHomeHero =
        this.announcementBar?.dataset.displayMode === 'hide_after_hero' &&
        !this.announcementBar.classList.contains('is-closed');

      return announcementControlsHomeHero
        ? this.announcementBar.isScrolledPastHero !== true
        : scrollTop <= window.innerHeight;
    }

    updateState() {
      const openDetails = this.detailsElements.find((details) => {
        const isMobileDrawer = details.closest('header-drawer[data-yg-header-mobile-menu]');
        const isDesktopMenuClosing = details.closest('header-menu') && details.classList.contains('is-closing');

        return details.open && !isDesktopMenuClosing && (!isMobileDrawer || details.classList.contains('menu-opening'));
      });
      const mobileDrawerDetails = this.detailsElements.find((details) => {
        return (
          details.open &&
          details.closest('header-drawer[data-yg-header-mobile-menu]') &&
          (details.classList.contains('menu-opening') || details.classList.contains('is-menu-closing'))
        );
      });
      const surfaceDetails = openDetails || mobileDrawerDetails;
      const isMobileDrawerOpen = Boolean(mobileDrawerDetails);
      const isMobileDrawerClosing = Boolean(mobileDrawerDetails?.classList.contains('is-menu-closing'));
      const overlayTop = this.headerWrapper?.getBoundingClientRect().bottom || 0;

      this.updateSurfaceHeight(surfaceDetails);
      this.updateDesktopPanelState(openDetails);
      this.updateFillState(openDetails);
      this.headerWrapper?.classList.toggle('is-mobile-drawer-open', isMobileDrawerOpen);
      this.headerWrapper?.classList.toggle('is-mobile-drawer-closing', isMobileDrawerClosing);
      this.style.setProperty('--yg-header-overlay-top', `${Math.max(0, overlayTop)}px`);
      this.toggleAttribute('open', Boolean(openDetails));
      this.setAttribute('aria-hidden', String(!openDetails));
      this.headerWrapper?.classList.toggle('is-disclosure-open', Boolean(openDetails));

    }
  }

  if (!customElements.get('yg-header-overlay')) {
    customElements.define('yg-header-overlay', YGHeaderOverlay);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerTransition = this.header.style.transition;
      this.hasProductHeaderTransitionOverride = document.body.classList.contains('template-product');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.hasProductHeaderTransitionOverride) {
        this.setProductHeaderTransition(true);
      }

      this.headerIsOnlyTop = this.getAttribute('data-sticky-type') === 'only_top';
      this.header.classList.toggle('shopify-header-only-top', this.headerIsOnlyTop);
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();
      requestAnimationFrame(this.setHeaderHeightHandler);

      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeightHandler);
      this.headerResizeObserver.observe(this.header);
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerMediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.lastDirectionScrollTop = Math.max(window.scrollY, 0);
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerDisclosureDetails = Array.from(
        this.querySelectorAll(
          'header-menu > details, [data-yg-header-search] > details, header-drawer[data-yg-header-mobile-menu] > details'
        )
      );
      this.announcementBar = document.querySelector('beni-announcement-bar');
      this.isHomePage = document.body.classList.contains('template-index');
      this.isAboutPage = this.hasAttribute('data-yg-about-header');
      this.announcementControlsHomeHero =
        this.isHomePage &&
        this.announcementBar?.dataset.displayMode === 'hide_after_hero';
      this.announcementHidden = this.announcementBar?.classList.contains('is-hidden') || false;
      this.announcementTransitionTimer = null;
      this.scrollFrame = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.setupTransparentHeaderHandler = this.setupTransparentHeader.bind(this);
      this.handleAnnouncementClassChange = this.handleAnnouncementClassChange.bind(this);
      this.handleAnnouncementTransitionEnd = this.handleAnnouncementTransitionEnd.bind(this);
      this.handleAboutStateChange = this.handleAboutStateChange.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.setupTransparentHeader();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparentHeaderHandler);
        document.addEventListener('shopify:section:unload', this.setupTransparentHeaderHandler);
        document.addEventListener('shopify:section:reorder', this.setupTransparentHeaderHandler);
      }

      this.observeAnnouncementBar();
      this.observeAboutState();
      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header?.getBoundingClientRect().height || 0;

      if (!Number.isFinite(headerHeight) || headerHeight <= 0) return;

      const nextHeaderHeight = `${headerHeight}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') === nextHeaderHeight) return;

      document.documentElement.style.setProperty('--header-height', nextHeaderHeight);
    }

    disconnectedCallback() {
      if (this.hasProductHeaderTransitionOverride) {
        this.header.style.transition = this.headerTransition;
      }

      this.header?.classList.remove('shopify-header-only-top');
      document.documentElement.classList.remove('scroll-down', 'scroll-up');
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('shopify:section:load', this.setupTransparentHeaderHandler);
      document.removeEventListener('shopify:section:unload', this.setupTransparentHeaderHandler);
      document.removeEventListener('shopify:section:reorder', this.setupTransparentHeaderHandler);
      this.announcementObserver?.disconnect();
      this.aboutStateObserver?.disconnect();
      this.headerResizeObserver?.disconnect();
      this.headerMediaQuery?.removeEventListener('change', this.setHeaderHeightHandler);
      this.announcementBar?.removeEventListener('transitionend', this.handleAnnouncementTransitionEnd);
      window.clearTimeout(this.announcementTransitionTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      isYGAnnouncementTransitioning = false;
    }

    observeAnnouncementBar() {
      if (!this.announcementBar || typeof MutationObserver === 'undefined') return;

      this.announcementObserver = new MutationObserver(this.handleAnnouncementClassChange);
      this.announcementObserver.observe(this.announcementBar, {
        attributes: true,
        attributeFilter: ['class'],
      });
      this.announcementBar.addEventListener('transitionend', this.handleAnnouncementTransitionEnd);
    }

    observeAboutState() {
      if (!this.isAboutPage || typeof MutationObserver === 'undefined') return;

      this.aboutStateObserver = new MutationObserver(this.handleAboutStateChange);
      this.aboutStateObserver.observe(this.header, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    handleAboutStateChange() {
      this.onScroll();
      document.querySelector('yg-header-overlay')?.updateState();
    }

    handleAnnouncementClassChange() {
      const isHidden = this.announcementBar?.classList.contains('is-hidden') || false;
      if (isHidden === this.announcementHidden) return;

      this.announcementHidden = isHidden;
      isYGAnnouncementTransitioning = true;

      if (this.isHomeHeroHeaderActive()) {
        this.resetHomeHeroHeader();
      } else if (
        (this.isAboutPage || this.announcementControlsHomeHero || isHidden) &&
        window.scrollY > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');
        this.hide();
      }

      this.syncScrollPosition();
      window.clearTimeout(this.announcementTransitionTimer);

      this.announcementTransitionTimer = window.setTimeout(
        () => this.finishAnnouncementTransition(),
        YG_ANNOUNCEMENT_TRANSITION_FALLBACK
      );
    }

    handleAnnouncementTransitionEnd(event) {
      if (event.target !== this.announcementBar || event.propertyName !== 'max-height') return;
      requestAnimationFrame(() => this.finishAnnouncementTransition());
    }

    finishAnnouncementTransition() {
      if (!isYGAnnouncementTransitioning) return;

      isYGAnnouncementTransitioning = false;
      window.clearTimeout(this.announcementTransitionTimer);
      this.announcementTransitionTimer = null;
      this.syncScrollPosition();

      if (!this.header.classList.contains('shopify-section-header-hidden')) {
        document.querySelector('yg-header-overlay')?.updateState();
      }
    }

    syncScrollPosition() {
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      this.currentScrollTop = scrollTop;
      this.lastDirectionScrollTop = scrollTop;
    }

    isHomeHeroHeaderActive(scrollTop = window.scrollY) {
      if (this.isAboutPage) {
        return !this.header.classList.contains('yg-about-covered');
      }

      if (!this.isHomePage) return false;

      const announcementControlsHomeHero =
        this.announcementControlsHomeHero && !this.announcementBar?.classList.contains('is-closed');

      return announcementControlsHomeHero
        ? this.announcementBar.isScrolledPastHero !== true
        : scrollTop <= window.innerHeight;
    }

    isMobileCartPopoverOpen() {
      return (
        window.matchMedia('(max-width: 989px)').matches &&
        document.querySelector('beni-cart-popover')?.classList.contains('active')
      );
    }

    resetHomeHeroHeader() {
      if (this.isMobileCartPopoverOpen()) return;

      const hasScrolledState =
        this.classList.contains('is-filled') ||
        this.header.classList.contains('scrolled-past-header') ||
        this.header.classList.contains('shopify-section-header-hidden') ||
        (!this.headerIsAlwaysSticky && this.header.classList.contains('shopify-section-header-sticky')) ||
        this.header.classList.contains('animate');

      if (!hasScrolledState) return;

      this.classList.remove('is-filled');
      this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'animate');

      if (!this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
    }

    setupTransparentHeader() {
      const firstSectionAllowsTransparency = document.querySelector(
        'main .shopify-section:first-child [allow-transparent-header]'
      );

      this.toggleAttribute('allow-transparency', this.isAboutPage || Boolean(firstSectionAllowsTransparency));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateScrollState();
      });
    }

    updateScrollState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (isYGAnnouncementTransitioning) {
        if (this.isHomeHeroHeaderActive(scrollTop)) {
          this.resetHomeHeroHeader();
        } else if (
          (this.announcementControlsHomeHero || this.announcementHidden) &&
          scrollTop > this.headerBounds.bottom
        ) {
          this.header.classList.add('scrolled-past-header');
          this.hide();
        }

        this.currentScrollTop = scrollTop;
        this.lastDirectionScrollTop = Math.max(scrollTop, 0);
        return;
      }

      this.updateScrollDirection(scrollTop);
      const hasOpenHeaderDisclosure =
        this.headerDisclosureDetails.some((details) => details.open) || this.isMobileCartPopoverOpen();

      if (this.isHomeHeroHeaderActive(scrollTop)) {
        if (!hasOpenHeaderDisclosure) {
          this.resetHomeHeroHeader();
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.isAboutPage) {
        if (!hasOpenHeaderDisclosure) {
          this.header.classList.add('scrolled-past-header');
          this.hide();
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.headerIsOnlyTop) {
        if (!hasOpenHeaderDisclosure) {
          this.classList.remove('is-filled');
        }

        if (scrollTop > 0) {
          this.header.classList.add('scrolled-past-header');
          this.hide();
        } else {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (hasOpenHeaderDisclosure || (this.predictiveSearch && this.predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    updateScrollDirection(scrollTop) {
      const normalizedScrollTop = Math.max(scrollTop, 0);
      const scrollDelta = normalizedScrollTop - this.lastDirectionScrollTop;
      if (Math.abs(scrollDelta) < 2) return;

      const isScrollingDown = scrollDelta > 0;
      document.documentElement.classList.toggle('scroll-down', isScrollingDown);
      document.documentElement.classList.toggle('scroll-up', !isScrollingDown);
      this.lastDirectionScrollTop = normalizedScrollTop;
    }

    hide() {
      if (
        this.headerIsAlwaysSticky ||
        this.header.classList.contains('shopify-section-header-hidden') ||
        this.isMobileCartPopoverOpen()
      ) {
        return;
      }

      this.setProductHeaderTransition(false);
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.hasAttribute('allow-transparency')) this.classList.remove('is-filled');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || isYGAnnouncementTransitioning) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;

      this.setProductHeaderTransition(true);
      if (this.hasAttribute('allow-transparency') && window.scrollY > this.headerBounds.bottom) {
        this.classList.add('is-filled');
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (
        !this.header.classList.contains('shopify-section-header-hidden') &&
        !this.header.classList.contains('shopify-section-header-sticky') &&
        !this.header.classList.contains('animate')
      ) {
        return;
      }

      this.setProductHeaderTransition(true);
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    setProductHeaderTransition(isRevealing) {
      if (!this.hasProductHeaderTransitionOverride) return;

      if (this.prefersReducedMotion) {
        this.header.style.transition = 'none';
        return;
      }

      this.header.style.transition = isRevealing
        ? 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)'
        : 'transform 0.3s cubic-bezier(0.4, 0, 1, 1)';
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-banner"] && !Shopify.designMode) return;
  try {
    
  class YGCountdown extends HTMLElement {
    constructor() {
      super();
      this.targetDate = null;
      this.prefixText = '';
      this.intervalId = null;
    }

    connectedCallback() {
      this.targetDate = this.dataset.targetDate || '';
      this.prefixText = this.dataset.prefix || '';

      if (this.targetDate) {
        this.startCountdown();
      } else {
        this.innerHTML = this.prefixText ? `<span class="yg-countdown__prefix">${this.prefixText}</span>` : '';
      }
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }

    startCountdown() {
      const update = () => {
        const now = new Date().getTime();
        let target;

        const dateStr = this.targetDate.trim();
        const dateParts = dateStr.split(/[\sT]+/);
        if (dateParts.length >= 2) {
          const datePart = dateParts[0].split('-');
          const timePart = dateParts[1].split(':');
          target = new Date(
            parseInt(datePart[0]),
            parseInt(datePart[1]) - 1,
            parseInt(datePart[2]),
            parseInt(timePart[0]) || 0,
            parseInt(timePart[1]) || 0,
            parseInt(timePart[2]) || 0
          ).getTime();
        } else {
          target = new Date(dateStr).getTime();
        }

        const distance = target - now;
        if (distance <= 0) {
          this.innerHTML = '';
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          return;
        }

        this.renderCountdown(distance);
      };

      update();
      this.intervalId = setInterval(update, 1000);
    }

    renderCountdown(distance) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let html = this.prefixText ? `<span class="yg-countdown__prefix">${this.prefixText}</span>` : '';
      if (days > 0) {
        html += `<span class="yg-countdown__segment"><span class="yg-countdown__value">${this.pad(
          days
        )}</span><span class="yg-countdown__unit">d</span></span>`;
        html += `<span class="yg-countdown__separator">:</span>`;
      }

      html += `<span class="yg-countdown__segment"><span class="yg-countdown__value">${this.pad(
        hours
      )}</span><span class="yg-countdown__unit">h</span></span>`;
        html += `<span class="yg-countdown__separator">:</span>`;
      html += `<span class="yg-countdown__segment"><span class="yg-countdown__value">${this.pad(
        minutes
      )}</span><span class="yg-countdown__unit">m</span></span>`;
        html += `<span class="yg-countdown__separator">:</span>`;
      html += `<span class="yg-countdown__segment"><span class="yg-countdown__value">${this.pad(
        seconds
      )}</span><span class="yg-countdown__unit">s</span></span>`;
      this.innerHTML = html;
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-countdown')) {
      window.customElements.define('yg-countdown', YGCountdown);
    }

    // const headerDrawerDetails = document.getElementById('Details-menu-drawer-container');

    // if (headerDrawerDetails) {
    //   const updateHeaderDrawerState = () => {
    //     document.body.classList.toggle(
    //       'yg-header-drawer-open',
    //       headerDrawerDetails.open || headerDrawerDetails.classList.contains('menu-opening')
    //     );
    //   };

    //   const headerDrawerObserver = new MutationObserver(updateHeaderDrawerState);

    //   headerDrawerObserver.observe(headerDrawerDetails, {
    //     attributes: true,
    //     attributeFilter: ['open', 'class'],
    //   });

      // updateHeaderDrawerState();
  //  }

    const reserveForms = document.querySelectorAll('.yg-image-banner__reserve-form');
    reserveForms.forEach(form => {
      const btn = form.querySelector('.yg-image-banner__reserve-button');
      const section = form.closest('.shopify-section');
      const banner = form.closest('.yg-image-banner');
      const emailInput = form.querySelector('.yg-image-banner__email');
      const state = form.querySelector('[data-yg-image-banner-reserve-state]');
      const returnToInput = form.querySelector('input[name="return_to"]');
      const storageKey = `ygImageBannerReserveRedirect:${form.id || 'default'}`;
      let isSubmitting = false;
      const getRedirectUrl = () => {
        const redirectUrl = state?.dataset.redirectUrl || returnToInput?.value || '';
        if (!redirectUrl) return null;

        try {
          return new URL(redirectUrl, window.location.origin);
        } catch (error) {
          return null;
        }
      };

      const redirectToFormPage = () => {
        const targetUrl = getRedirectUrl();
        if (!targetUrl || targetUrl.href === window.location.href) return;

        try {
          sessionStorage.removeItem(storageKey);
        } catch (error) {
        }

        window.location.replace(targetUrl.href);
      };
      const hasShopifySuccessParam = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';
      };

      const resetBannerStyles = () => {
        banner?.style.removeProperty('transform');
        banner?.style.removeProperty('opacity');
        banner?.style.removeProperty('-webkit-clip-path');
        banner?.style.removeProperty('clip-path');
        banner?.style.removeProperty('filter');
        banner?.style.removeProperty('pointer-events');
        banner?.style.removeProperty('visibility');
        banner?.style.removeProperty('--yg-banner-radius');
        banner?.querySelector('.yg-image-banner__price-bar')?.style.setProperty('--yg-price-bar-shift', '0%');
      };

      const pauseBannerInteraction = () => {
        section?.classList.add('is-reserve-focused');
        banner?.classList.add('is-reserve-focused');
        resetBannerStyles();
      };

      const resumeBannerInteraction = () => {
        if (isSubmitting) return;
        section?.classList.remove('is-reserve-focused');
        banner?.classList.remove('is-reserve-focused');
      };

      emailInput?.addEventListener('blur', resumeBannerInteraction);

      let storedRedirectUrl = '';
      try {
        storedRedirectUrl = sessionStorage.getItem(storageKey) || '';
      } catch (error) {
        storedRedirectUrl = '';
      }

      if (storedRedirectUrl && state && !state.dataset.redirectUrl) {
        state.dataset.redirectUrl = storedRedirectUrl;
      }

      if (state?.dataset.postedSuccessfully === 'true' || (storedRedirectUrl && hasShopifySuccessParam())) {
        pauseBannerInteraction();
        btn?.classList.remove('is-loading');
        redirectToFormPage();
      }

      if (!btn) return;
      form.addEventListener('invalid', () => {
        isSubmitting = false;
        btn.classList.remove('is-loading');
        resumeBannerInteraction();
      }, true);
      form.addEventListener('submit', async (event) => {
        if (!form.checkValidity()) {
          isSubmitting = false;
          btn.classList.remove('is-loading');
          resumeBannerInteraction();
          return;
        }

        const targetUrl = getRedirectUrl();
        if (!targetUrl) return;

        event.preventDefault();

        isSubmitting = true;
        pauseBannerInteraction();
        btn.classList.add('is-loading');

        if (returnToInput) {
          returnToInput.value = targetUrl.href;
        }

        try {
          sessionStorage.setItem(storageKey, targetUrl.href);
        } catch (error) {
        }

        try {
          const response = await fetch(form.action, {
            method: form.method || 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html',
          },
          });
          const responseUrl = new URL(response.url || window.location.href, window.location.origin);
          const postedSuccessfully =
            responseUrl.searchParams.get('customer_posted') === 'true' ||
            responseUrl.searchParams.get('contact_posted') === 'true' ||
            response.redirected;

          if (response.ok && postedSuccessfully) {
            window.location.assign(targetUrl.href);
            return;
          }
        } catch (error) {
        }

        HTMLFormElement.prototype.submit.call(form);
      });
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
          btn.classList.remove('is-loading');
        }
      });
    });
  });

  class YgPriceBarReveal extends HTMLElement {
    connectedCallback() {
      this.banner = document.querySelector(this.dataset.bannerSelector);
      this.section = document.querySelector(this.dataset.sectionSelector) || this.closest('.shopify-section');
      this.priceBar = this.banner?.querySelector('.yg-image-banner__price-bar') || null;
      this.reserveState = this.banner?.querySelector('[data-yg-image-banner-reserve-state]') || null;

      if (!this.section || !this.priceBar) return;
      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      requestAnimationFrame(this.update);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.priceBar) {
        this.priceBar.style.removeProperty('--yg-price-bar-shift');
      }
    }

    onScroll() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.update);
    }

    update() {
      if (!this.section || !this.priceBar) return;
      if (
        this.section.classList.contains('is-reserve-focused') ||
        this.reserveState?.dataset.postedSuccessfully === 'true'
      ) {
        this.priceBar.style.setProperty('--yg-price-bar-shift', '0%');
        return;
      }

      const vh = window.innerHeight;
      const sectionRect = this.section.getBoundingClientRect();
      const runway = Math.max(this.section.offsetHeight - vh, 1);
      const progress = Math.min(Math.max(-sectionRect.top / runway, 0), 1);
      const revealProgress = Math.min(progress / 0.45, 1);
      const eased = revealProgress * revealProgress * (3 - 2 * revealProgress);
      this.priceBar.style.setProperty('--yg-price-bar-shift', `${(1 - eased) * 110}%`);
    }
  }

  if (!customElements.get('yg-price-bar-reveal')) {
    customElements.define('yg-price-bar-reveal', YgPriceBarReveal);
  }

  class YgAttention extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      this.banner = this.previousElementSibling;
      this.lens = this.querySelector('.yg-attention__media');
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.priceBar = this.banner ? this.banner.querySelector('.yg-image-banner__price-bar') : null;
      this.reserveState = this.banner?.querySelector('[data-yg-image-banner-reserve-state]') || null;

      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onScrollIntent = this.onScrollIntent.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      window.addEventListener('wheel', this.onScrollIntent, { passive: false });
      window.addEventListener('touchstart', this.onTouchStart, { passive: true });
      window.addEventListener('touchmove', this.onScrollIntent, { passive: false });

      this.hasExited = false;
      this.reportedHidden = false;
      this.lastScrollY = window.scrollY;
      this.touchY = null;
      this.stageLockUntil = 0;
      this.releaseScrollUntil = 0;

      // 滚动意图计数器
      this.scrollIntentCount = 0;
      this.lastScrollDirection = null;
      this.clearIntentTimeout = null;

      requestAnimationFrame(this.update);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('wheel', this.onScrollIntent);
      window.removeEventListener('touchstart', this.onTouchStart);
      window.removeEventListener('touchmove', this.onScrollIntent);
      clearTimeout(this.bannerVisibilityTimeout);
      if (this.banner) {
        this.banner.style.transform = '';
        this.banner.style.opacity = '';
        this.banner.style.webkitClipPath = '';
        this.banner.style.clipPath = '';
        this.banner.style.pointerEvents = '';
        this.banner.style.visibility = '';
        this.banner.style.removeProperty('--yg-banner-radius');
      }
      if (this.priceBar) {
        this.priceBar.style.removeProperty('--yg-price-bar-shift');
      }
    }

    onScroll() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.update);
    }

    getMetrics() {
      const vh = window.innerHeight || document.documentElement.clientHeight || 1;
      const sectionRect = this.section.getBoundingClientRect();
      const runway = Math.max(this.section.offsetHeight - vh, 1);
      const progress = Math.min(Math.max(-sectionRect.top / runway, 0), 1);
      const sectionTop = window.scrollY + sectionRect.top;
      return { progress, runway, sectionTop, sectionRect };
    }

    onTouchStart(event) {
      this.touchY = event.touches?.[0]?.clientY ?? null;
    }

    dispatchVisibility(hidden) {
      if (this.reportedHidden === hidden) return;
      this.reportedHidden = hidden;
      window.dispatchEvent(
        new CustomEvent('yg:image-banner-visibility', {
          detail: {
            sectionId: this.dataset.sectionId,
            hidden,
          },
        })
      );
    }

    syncBannerAnimationVisibility(shouldExit) {
      this.dispatchVisibility(shouldExit);
    }

    syncBannerDisplayState(shouldExit) {
      clearTimeout(this.bannerVisibilityTimeout);

      if (!shouldExit) {
        this.banner.style.visibility = '';
        return;
      }

      if (this.reduceMotion) {
        this.banner.style.visibility = 'hidden';
        return;
      }

      this.bannerVisibilityTimeout = setTimeout(() => {
        if (this.hasExited && this.banner) {
          this.banner.style.visibility = 'hidden';
        }
      }, 820);
    }

    onScrollIntent(event) {
      if (!this.section) return;

      let delta = 0;
      if (event.type === 'wheel') {
        delta = event.deltaY;
      } else if (event.type === 'touchmove' && this.touchY !== null) {
        const nextY = event.touches?.[0]?.clientY ?? this.touchY;
        delta = this.touchY - nextY;
        this.touchY = nextY;
      }

      const PRICE_BAR_PROGRESS = 0.15;
      const EXIT_PROGRESS = 0.34;
      const { progress, runway, sectionTop, sectionRect } = this.getMetrics();
      const inActiveSection = sectionRect.top <= 2 && sectionRect.bottom > window.innerHeight;
      if (!inActiveSection) return;
      if (Date.now() < this.releaseScrollUntil) return;

      // After the banner has collapsed into the attention image, one downward intent should
      // release the sticky section. Guard the handoff so Mac trackpad momentum cannot retrigger it.
      if (delta > 0 && this.hasExited) {
        if (event.cancelable) event.preventDefault();
        this.scrollIntentCount = 0;
        this.lastScrollDirection = 'down';
        this.releaseScrollUntil = Date.now() + 700;
        window.scrollTo({
          top: sectionTop + runway + 1,
          behavior: 'smooth',
        });
        return;
      }

      const isPriceBarFullyVisible = progress >= PRICE_BAR_PROGRESS - 0.02 && progress < EXIT_PROGRESS - 0.01;
      if (delta > 0 && isPriceBarFullyVisible && !this.hasExited) {
        if (event.cancelable) event.preventDefault();
        this.hasExited = true;
        this.scrollIntentCount = 0;
        this.stageLockUntil = Date.now() + 180;
        requestAnimationFrame(this.update);
        window.scrollTo({
          top: sectionTop + runway * EXIT_PROGRESS,
          behavior: 'smooth',
        });
        return;
      }

      if (Date.now() < this.stageLockUntil) {
        if (event.cancelable) event.preventDefault();
        return;
      }

      if (Math.abs(delta) < 3) return;

      const currentDirection = delta > 0 ? 'down' : 'up';

      // 方向改变时，立即重置计数
      if (this.lastScrollDirection !== currentDirection) {
        this.scrollIntentCount = 0;
        this.lastScrollDirection = currentDirection;
      }

      this.scrollIntentCount++;

      clearTimeout(this.clearIntentTimeout);
      this.clearIntentTimeout = setTimeout(() => {
        this.scrollIntentCount = 0;
      }, 300);

      // 【核心逻辑改动】：
      // 如果当前满足向下滚动，且 price-bar 已经完全展示出来（进度接近或达到 0.15），
      // 目标所需意图次数设定为 1。也就是说不需要滚两下，滚一下直接触发下一个退出动画！
      // 其他状态（初始下滑、或者返回上滑）保持 2 下以保证过渡界限清晰。
      const requiredIntents = (currentDirection === 'down' && isPriceBarFullyVisible) ? 1 : 2;

      if (this.scrollIntentCount < requiredIntents) {
        if (event.cancelable) event.preventDefault();
        return;
      }

      // 意图达成，重置计数并触发滚动
      this.scrollIntentCount = 0;

      if (delta < 0) {
        // 向上滚动返回逻辑
        if (this.hasExited && progress > PRICE_BAR_PROGRESS + 0.01) {
          if (event.cancelable) event.preventDefault();
          this.stageLockUntil = Date.now() + 220;
          window.scrollTo({
            top: sectionTop + runway * PRICE_BAR_PROGRESS,
            behavior: 'smooth',
          });
        }
        return;
      }

      // 向下执行动画目标计算
      let targetProgress = null;
      if (progress < PRICE_BAR_PROGRESS - 0.01) {
        targetProgress = PRICE_BAR_PROGRESS;
      } else if (progress < EXIT_PROGRESS - 0.01) {
        targetProgress = EXIT_PROGRESS;
      }

      if (targetProgress === null) return;

      if (event.cancelable) event.preventDefault();
      this.stageLockUntil = Date.now() + 220; // 降低阶段锁定等待，提升后续滚动的连贯响应
      window.scrollTo({
        top: sectionTop + runway * targetProgress,
        behavior: 'smooth',
      });
    }

    update() {
      if (!this.banner || !this.section) return;
      if (
        this.section.classList.contains('is-reserve-focused') ||
        this.reserveState?.dataset.postedSuccessfully === 'true'
      ) {
        clearTimeout(this.bannerVisibilityTimeout);
        this.banner.style.transform = '';
        this.banner.style.opacity = '';
        this.banner.style.webkitClipPath = '';
        this.banner.style.clipPath = '';
        this.banner.style.pointerEvents = '';
        this.banner.style.visibility = '';
        this.banner.style.removeProperty('--yg-banner-radius');
        if (this.priceBar) {
          this.priceBar.style.setProperty('--yg-price-bar-shift', '0%');
        }
        this.dispatchVisibility(false);
        return;
      }

      const vh = window.innerHeight;
      const vw = window.innerWidth;
      const isTabletViewport = vw >= 750 && vw <= 1025;
      const sectionRect = this.section.getBoundingClientRect();
      const runway = Math.max(this.section.offsetHeight - vh, 1);
      const progress = Math.min(Math.max(-sectionRect.top / runway, 0), 1);
      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - this.lastScrollY;
      const isScrollingDown = scrollDelta > 1;
      const isScrollingUp = scrollDelta < -1;
      const PHASE1 = 0.15;
      const EXIT_TRIGGER = 0.34;
      const ENTER_BACK_TRIGGER = 0.24;

      const p1 = Math.min(progress / PHASE1, 1);
      if (this.priceBar) {
        const p1Eased = p1 * p1 * (3 - 2 * p1);
        this.priceBar.style.setProperty('--yg-price-bar-shift', `${(1 - p1Eased) * 110}%`);
      }

      if (!this.hasExited && isScrollingDown && progress >= EXIT_TRIGGER) {
        this.hasExited = true;
      } else if (this.hasExited && isScrollingUp && progress <= ENTER_BACK_TRIGGER) {
        this.hasExited = false;
      }
      const shouldExit = this.hasExited;
      this.lastScrollY = currentScrollY;
      if (this.reduceMotion) {
        this.banner.style.transform = shouldExit ? 'scale(0)' : '';
        this.banner.style.webkitClipPath = '';
        this.banner.style.clipPath = '';
        this.banner.style.pointerEvents = shouldExit ? 'none' : '';
        this.banner.style.setProperty('--yg-banner-radius', shouldExit ? '96px' : '0px');
        this.syncBannerDisplayState(shouldExit);
        this.syncBannerAnimationVisibility(shouldExit);
        return;
      }

      const radius = shouldExit ? (isTabletViewport ? 64 : 96) : 0;
      this.banner.style.transform = shouldExit ? 'scale(0)' : '';
      this.banner.style.webkitClipPath = '';
      this.banner.style.clipPath = '';
      this.banner.style.pointerEvents = shouldExit ? 'none' : '';
      this.banner.style.setProperty('--yg-banner-radius', `${radius}px`);
      this.syncBannerDisplayState(shouldExit);
      this.syncBannerAnimationVisibility(shouldExit);
    }
  }

  if (!customElements.get('yg-attention')) {
    customElements.define('yg-attention', YgAttention);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-swiper-tab"] && !Shopify.designMode) return;
  try {
    
  class YGImageSwiperTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabTitle = this.querySelector('yg-tabs-title');
      this.tabShell = this.querySelector('.yg-image-swiper-tab__tabs-shell');
      this.previousTabButton = this.querySelector('.yg-image-swiper-tab__tab-arrow--prev');
      this.nextTabButton = this.querySelector('.yg-image-swiper-tab__tab-arrow--next');
      this.swiper = null;
      this.hasLoopBuffer = false;
      this.restoreLoadedImageStates(this);
      this.handleTabClick = (event) => this.activateTabSlide(event);
      this.handleResize = () => {
        this.updateTabArrows();
        this.swiper?.update();
      };
      this.handlePreviousTab = () => this.activateRelativeTab(-1);
      this.handleNextTab = () => this.activateRelativeTab(1);
      this.tabTitle?.addEventListener('click', this.handleTabClick);
      this.previousTabButton?.addEventListener('click', this.handlePreviousTab);
      this.nextTabButton?.addEventListener('click', this.handleNextTab);
      window.addEventListener('resize', this.handleResize);

      if (typeof ResizeObserver !== 'undefined' && this.tabTitle) {
        this.tabResizeObserver = new ResizeObserver(() => this.updateTabArrows());
        this.tabResizeObserver.observe(this.tabTitle);
      }

      this.updateTabArrows();
      this.loadSwiper().then(() => this.initializeSwiper()).catch(() => undefined);
    }

    disconnectedCallback() {
      this.tabTitle?.removeEventListener('click', this.handleTabClick);
      this.previousTabButton?.removeEventListener('click', this.handlePreviousTab);
      this.nextTabButton?.removeEventListener('click', this.handleNextTab);
      window.removeEventListener('resize', this.handleResize);
      this.tabResizeObserver?.disconnect();
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.initialized = false;
    }

    loadSwiper() {
      if (window.Swiper) return Promise.resolve();
      if (window.loadMondoSwiper) return window.loadMondoSwiper();
      return Promise.reject(new Error('Swiper is unavailable'));
    }

    initializeSwiper() {
      const panel = this.querySelector('.yg-image-swiper-tab__panel');
      const swiperElement = panel?.querySelector('.yg-image-swiper-tab__swiper');
      if (!swiperElement || swiperElement.swiper) return;
      const slideCount = Number(swiperElement.dataset.slideCount || 0);
      const previousButton = panel.querySelector('.yg-image-swiper-tab__swiper-arrow--prev');
      const nextButton = panel.querySelector('.yg-image-swiper-tab__swiper-arrow--next');
      this.hasLoopBuffer = slideCount > 2;
      if (this.hasLoopBuffer) this.createLoopBuffer(swiperElement, slideCount);
      const updateSlideState = (swiper) => {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const logicalIndex = Number(activeSlide?.dataset.logicalSlideIndex || 1) - 1;
        this.setActiveTab(logicalIndex);
        this.updateDescription(panel, logicalIndex);
        this.scheduleImageStateRestore(panel);
      };
      this.swiper = new window.Swiper(swiperElement, {
        initialSlide: this.hasLoopBuffer ? 1 : 0,
        slidesPerView: 'auto',
        centeredSlides: true,
        centerInsufficientSlides: true,
        spaceBetween: 12,
        speed: 500,
        loop: false,
        rewind: slideCount > 1 && slideCount <= 2,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: previousButton,
          nextEl: nextButton
        },
        on: {
          init: updateSlideState,
          slideChange: updateSlideState,
          transitionEnd: (swiper) => {
            this.normalizeLoopBuffer(swiper, slideCount);
            updateSlideState(swiper);
          }
        }
      });
      if (Number.isInteger(this.pendingSlideIndex)) {
        this.slideToLogicalIndex(this.pendingSlideIndex);
        this.pendingSlideIndex = null;
      }
    }

    createLoopBuffer(swiperElement, slideCount) {
      const wrapper = swiperElement.querySelector('.swiper-wrapper');
      if (!wrapper || wrapper.dataset.ygLoopBuffer === 'true') return;
      const slides = Array.from(wrapper.children).slice(0, slideCount);
      if (slides.length !== slideCount) return;

      const cloneSlide = (slide) => {
        const clone = slide.cloneNode(true);
        clone.dataset.ygLoopClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('[id], [data-shopify-editor-block]')].forEach((element) => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      };

      wrapper.prepend(cloneSlide(slides[slideCount - 1]));
      wrapper.append(cloneSlide(slides[0]));
      wrapper.dataset.ygLoopBuffer = 'true';
    }

    normalizeLoopBuffer(swiper, slideCount) {
      if (!this.hasLoopBuffer) return;
      if (swiper.activeIndex === 0) {
        swiper.slideTo(slideCount, 0, false, true);
      } else if (swiper.activeIndex === slideCount + 1) {
        swiper.slideTo(1, 0, false, true);
      }
    }

    scheduleImageStateRestore(scope) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.restoreLoadedImageStates(scope));
      });
    }

    restoreLoadedImageStates(scope) {
      scope.querySelectorAll('yg-image').forEach((imageBox) => {
        const images = Array.from(imageBox.querySelectorAll('img'));
        if (!images.length) return;

        const isEveryImageLoaded = images.every((image) => {
          const hasDeferredSource = image.hasAttribute('data-src');
          const isLoaded = image.classList.contains('is-loaded') || (!hasDeferredSource && image.complete && image.naturalWidth > 0);

          if (isLoaded) {
            image.classList.add('is-loaded');
            image.classList.remove('is-error');
          }

          return isLoaded;
        });

        if (!isEveryImageLoaded) return;

        imageBox.classList.remove('is-loading', 'is-error');
        imageBox.classList.add('is-loaded');
      });
    }

    updateDescription(panel, activeIndex) {
      panel.querySelectorAll('[data-swiper-description-index]').forEach((description, index) => {
        description.classList.toggle('is-active', index === activeIndex);
      });
    }

    activateTabSlide(event) {
      const tab = event.target.closest('[data-slide-index]');
      if (!tab || !this.tabTitle?.contains(tab)) return;
      const targetIndex = Number(tab.dataset.slideIndex);
      if (!Number.isInteger(targetIndex)) return;
      this.setActiveTab(targetIndex);
      if (!this.swiper) {
        this.pendingSlideIndex = targetIndex;
        return;
      }
      this.slideToLogicalIndex(targetIndex);
    }

    slideToLogicalIndex(targetIndex) {
      if (!this.swiper) return;
      if (this.hasLoopBuffer) {
        const slideCount = Number(this.swiper.el.dataset.slideCount || 0);
        this.normalizeLoopBuffer(this.swiper, slideCount);
        this.swiper.slideTo(targetIndex + 1, 500);
        return;
      }
      const slideIndex = Array.from(this.swiper.slides).findIndex(
        (slide) => Number(slide.dataset.logicalSlideIndex) - 1 === targetIndex
      );
      if (slideIndex >= 0) this.swiper.slideTo(slideIndex, 500);
    }

    setActiveTab(activeIndex) {
      const targetTab = this.tabItems[activeIndex];
      if (!targetTab) return;
      this.tabItems.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });
      this.tabTitle?.updateStyle?.(targetTab);
      this.tabTitle?.scrollItemIntoView?.(targetTab);
      this.updateTabArrows();
    }

    get tabItems() {
      return Array.from(this.tabTitle?.children || []);
    }

    get activeTabIndex() {
      const index = this.tabItems.findIndex((tab) => tab.classList.contains('is-active'));
      return index < 0 ? 0 : index;
    }

    activateRelativeTab(offset) {
      const tabs = this.tabItems;
      const targetIndex = this.activeTabIndex + offset;
      if (!tabs[targetIndex]) return;
      tabs[targetIndex].click();
    }

    updateTabArrows() {
      if (!this.tabShell || !this.previousTabButton || !this.nextTabButton) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const scrollContainer = this.tabTitle?.closest('.yg-scroll-container');
      const isOverflowing = Boolean(
        scrollContainer && scrollContainer.scrollWidth > scrollContainer.clientWidth + 1
      );
      const activeIndex = this.activeTabIndex;
      const lastIndex = this.tabItems.length - 1;
      const hasPrevious = isMobile && isOverflowing && activeIndex > 0;
      const hasNext = isMobile && isOverflowing && activeIndex < lastIndex;
      this.previousTabButton.hidden = !hasPrevious;
      this.nextTabButton.hidden = !hasNext;
      this.tabShell.classList.toggle('has-previous-tab', hasPrevious);
      this.tabShell.classList.toggle('has-next-tab', hasNext);
    }
  }

  if (!window.customElements.get('yg-image-swiper-tabs')) {
    window.customElements.define('yg-image-swiper-tabs', YGImageSwiperTabs);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGImageTabs extends HTMLElement {
    constructor() {
      super();
      this.handleDeferredImageLoad = this.handleDeferredImageLoad.bind(this);
    }

    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-image-tab-panel]'));
      this.hasLoadedImages = false;
      this.addDeferredImageListener();

      if ('IntersectionObserver' in window) {
        this.lazySwiperObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.isIntersecting) {
            this.lazySwiperObserver.disconnect();
            this.lazySwiperObserver = null;
            this.loadSwiperAssets().then(() => {
              if (!this.isConnected) return;
              this.initSwiper();
              this.triggers = Array.from(this.querySelectorAll('[data-image-tab-trigger]'));
            }).catch(() => undefined);
          }
        }, { rootMargin: '300px' });
        this.lazySwiperObserver.observe(this);
      } else {
        this.loadSwiperAssets().then(() => {
          if (!this.isConnected) return;
          this.initSwiper();
          this.triggers = Array.from(this.querySelectorAll('[data-image-tab-trigger]'));
        }).catch(() => undefined);
      }
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      if (this.lazySwiperObserver) {
        this.lazySwiperObserver.disconnect();
        this.lazySwiperObserver = null;
      }
      this.removeDeferredImageListener();
    }

    loadSwiperAssets() {
      if (window.loadMondoSwiper) {
        return window.loadMondoSwiper();
      }

      if (window.Swiper) {
        return Promise.resolve();
      }

      if (window.__ygMediaGridSwiperPromise) {
        return window.__ygMediaGridSwiperPromise;
      }

      const assets = window.themeAssetUrls || {};

      if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = assets.swiperCss;
        document.head.appendChild(link);
      }

      window.__ygMediaGridSwiperPromise = new Promise((resolve, reject) => {
        if (!assets.swiperJs) {
          reject(new Error('Missing Swiper asset URL'));
          return;
        }

        const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);

        if (existingScript) {
          if (window.Swiper) {
            resolve();
            return;
          }

          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__ygMediaGridSwiperPromise;
    }

    addDeferredImageListener() {
      if (!this.hasDeferredImages) return;

      window.addEventListener('scroll', this.handleDeferredImageLoad, { passive: true });
      window.addEventListener('resize', this.handleDeferredImageLoad, { passive: true });
      this.handleDeferredImageLoad();
    }

    get hasDeferredImages() {
      return !!this.querySelector('img[data-image-tabs-src]');
    }

    removeDeferredImageListener() {
      window.removeEventListener('scroll', this.handleDeferredImageLoad);
      window.removeEventListener('resize', this.handleDeferredImageLoad);
    }

    handleDeferredImageLoad(force = false) {
      if (this.hasLoadedImages) return;
      if (force !== true && !this.hasReachedDeferredLoadPoint) return;

      this.hasLoadedImages = true;
      this.removeDeferredImageListener();
      this.loadDeferredImages();
    }

    get hasReachedDeferredLoadPoint() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;

      return window.scrollY >= viewportHeight * 5;
    }

    loadDeferredImages() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      const images = Array.from(this.querySelectorAll('img[data-image-tabs-src]'));

      images.forEach((image) => {
        const desktopSrc = image.dataset.imageTabsSrcPc;
        const mobileSrc = image.dataset.imageTabsSrcMobile;
        const fallbackSrc = image.dataset.imageTabsSrc;
        const imageSrc = (isMobile ? mobileSrc : desktopSrc) || fallbackSrc;

        if (desktopSrc) {
          image.setAttribute('data-src-pc', desktopSrc);
        }

        if (mobileSrc) {
          image.setAttribute('data-src-mobile', mobileSrc);
        }

        if (imageSrc) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
          image.decoding = 'async';
          image.src = imageSrc;
        }

        image.removeAttribute('data-image-tabs-src');
        image.removeAttribute('data-image-tabs-src-pc');
        image.removeAttribute('data-image-tabs-src-mobile');
      });
    }

    initSwiper() {
      const swiperEl = this.querySelector('.yg-image-tabs-images');
      const pagination = this.querySelector('.yg-image-tabs-colors-list');

      if (!swiperEl || !pagination || !window.Swiper) return;

      const escapeAttribute = (value = '') => String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      swiperEl.classList.add('yg-image-tabs-swiper-ready');

      const isDesktop = window.innerWidth >= 768;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        allowTouchMove: this.panels.length > 1,
        speed: 300,
        effect: 'fade' ,
        pagination: {
          el: pagination,
          clickable: true,
          renderBullet: (index, className) => {
            const slide = this.panels[index];
            const tabColor = slide?.dataset.tabColor || 'transparent';
            const tabLabel = slide?.dataset.tabLabel || `Show image ${index + 1}`;

            return `
              <button
                class="${className} yg-color-tab"
                type="button"
                style="--color: ${escapeAttribute(tabColor)}"
                data-image-tab-trigger="${index}"
                aria-label="${escapeAttribute(tabLabel)}"
                aria-pressed="${index === 0 ? 'true' : 'false'}"
              >
                <span class="yg-color-tab-inner"></span>
              </button>
            `;
          },
        },
        
        on: {
          slideChange: (swiper) => {
            this.setActiveTabWhenReady(swiper.realIndex);
          },
        },
      });
    }

    setActiveTabWhenReady(activeIndex) {
      if (this.pendingActiveIndex === activeIndex) return;

      if (!this.hasLoadedImages && this.hasDeferredImages) {
        this.handleDeferredImageLoad(true);
      }

      this.pendingActiveIndex = activeIndex;
      this.preparePanelImages(activeIndex).then(() => {
        if (this.pendingActiveIndex !== activeIndex) return;

        this.setActiveTab(activeIndex);
        this.pendingActiveIndex = null;
      });
    }

    preparePanelImages(activeIndex) {
      const panel = this.panels[activeIndex];
      const images = Array.from(panel?.querySelectorAll('img') || []);

      if (!images.length) {
        return Promise.resolve();
      }

      return Promise.all(images.map((image) => this.decodeImage(image)));
    }

    decodeImage(image) {
      if (!image.currentSrc && !image.src) {
        return Promise.resolve();
      }

      if (image.complete && image.naturalWidth > 0) {
        return image.decode ? image.decode().catch(() => undefined) : Promise.resolve();
      }

      return new Promise((resolve) => {
        const finish = () => {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);

          if (image.decode) {
            image.decode().then(resolve).catch(resolve);
          } else {
            resolve();
          }
        };

        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
      });
    }

    setActiveTab(activeIndex) {
      this.triggers = this.triggers || Array.from(this.querySelectorAll('[data-image-tab-trigger]'));

      this.triggers.forEach((trigger, index) => {
        const isActive = index === activeIndex;

        trigger.classList.toggle('active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;

        panel.classList.toggle('active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (this.swiper && this.swiper.realIndex !== activeIndex) {
        this.swiper.slideTo(activeIndex);
      }
    }
  }

  if (!customElements.get('yg-image-tabs')) {
    customElements.define('yg-image-tabs', YGImageTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-text-overly"] && !Shopify.designMode) return;
  try {
    
  class YGImageTextOverlay extends HTMLElement {
    constructor() {
      super();
      this.handleIntersect = this.handleIntersect.bind(this);
    }

    connectedCallback() {
      this.setupObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setupObserver() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersect, {
        threshold: 0.2,
      });
      this.observer.observe(this);
    }

    handleIntersect(entries) {
      const isVisible = entries.some((entry) => entry.isIntersecting);

      if (!isVisible) return;

      this.classList.add('is-visible');
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('yg-image-text-overlay')) {
    customElements.define('yg-image-text-overlay', YGImageTextOverlay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-in-the-box"] && !Shopify.designMode) return;
  try {
    
  class YGInTheBox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabTitle = this.querySelector('yg-tabs-title');
      this.swiperElement = this.querySelector('.yg-in-the-box-swiper');
      this.restoreLoadedImageStates(this);
      this.handleTabClick = () => this.scheduleTabChange();
      this.handleResize = () => this.handleLayoutChange();
      this.tabTitle?.addEventListener('click', this.handleTabClick);
      window.addEventListener('resize', this.handleResize);
      if (this.tabTitle) {
        this.tabObserver = new MutationObserver(() => this.scheduleTabChange());
        this.tabObserver.observe(this.tabTitle, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
      }
      this.loadSwiper().then(() => this.initializeSwiper()).catch(() => undefined);
    }

    disconnectedCallback() {
      this.tabTitle?.removeEventListener('click', this.handleTabClick);
      window.removeEventListener('resize', this.handleResize);
      this.tabObserver?.disconnect();
      if (this.tabChangeFrame) cancelAnimationFrame(this.tabChangeFrame);
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.initialized = false;
    }

    get tabItems() {
      return Array.from(this.tabTitle?.children || []);
    }

    get activeTabIndex() {
      const index = this.tabItems.findIndex((tab) => tab.classList.contains('is-active'));
      return index < 0 ? 0 : index;
    }

    loadSwiper() {
      if (window.Swiper) return Promise.resolve();
      if (window.loadMondoSwiper) return window.loadMondoSwiper();
      return Promise.reject(new Error('Swiper is unavailable'));
    }

    initializeSwiper() {
      if (!this.swiperElement || this.swiperElement.swiper) return;
      const tabCount = Number(this.dataset.tabCount || 0);
      this.swiper = new window.Swiper(this.swiperElement, {
        initialSlide: this.activeTabIndex,
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 450,
        autoHeight: true,
        allowTouchMove: tabCount > 1,
        observer: true,
        observeParents: true,
        on: {
          init: (swiper) => this.updateSlideState(swiper),
          slideChange: (swiper) => this.updateSlideState(swiper),
          transitionEnd: (swiper) => this.updateSlideState(swiper)
        }
      });
    }

    scheduleTabChange() {
      if (this.tabChangeFrame) cancelAnimationFrame(this.tabChangeFrame);
      this.tabChangeFrame = requestAnimationFrame(() => {
        this.tabChangeFrame = null;
        this.handleTabChange();
      });
    }

    handleTabChange() {
      if (!this.swiper) return;
      const activeIndex = this.activeTabIndex;
      if (activeIndex !== this.swiper.activeIndex) {
        this.swiper.slideTo(activeIndex);
        return;
      }
      this.swiper.update();
      this.swiper.updateAutoHeight(0);
      this.scheduleImageStateRestore(this.swiper.slides[activeIndex]);
    }

    handleLayoutChange() {
      if (!this.swiper) return;
      this.swiper.update();
      this.swiper.updateAutoHeight(0);
      this.scheduleImageStateRestore(this);
    }

    updateSlideState(swiper) {
      this.activateTab(swiper.activeIndex);
      swiper.updateAutoHeight(0);
      this.scheduleImageStateRestore(swiper.slides[swiper.activeIndex]);
    }

    activateTab(index) {
      const tab = this.tabItems[index];
      if (!tab) return;
      if (!tab.classList.contains('is-active')) {
        tab.click();
        return;
      }
      this.scheduleTabChange();
    }

    scheduleImageStateRestore(scope) {
      if (!scope) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.restoreLoadedImageStates(scope));
      });
    }

    restoreLoadedImageStates(scope) {
      scope.querySelectorAll('yg-image').forEach((imageBox) => {
        const images = Array.from(imageBox.querySelectorAll('img'));
        if (!images.length) return;

        const isEveryImageLoaded = images.every((image) => {
          const hasDeferredSource = image.hasAttribute('data-src');
          const isLoaded = image.classList.contains('is-loaded') || (!hasDeferredSource && image.complete && image.naturalWidth > 0);

          if (isLoaded) {
            image.classList.add('is-loaded');
            image.classList.remove('is-error');
          }

          return isLoaded;
        });

        if (!isEveryImageLoaded) return;
        imageBox.classList.remove('is-loading', 'is-error');
        imageBox.classList.add('is-loaded');
      });
    }
  }

  if (!window.customElements.get('yg-in-the-box')) {
    window.customElements.define('yg-in-the-box', YGInTheBox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-automatic"] && !Shopify.designMode) return;
  try {
    
  class YGMediaAutomatic extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.panels = Array.from(this.querySelectorAll('[data-panel-index]'));
      this.tabs = Array.from(this.querySelectorAll('[data-tab-index]'));
      this.mobileDetails = Array.from(this.querySelectorAll('[data-mobile-details-index]'));
      this.breakpointQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayConfigured = this.dataset.autoplay === 'true';
      this.autoplayEnabled = this.autoplayConfigured && !this.reducedMotionQuery.matches;
      this.autoplayTriggered = !this.autoplayConfigured;
      this.imageDuration = Math.max(Number(this.dataset.imageDuration) || 5, 1) * 1000;
      this.activeIndex = Math.max(this.panels.findIndex((panel) => panel.classList.contains('is-active')), 0);
      this.mediaCleanupCallbacks = [];
      this.panelHideTimers = new Map();
      this.timedElapsed = 0;
      this.timedDuration = this.imageDuration;
      this.fallbackActive = false;
      this.isSuspended = document.hidden;
      this.isAdvancing = false;

      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleReducedMotionChange = this.handleReducedMotionChange.bind(this);
      this.handleProviderMessage = this.handleProviderMessage.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerEnd = this.handlePointerEnd.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);
      this.queueAutoplayTriggerCheck = this.queueAutoplayTriggerCheck.bind(this);
      this.checkAutoplayTrigger = this.checkAutoplayTrigger.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleTabKeydown);
      });

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('message', this.handleProviderMessage);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerEnd);
      this.addEventListener('pointercancel', this.handlePointerEnd);
      this.addEventListener('click', this.handleClickCapture, true);
      this.breakpointQuery.addEventListener?.('change', this.handleBreakpointChange);
      this.reducedMotionQuery.addEventListener?.('change', this.handleReducedMotionChange);
      this.dataset.autoplayActive = String(this.autoplayEnabled);

      if (this.panels.length > 0) {
        this.activate(this.activeIndex, { force: true });
      }

      this.setupAutoplayTrigger();
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleTabKeydown);
      });

      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('message', this.handleProviderMessage);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerEnd);
      this.removeEventListener('pointercancel', this.handlePointerEnd);
      this.removeEventListener('click', this.handleClickCapture, true);
      this.breakpointQuery?.removeEventListener?.('change', this.handleBreakpointChange);
      this.reducedMotionQuery?.removeEventListener?.('change', this.handleReducedMotionChange);
      this.clearTimedProgress(true);
      this.clearMediaTracking();
      this.clearPanelHideTimers();
      this.teardownAutoplayTrigger();
    }

    handleTabClick(event) {
      this.activate(Number(event.currentTarget.dataset.tabIndex));
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const groupTabs = Array.from(event.currentTarget.closest('[role="tablist"]').querySelectorAll('[data-tab-index]'));
      const currentPosition = groupTabs.indexOf(event.currentTarget);
      let nextPosition = currentPosition;

      if (event.key === 'ArrowLeft') {
        nextPosition = (currentPosition - 1 + groupTabs.length) % groupTabs.length;
      }

      if (event.key === 'ArrowRight') {
        nextPosition = (currentPosition + 1) % groupTabs.length;
      }

      if (event.key === 'Home') {
        nextPosition = 0;
      }

      if (event.key === 'End') {
        nextPosition = groupTabs.length - 1;
      }

      event.preventDefault();
      const nextTab = groupTabs[nextPosition];
      nextTab.focus();
      this.activate(Number(nextTab.dataset.tabIndex));
    }

    setupAutoplayTrigger() {
      if (!this.autoplayEnabled || this.autoplayTriggered) return;
      window.addEventListener('scroll', this.queueAutoplayTriggerCheck, { passive: true });
      window.addEventListener('resize', this.queueAutoplayTriggerCheck);
      this.queueAutoplayTriggerCheck();
    }

    teardownAutoplayTrigger() {
      window.removeEventListener('scroll', this.queueAutoplayTriggerCheck);
      window.removeEventListener('resize', this.queueAutoplayTriggerCheck);
      if (this.autoplayTriggerFrame) {
        window.cancelAnimationFrame(this.autoplayTriggerFrame);
        this.autoplayTriggerFrame = null;
      }
    }

    queueAutoplayTriggerCheck() {
      if (this.autoplayTriggerFrame || this.autoplayTriggered) return;
      this.autoplayTriggerFrame = window.requestAnimationFrame(this.checkAutoplayTrigger);
    }

    checkAutoplayTrigger() {
      this.autoplayTriggerFrame = null;
      if (!this.autoplayEnabled || this.autoplayTriggered) return;

      const sectionTop = this.getBoundingClientRect().top;
      if (sectionTop > window.innerHeight * 0.5) return;

      this.autoplayTriggered = true;
      this.teardownAutoplayTrigger();
      this.resetAllProgress();
      this.setProgress(this.activeIndex, 0);

      if (!this.isSuspended) {
        this.startActiveMedia(this.panels[this.activeIndex]);
      }
    }

    handleVisibilityChange() {
      this.isSuspended = document.hidden;

      if (this.isSuspended) {
        this.pauseTimedProgress();
        this.stopVideoProgressLoop();
        this.pauseCurrentMediaPreservingPosition();
        return;
      }

      if (!this.autoplayTriggered) return;

      this.resumeCurrentMedia();

      if (!this.autoplayEnabled) return;

      const mediaKind = this.getActiveMediaKind();
      if (mediaKind === 'image') {
        this.startTimedProgress(this.imageDuration, this.timedElapsed);
      }
    }

    handleBreakpointChange() {
      this.activate(this.activeIndex, { force: true });
    }

    handleReducedMotionChange() {
      this.autoplayEnabled = this.autoplayConfigured && !this.reducedMotionQuery.matches;
      this.dataset.autoplayActive = String(this.autoplayEnabled);
      if (this.autoplayEnabled) {
        this.setupAutoplayTrigger();
      } else {
        this.teardownAutoplayTrigger();
      }
      this.activate(this.activeIndex, { force: true });
    }

    handleBlockSelect(event) {
      const panel = event.target.closest?.('[data-panel-index]');
      if (panel) this.activate(Number(panel.dataset.panelIndex));
    }

    handlePointerDown(event) {
      if (!this.breakpointQuery.matches || this.panels.length < 2 || event.pointerType !== 'touch') return;

      this.swipePointerId = event.pointerId;
      this.swipeStartX = event.clientX;
      this.swipeStartY = event.clientY;
      this.swipeCurrentX = event.clientX;
      this.swipeCurrentY = event.clientY;
      this.swipeAxis = null;
      this.suppressSwipeClick = false;
      this.setPointerCapture?.(event.pointerId);
    }

    handlePointerMove(event) {
      if (event.pointerId !== this.swipePointerId) return;

      this.swipeCurrentX = event.clientX;
      this.swipeCurrentY = event.clientY;
      const deltaX = this.swipeCurrentX - this.swipeStartX;
      const deltaY = this.swipeCurrentY - this.swipeStartY;

      if (!this.swipeAxis && Math.max(Math.abs(deltaX), Math.abs(deltaY)) >= 8) {
        this.swipeAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
      }

      if (this.swipeAxis === 'horizontal' && event.cancelable) {
        event.preventDefault();
      }
    }

    handlePointerEnd(event) {
      if (event.pointerId !== this.swipePointerId) return;

      const deltaX = (this.swipeCurrentX ?? event.clientX) - this.swipeStartX;
      const deltaY = (this.swipeCurrentY ?? event.clientY) - this.swipeStartY;
      const threshold = Math.min(Math.max(this.clientWidth * 0.1, 48), 96);
      const isHorizontalSwipe =
        event.type === 'pointerup' &&
        this.swipeAxis === 'horizontal' &&
        Math.abs(deltaX) >= threshold &&
        Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

      if (this.hasPointerCapture?.(event.pointerId)) {
        this.releasePointerCapture(event.pointerId);
      }

      this.swipePointerId = null;
      this.swipeAxis = null;
      this.swipeCurrentX = null;
      this.swipeCurrentY = null;

      if (!isHorizontalSwipe) return;

      this.suppressSwipeClick = true;
      this.activate(this.activeIndex + (deltaX < 0 ? 1 : -1));
      window.setTimeout(() => {
        this.suppressSwipeClick = false;
      }, 0);
    }

    handleClickCapture(event) {
      if (!this.suppressSwipeClick) return;
      event.preventDefault();
      event.stopPropagation();
    }

    activate(index, options = {}) {
      if (!this.panels.length) return;

      const normalizedIndex = ((Number(index) % this.panels.length) + this.panels.length) % this.panels.length;
      if (!options.force && normalizedIndex === this.activeIndex) return;

      const previousPanel = this.panels[this.activeIndex];
      const nextPanel = this.panels[normalizedIndex];

      this.isAdvancing = false;
      this.clearTimedProgress(true);
      this.clearMediaTracking();

      if (previousPanel && previousPanel === nextPanel) {
        this.stopPanelMedia(previousPanel);
      }

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === normalizedIndex;
        const existingTimer = this.panelHideTimers.get(panel);

        if (existingTimer) {
          window.clearTimeout(existingTimer);
          this.panelHideTimers.delete(panel);
        }

        if (isActive) {
          panel.hidden = false;
          window.requestAnimationFrame(() => panel.classList.add('is-active'));
          return;
        }

        panel.classList.remove('is-active');
        const timer = window.setTimeout(() => {
          if (!panel.classList.contains('is-active')) {
            this.stopPanelMedia(panel);
            panel.hidden = true;
          }
          this.panelHideTimers.delete(panel);
        }, this.reducedMotionQuery.matches ? 0 : 320);
        this.panelHideTimers.set(panel, timer);
      });

      this.activeIndex = normalizedIndex;

      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.tabIndex) === normalizedIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.mobileDetails.forEach((details) => {
        details.classList.toggle('is-active', Number(details.dataset.mobileDetailsIndex) === normalizedIndex);
      });

      this.resetAllProgress();
      this.setProgress(normalizedIndex, this.autoplayEnabled ? 0 : 1);

      if (!this.isSuspended && this.autoplayTriggered) {
        this.startActiveMedia(nextPanel);
      }
    }

    startActiveMedia(panel) {
      if (!panel) return;

      const slot = this.getCurrentMediaSlot(panel);
      const mediaKind = slot?.dataset.mediaKind || 'none';

      if (mediaKind === 'image' || mediaKind === 'none') {
        if (this.autoplayEnabled) this.startTimedProgress(this.imageDuration, 0);
        return;
      }

      if (mediaKind !== 'video' || this.reducedMotionQuery.matches) return;

      const videoElement = slot.querySelector('yg-video');
      if (!videoElement) {
        this.startVideoFallback();
        return;
      }

      const play = () => {
        if (!this.isConnected || panel !== this.panels[this.activeIndex]) return;
        videoElement.playVideo?.();
        this.waitForPlayableMedia(videoElement, 0);
      };

      if (typeof videoElement.playVideo === 'function') {
        play();
      } else {
        window.customElements.whenDefined('yg-video').then(play);
      }

      if (this.autoplayEnabled) {
        this.videoWatchdog = window.setTimeout(() => this.startVideoFallback(), 8000);
      }
    }

    waitForPlayableMedia(videoElement, attempt) {
      if (!this.isConnected || videoElement.closest('[data-panel-index]') !== this.panels[this.activeIndex]) return;

      const nativeVideo = videoElement.querySelector('video.yg-video-iframe');
      if (nativeVideo) {
        this.trackNativeVideo(nativeVideo);
        return;
      }

      const iframe = videoElement.querySelector('iframe.yg-video-iframe');
      if (iframe) {
        this.trackProviderIframe(iframe);
        return;
      }

      if (attempt >= 40) {
        this.startVideoFallback();
        return;
      }

      const retryTimer = window.setTimeout(() => this.waitForPlayableMedia(videoElement, attempt + 1), 100);
      this.mediaCleanupCallbacks.push(() => window.clearTimeout(retryTimer));
    }

    trackNativeVideo(video) {
      video.removeAttribute('poster');
      this.currentNativeVideo = video;
      this.isNativeVideoPlaying = false;
      this.nativeProgressStartTime = null;
      const hasVideoFrameCallback = typeof video.requestVideoFrameCallback === 'function';

      const updateProgress = (currentTime = video.currentTime) => {
        const duration = video.duration;
        if (!duration || !Number.isFinite(duration)) return;
        this.updateNativeProgress(currentTime, duration);
      };

      const handlePlaying = () => {
        if (!hasVideoFrameCallback || this.isNativeVideoPlaying) return;
        this.isNativeVideoPlaying = true;
        this.startNativeProgressLoop(video);
      };
      const handleTimeUpdate = () => {
        if (hasVideoFrameCallback) return;

        if (!this.isNativeVideoPlaying) {
          if (
            video.paused ||
            video.ended ||
            video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA ||
            video.currentTime <= 0
          ) {
            return;
          }

          this.isNativeVideoPlaying = true;
          this.startNativeProgressLoop(video);
        }

        updateProgress();
      };
      const handlePlaybackPause = () => {
        if (this.isNativeVideoPlaying && !hasVideoFrameCallback) updateProgress();
        this.isNativeVideoPlaying = false;
        this.stopVideoProgressLoop();
      };
      const handleEnded = () => this.finishCurrentVideo();
      const handleError = () => this.startVideoFallback();

      video.addEventListener('timeupdate', handleTimeUpdate);
      video.addEventListener('playing', handlePlaying);
      video.addEventListener('pause', handlePlaybackPause);
      video.addEventListener('waiting', handlePlaybackPause);
      video.addEventListener('stalled', handlePlaybackPause);
      video.addEventListener('ended', handleEnded);
      video.addEventListener('error', handleError);

      this.mediaCleanupCallbacks.push(() => {
        video.removeEventListener('timeupdate', handleTimeUpdate);
        video.removeEventListener('playing', handlePlaying);
        video.removeEventListener('pause', handlePlaybackPause);
        video.removeEventListener('waiting', handlePlaybackPause);
        video.removeEventListener('stalled', handlePlaybackPause);
        video.removeEventListener('ended', handleEnded);
        video.removeEventListener('error', handleError);
      });

      if (!video.paused) handlePlaying();
      video.play()?.catch?.(() => this.startVideoFallback());
    }

    trackProviderIframe(iframe) {
      this.currentProviderFrame = iframe;
      this.isProviderPlaying = false;
      const source = iframe.getAttribute('src') || '';

      if (source.includes('youtube.com') || source.includes('youtu.be')) {
        this.currentProvider = 'youtube';
        const registerYouTube = () => {
          this.postToProvider({ event: 'listening', id: this.dataset.sectionId });
          this.postToProvider({ event: 'command', func: 'addEventListener', args: ['onStateChange'] });
          this.postToProvider({ event: 'command', func: 'addEventListener', args: ['onReady'] });
        };
        iframe.addEventListener('load', registerYouTube, { once: true });
        registerYouTube();
        this.providerPoll = window.setInterval(() => {
          this.postToProvider({ event: 'command', func: 'getCurrentTime', args: [] });
          this.postToProvider({ event: 'command', func: 'getDuration', args: [] });
        }, 250);
        return;
      }

      if (source.includes('vimeo.com')) {
        this.currentProvider = 'vimeo';
        const registerVimeo = () => {
          this.postToProvider({ method: 'addEventListener', value: 'timeupdate' });
          this.postToProvider({ method: 'addEventListener', value: 'durationchange' });
          this.postToProvider({ method: 'addEventListener', value: 'play' });
          this.postToProvider({ method: 'addEventListener', value: 'playing' });
          this.postToProvider({ method: 'addEventListener', value: 'pause' });
          this.postToProvider({ method: 'addEventListener', value: 'bufferstart' });
          this.postToProvider({ method: 'addEventListener', value: 'bufferend' });
          this.postToProvider({ method: 'addEventListener', value: 'ended' });
          this.postToProvider({ method: 'getDuration' });
        };
        iframe.addEventListener('load', registerVimeo, { once: true });
        registerVimeo();
        return;
      }

      this.startVideoFallback();
    }

    handleProviderMessage(event) {
      if (!this.currentProviderFrame || event.source !== this.currentProviderFrame.contentWindow) return;

      let payload = event.data;
      if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload);
        } catch (error) {
          return;
        }
      }

      if (!payload || typeof payload !== 'object') return;

      if (this.currentProvider === 'youtube') {
        const info = payload.info;
        if (info && typeof info === 'object') {
          const duration = Number(info.duration);
          const currentTime = Number(info.currentTime);
          const playerState = Number(info.playerState);
          if (Number.isFinite(playerState)) this.isProviderPlaying = playerState === 1;
          if (
            this.isProviderPlaying &&
            Number.isFinite(duration) &&
            duration > 0 &&
            Number.isFinite(currentTime)
          ) {
            this.updateProviderProgress(currentTime, duration);
          }
          if (playerState === 0) this.finishCurrentVideo();
        }

        if (payload.event === 'onStateChange') {
          const playerState = Number(payload.info);
          this.isProviderPlaying = playerState === 1;
          if (playerState === 0) this.finishCurrentVideo();
        }
        return;
      }

      if (this.currentProvider === 'vimeo') {
        if (payload.event === 'play' || payload.event === 'playing' || payload.event === 'bufferend') {
          this.isProviderPlaying = true;
        }

        if (payload.event === 'pause' || payload.event === 'bufferstart') {
          this.isProviderPlaying = false;
        }

        if (payload.event === 'timeupdate' || payload.event === 'durationchange') {
          const data = payload.data || {};
          const duration = Number(data.duration || this.providerDuration);
          const seconds = Number(data.seconds);
          if (Number.isFinite(duration) && duration > 0) this.providerDuration = duration;
          if (
            this.isProviderPlaying &&
            Number.isFinite(seconds) &&
            Number.isFinite(this.providerDuration) &&
            this.providerDuration > 0
          ) {
            this.updateProviderProgress(seconds, this.providerDuration);
          }
        }

        if (payload.method === 'getDuration') {
          const duration = Number(payload.value);
          if (Number.isFinite(duration) && duration > 0) {
            this.providerDuration = duration;
            this.markVideoProgressAvailable();
          }
        }

        if (payload.event === 'ended') this.finishCurrentVideo();
      }
    }

    postToProvider(message) {
      this.currentProviderFrame?.contentWindow?.postMessage(JSON.stringify(message), '*');
    }

    markVideoProgressAvailable() {
      if (this.videoWatchdog) {
        window.clearTimeout(this.videoWatchdog);
        this.videoWatchdog = null;
      }

      if (this.fallbackActive) {
        this.fallbackActive = false;
        this.clearTimedProgress(true);
      }
    }

    startNativeProgressLoop(video) {
      this.stopVideoProgressLoop();
      const hasVideoFrameCallback = typeof video.requestVideoFrameCallback === 'function';

      const update = (timestamp, metadata) => {
        if (
          this.isSuspended ||
          this.currentNativeVideo !== video ||
          !this.isNativeVideoPlaying ||
          video.paused ||
          video.ended
        ) {
          this.videoProgressFrame = null;
          this.videoProgressFrameType = null;
          return;
        }

        const duration = video.duration;
        if (Number.isFinite(duration) && duration > 0) {
          const currentTime = Number.isFinite(metadata?.mediaTime) ? metadata.mediaTime : video.currentTime;
          const videoElement = video.closest('yg-video');
          video.closest('.yg-video-iframe-container')?.classList.remove('close');
          videoElement?.querySelector('.yg-video-placeholder')?.classList.add('close');
          this.updateNativeProgress(currentTime, duration);
        }

        if (hasVideoFrameCallback) {
          this.videoProgressFrameType = 'video';
          this.videoProgressFrame = video.requestVideoFrameCallback(update);
        } else {
          this.videoProgressFrameType = 'animation';
          this.videoProgressFrame = window.requestAnimationFrame(update);
        }
      };

      if (hasVideoFrameCallback) {
        this.videoProgressFrameType = 'video';
        this.videoProgressFrame = video.requestVideoFrameCallback(update);
      } else {
        this.videoProgressFrameType = 'animation';
        this.videoProgressFrame = window.requestAnimationFrame(update);
      }
    }

    updateNativeProgress(currentTime, duration) {
      if (!Number.isFinite(currentTime) || !Number.isFinite(duration) || duration <= 0) return;

      if (this.nativeProgressStartTime === null) {
        this.nativeProgressStartTime = Math.max(currentTime, 0);
      }

      const elapsed = Math.max(currentTime - this.nativeProgressStartTime, 0);
      const remainingDuration = Math.max(duration - this.nativeProgressStartTime, 0);
      const progress = remainingDuration > 0 ? elapsed / remainingDuration : 0;

      this.markVideoProgressAvailable();
      this.setProgress(this.activeIndex, Math.min(progress, 1));
    }

    updateProviderProgress(currentTime, duration) {
      this.providerDuration = duration;
      this.markVideoProgressAvailable();
      this.setProgress(this.activeIndex, Math.min(currentTime / duration, 1));
    }

    stopVideoProgressLoop() {
      if (!this.videoProgressFrame) return;
      if (this.videoProgressFrameType === 'video' && this.currentNativeVideo?.cancelVideoFrameCallback) {
        this.currentNativeVideo.cancelVideoFrameCallback(this.videoProgressFrame);
      } else {
        window.cancelAnimationFrame(this.videoProgressFrame);
      }
      this.videoProgressFrame = null;
      this.videoProgressFrameType = null;
    }

    startVideoFallback() {
      if (!this.autoplayEnabled || this.fallbackActive) return;
      this.fallbackActive = true;
      this.pauseTimedProgress();
    }

    finishCurrentVideo() {
      if (!this.autoplayEnabled || this.isAdvancing) return;
      this.isAdvancing = true;
      this.setProgress(this.activeIndex, 1);
      window.setTimeout(() => this.advance(), 30);
    }

    advance() {
      if (!this.panels.length) return;
      this.activate((this.activeIndex + 1) % this.panels.length, { force: this.panels.length === 1 });
    }

    startTimedProgress(duration, elapsed = 0) {
      if (!this.autoplayEnabled || this.isSuspended) return;

      this.pauseTimedProgress();
      this.timedDuration = duration;
      this.timedElapsed = Math.min(elapsed, duration);
      const startedAt = performance.now() - this.timedElapsed;

      const update = (now) => {
        if (this.isSuspended) return;
        this.timedElapsed = Math.min(now - startedAt, this.timedDuration);
        this.setProgress(this.activeIndex, this.timedElapsed / this.timedDuration);

        if (this.timedElapsed >= this.timedDuration) {
          this.timedFrame = null;
          this.advance();
          return;
        }

        this.timedFrame = window.requestAnimationFrame(update);
      };

      this.timedFrame = window.requestAnimationFrame(update);
    }

    pauseTimedProgress() {
      if (!this.timedFrame) return;
      window.cancelAnimationFrame(this.timedFrame);
      this.timedFrame = null;
    }

    clearTimedProgress(reset) {
      this.pauseTimedProgress();
      if (reset) {
        this.timedElapsed = 0;
        this.timedDuration = this.imageDuration;
        this.fallbackActive = false;
      }
    }

    clearMediaTracking() {
      this.stopVideoProgressLoop();
      this.mediaCleanupCallbacks.forEach((callback) => callback());
      this.mediaCleanupCallbacks = [];

      if (this.providerPoll) {
        window.clearInterval(this.providerPoll);
        this.providerPoll = null;
      }

      if (this.videoWatchdog) {
        window.clearTimeout(this.videoWatchdog);
        this.videoWatchdog = null;
      }

      this.currentNativeVideo = null;
      this.isNativeVideoPlaying = false;
      this.nativeProgressStartTime = null;
      this.currentProviderFrame = null;
      this.currentProvider = null;
      this.isProviderPlaying = false;
      this.providerDuration = null;
    }

    stopPanelMedia(panel) {
      panel?.querySelectorAll('yg-video').forEach((videoElement) => {
        const nativeVideo = videoElement.querySelector('video.yg-video-iframe');
        if (nativeVideo) {
          nativeVideo.pause();
          try {
            nativeVideo.currentTime = 0;
          } catch (error) {}
        }
        videoElement.pauseVideo?.();
      });
    }

    pauseCurrentMediaPreservingPosition() {
      if (this.currentNativeVideo) this.currentNativeVideo.pause();

      if (this.currentProvider === 'youtube') {
        this.postToProvider({ event: 'command', func: 'pauseVideo', args: [] });
      }

      if (this.currentProvider === 'vimeo') {
        this.postToProvider({ method: 'pause' });
      }
    }

    resumeCurrentMedia() {
      if (this.reducedMotionQuery.matches) return;

      if (this.currentNativeVideo) {
        this.currentNativeVideo.play()?.catch?.(() => this.startVideoFallback());
        this.startNativeProgressLoop(this.currentNativeVideo);
        return;
      }

      if (this.currentProvider === 'youtube') {
        this.postToProvider({ event: 'command', func: 'playVideo', args: [] });
        return;
      }

      if (this.currentProvider === 'vimeo') {
        this.postToProvider({ method: 'play' });
        return;
      }

      if (this.getActiveMediaKind() === 'video') {
        this.startActiveMedia(this.panels[this.activeIndex]);
      }
    }

    getCurrentMediaSlot(panel) {
      if (!panel) return null;
      const modifier = this.breakpointQuery.matches ? 'mobile' : 'desktop';
      return panel.querySelector(`.yg-media-automatic__media-slot--${modifier}`);
    }

    getActiveMediaKind() {
      return this.getCurrentMediaSlot(this.panels[this.activeIndex])?.dataset.mediaKind || 'none';
    }

    resetAllProgress() {
      this.querySelectorAll('[data-progress-index]').forEach((progressElement) => {
        progressElement.style.transform = 'scaleX(0)';
      });
    }

    setProgress(index, progress) {
      const clampedProgress = Math.min(Math.max(Number(progress) || 0, 0), 1);
      this.querySelectorAll(`[data-progress-index="${index}"]`).forEach((progressElement) => {
        progressElement.style.transform = `scaleX(${clampedProgress})`;
      });
    }

    clearPanelHideTimers() {
      this.panelHideTimers.forEach((timer) => window.clearTimeout(timer));
      this.panelHideTimers.clear();
    }
  }

  if (!window.customElements.get('yg-media-automatic')) {
    window.customElements.define('yg-media-automatic', YGMediaAutomatic);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-banner"] && !Shopify.designMode) return;
  try {
    
  class YgMediaBanner extends HTMLElement {
    constructor() {
      super();
      this.handleIntersect = this.handleIntersect.bind(this);
    }

    connectedCallback() {
      this.setupObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setupObserver() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersect, {
        threshold: 0.2,
      });
      this.observer.observe(this);
    }

    handleIntersect(entries) {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.classList.add('is-visible');
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('yg-media-banner')) {
    customElements.define('yg-media-banner', YgMediaBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-box-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGMediaBoxSwiper extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.main = this.closest('.yg-media-box-main');
      this.previousButton = this.main?.querySelector('.yg-media-box-button--prev');
      this.nextButton = this.main?.querySelector('.yg-media-box-button--next');
      this.progress = this.main?.querySelector('.yg-media-box-progress');
      this.progressValue = this.main?.querySelector('.yg-media-box-progress-value');
      this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
      if (!this.slides.length) return;
      this.updateProgress(0);
      if (this.slides.length === 1) {
        this.previousButton?.setAttribute('disabled', 'disabled');
        this.nextButton?.setAttribute('disabled', 'disabled');
        this.syncVideos(0);
        return;
      }
      this.loadSwiper()
        .then(() => this.initializeSwiper())
        .catch((error) => console.warn('YG media box swiper failed to load', error));
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.initialized = false;
    }

    loadSwiper() {
      if (window.Swiper) return Promise.resolve();
      if (window.loadMondoSwiper) return window.loadMondoSwiper();
      if (window.__ygMediaGridSwiperPromise) return window.__ygMediaGridSwiperPromise;
      const assets = window.themeAssetUrls || {};
      if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = assets.swiperCss;
        document.head.appendChild(stylesheet);
      }
      window.__ygMediaGridSwiperPromise = new Promise((resolve, reject) => {
        if (!assets.swiperJs) return reject(new Error('Missing Swiper asset URL'));
        const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);
        if (existingScript) {
          if (window.Swiper) return resolve();
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }
        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.defer = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });
      return window.__ygMediaGridSwiperPromise;
    }

    initializeSwiper() {
      if (!window.Swiper || this.swiper || !this.isConnected) return;
      this.swiper = new window.Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 500,
        watchOverflow: true,
        navigation: {
          prevEl: this.previousButton,
          nextEl: this.nextButton,
          disabledClass: 'swiper-button-disabled'
        },
        breakpoints: {
          900: {
            spaceBetween: 24
          }
        },
        on: {
          init: (swiper) => this.handleSlideChange(swiper),
          slideChange: (swiper) => this.handleSlideChange(swiper)
        }
      });
    }

    handleSlideChange(swiper) {
      this.updateProgress(swiper.activeIndex);
      this.syncVideos(swiper.activeIndex);
    }

    updateProgress(activeIndex) {
      const slideCount = this.slides.length || 1;
      const currentIndex = Math.min(activeIndex + 1, slideCount);
      if (this.progressValue) this.progressValue.style.transform = `scaleX(${currentIndex / slideCount})`;
      this.progress?.setAttribute('aria-valuenow', String(currentIndex));
    }

    syncVideos(activeIndex) {
      this.slides.forEach((slide, index) => {
        const video = slide.querySelector('yg-video');
        if (!video) return;
        if (index === activeIndex) video.playVideo?.();
        else video.pauseVideo?.();
      });
    }
  }

  if (!customElements.get('yg-media-box-swiper')) {
    customElements.define('yg-media-box-swiper', YGMediaBoxSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-control"] && !Shopify.designMode) return;
  try {
    
  class YGMediaControl extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.desktopPanels = Array.from(this.querySelectorAll('[data-desktop-panel-index]'));
      this.controls = Array.from(this.querySelectorAll('[data-control-index]'));
      this.mobileSlides = Array.from(this.querySelectorAll('[data-mobile-slide-index]'));
      this.paginationButtons = Array.from(this.querySelectorAll('[data-pagination-index]'));
      this.mobileSwiperElement = this.querySelector('[data-mobile-swiper]');
      this.breakpointQuery = window.matchMedia('(max-width: 999px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayEnabled = !this.reducedMotionQuery.matches;
      this.imageDuration = Math.max(Number(this.dataset.imageDuration) || 5, 1) * 1000;
      this.itemCount = Math.max(this.desktopPanels.length, this.mobileSlides.length);
      this.activeIndex = 0;
      this.isInViewport = false;
      this.isSuspended = true;
      this.mediaCleanupCallbacks = [];
      this.timedElapsed = 0;
      this.timedDuration = this.imageDuration;
      this.isAdvancing = false;

      this.handleControlClick = this.handleControlClick.bind(this);
      this.handleControlKeydown = this.handleControlKeydown.bind(this);
      this.handlePaginationClick = this.handlePaginationClick.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleReducedMotionChange = this.handleReducedMotionChange.bind(this);
      this.handleProviderMessage = this.handleProviderMessage.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);

      this.controls.forEach((control) => {
        control.addEventListener('click', this.handleControlClick);
        control.addEventListener('keydown', this.handleControlKeydown);
      });
      this.paginationButtons.forEach((button) => button.addEventListener('click', this.handlePaginationClick));
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('message', this.handleProviderMessage);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.breakpointQuery.addEventListener?.('change', this.handleBreakpointChange);
      this.reducedMotionQuery.addEventListener?.('change', this.handleReducedMotionChange);

      if (this.breakpointQuery.matches) this.ensureSwiper();
      if (this.itemCount > 0) this.activate(0, { force: true, immediate: true });
      this.setupViewportObserver();
    }

    disconnectedCallback() {
      this.controls?.forEach((control) => {
        control.removeEventListener('click', this.handleControlClick);
        control.removeEventListener('keydown', this.handleControlKeydown);
      });
      this.paginationButtons?.forEach((button) => button.removeEventListener('click', this.handlePaginationClick));
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('message', this.handleProviderMessage);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.breakpointQuery?.removeEventListener?.('change', this.handleBreakpointChange);
      this.reducedMotionQuery?.removeEventListener?.('change', this.handleReducedMotionChange);
      this.viewportObserver?.disconnect();
      this.viewportObserver = null;
      this.clearTimedProgress(true);
      this.clearMediaTracking();
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.initialized = false;
    }

    handleControlClick(event) {
      this.activate(Number(event.currentTarget.dataset.controlIndex));
    }

    handleControlKeydown(event) {
      if (!['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const currentPosition = this.controls.indexOf(event.currentTarget);
      let nextPosition = currentPosition;
      if (event.key === 'ArrowUp') nextPosition = (currentPosition - 1 + this.controls.length) % this.controls.length;
      if (event.key === 'ArrowDown') nextPosition = (currentPosition + 1) % this.controls.length;
      if (event.key === 'Home') nextPosition = 0;
      if (event.key === 'End') nextPosition = this.controls.length - 1;
      event.preventDefault();
      this.controls[nextPosition]?.focus();
      this.activate(nextPosition);
    }

    handlePaginationClick(event) {
      this.activate(Number(event.currentTarget.dataset.paginationIndex));
    }

    handleVisibilityChange() {
      this.updateSuspendedState();
    }

    handleIntersection(entries) {
      const entry = entries[entries.length - 1];
      this.isInViewport = Boolean(entry?.isIntersecting);
      this.updateSuspendedState();
    }

    setupViewportObserver() {
      if (!('IntersectionObserver' in window)) {
        this.isInViewport = true;
        this.updateSuspendedState();
        return;
      }

      this.viewportObserver = new IntersectionObserver(this.handleIntersection, { threshold: 0.01 });
      this.viewportObserver.observe(this);
    }

    updateSuspendedState() {
      const shouldSuspend = document.hidden || !this.isInViewport;
      if (shouldSuspend === this.isSuspended) return;

      this.isSuspended = shouldSuspend;
      if (shouldSuspend) {
        this.suspendPlayback();
        return;
      }

      this.resumePlayback();
    }

    suspendPlayback() {
      this.pauseTimedProgress();
      this.stopVideoProgressLoop();
      this.pauseCurrentMediaPreservingPosition();
      this.clearStallTimer();
    }

    resumePlayback() {
      const mediaKind = this.getActiveMediaKind();
      if (mediaKind === 'image' || mediaKind === 'none') {
        if (this.autoplayEnabled) this.startTimedProgress(this.imageDuration, this.timedElapsed);
        return;
      }
      this.resumeCurrentMedia();
    }

    handleBreakpointChange() {
      if (this.breakpointQuery.matches) this.ensureSwiper();
      this.activate(this.activeIndex, { force: true, immediate: true });
    }

    handleReducedMotionChange() {
      this.autoplayEnabled = !this.reducedMotionQuery.matches;
      this.activate(this.activeIndex, { force: true, immediate: true });
    }

    handleBlockSelect(event) {
      const item = event.target.closest?.('[data-item-index]');
      if (item) this.activate(Number(item.dataset.itemIndex), { immediate: true });
    }

    loadSwiper() {
      if (window.Swiper) return Promise.resolve();
      if (window.loadMondoSwiper) return window.loadMondoSwiper();
      return Promise.reject(new Error('Swiper loader unavailable'));
    }

    ensureSwiper() {
      if (!this.mobileSwiperElement || this.swiper || this.swiperLoading || this.itemCount < 2) return;
      this.swiperLoading = true;
      this.loadSwiper()
        .then(() => {
          if (!this.isConnected || !window.Swiper || this.swiper) return;
          this.swiper = new window.Swiper(this.mobileSwiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 420,
            watchOverflow: true,
            on: {
              slideChange: (swiper) => {
                if (!this.syncingSwiper) this.activate(swiper.activeIndex, { fromSwiper: true });
              }
            }
          });
          this.swiper.slideTo(this.activeIndex, 0);
        })
        .catch((error) => console.warn('YG media control swiper failed to load', error))
        .finally(() => {
          this.swiperLoading = false;
        });
    }

    activate(index, options = {}) {
      if (!this.itemCount) return;
      const normalizedIndex = ((Number(index) % this.itemCount) + this.itemCount) % this.itemCount;
      if (!options.force && normalizedIndex === this.activeIndex) return;

      this.stopIndexMedia(this.activeIndex);
      this.clearTimedProgress(true);
      this.clearMediaTracking();
      this.isAdvancing = false;
      this.activeIndex = normalizedIndex;

      this.desktopPanels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === normalizedIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
      this.controls.forEach((control, controlIndex) => {
        const isActive = controlIndex === normalizedIndex;
        control.classList.toggle('is-active', isActive);
        control.setAttribute('aria-selected', String(isActive));
        control.tabIndex = isActive ? 0 : -1;
      });
      this.paginationButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === normalizedIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });

      this.resetAllProgress();
      if (!this.autoplayEnabled) this.setProgress(normalizedIndex, 1);

      if (this.breakpointQuery.matches) {
        this.ensureSwiper();
        if (this.swiper && !options.fromSwiper && this.swiper.activeIndex !== normalizedIndex) {
          this.syncingSwiper = true;
          this.swiper.slideTo(normalizedIndex, options.immediate ? 0 : 420);
          window.setTimeout(() => {
            this.syncingSwiper = false;
          }, options.immediate ? 0 : 430);
        }
      }

      if (!this.isSuspended) this.startActiveMedia();
    }

    getActiveSlot() {
      if (this.breakpointQuery.matches) {
        return this.mobileSlides[this.activeIndex]?.querySelector('.yg-media-control-media');
      }
      return this.desktopPanels[this.activeIndex]?.querySelector('.yg-media-control-media');
    }

    getActiveMediaKind() {
      return this.getActiveSlot()?.dataset.mediaKind || 'none';
    }

    startActiveMedia() {
      const slot = this.getActiveSlot();
      const mediaKind = slot?.dataset.mediaKind || 'none';
      if (mediaKind === 'image' || mediaKind === 'none') {
        if (this.autoplayEnabled) this.startTimedProgress(this.imageDuration, 0);
        return;
      }
      if (mediaKind !== 'video' || !this.autoplayEnabled) return;

      const videoElement = slot.querySelector('yg-video');
      if (!videoElement) {
        this.scheduleStallAdvance();
        return;
      }
      const play = () => {
        if (!this.isConnected || slot !== this.getActiveSlot()) return;
        videoElement.playVideo?.();
        this.waitForPlayableMedia(videoElement, slot, 0);
        this.scheduleStallAdvance();
      };
      if (typeof videoElement.playVideo === 'function') play();
      else window.customElements.whenDefined('yg-video').then(play);
    }

    waitForPlayableMedia(videoElement, slot, attempt) {
      if (!this.isConnected || slot !== this.getActiveSlot()) return;
      const nativeVideo = videoElement.querySelector('video.yg-video-iframe');
      if (nativeVideo) {
        this.trackNativeVideo(nativeVideo);
        return;
      }
      const iframe = videoElement.querySelector('iframe.yg-video-iframe');
      if (iframe) {
        this.trackProviderIframe(iframe);
        return;
      }
      if (attempt >= 80) return;
      const retryTimer = window.setTimeout(() => this.waitForPlayableMedia(videoElement, slot, attempt + 1), 100);
      this.mediaCleanupCallbacks.push(() => window.clearTimeout(retryTimer));
    }

    trackNativeVideo(video) {
      this.currentNativeVideo = video;
      this.lastNativeTime = 0;
      const handleProgress = () => {
        const duration = video.duration;
        if (!Number.isFinite(duration) || duration <= 0) return;
        if (video.currentTime > this.lastNativeTime) this.markPlaybackHealthy();
        this.lastNativeTime = video.currentTime;
        this.setProgress(this.activeIndex, Math.min(video.currentTime / duration, 1));
      };
      const handlePlaying = () => {
        this.markPlaybackHealthy();
        this.startNativeProgressLoop(video);
      };
      const handleWaiting = () => {
        this.stopVideoProgressLoop();
        this.scheduleStallAdvance();
      };
      const handleEnded = () => this.finishCurrentVideo();
      const handleError = () => this.scheduleStallAdvance();
      const events = [
        ['loadedmetadata', handleProgress],
        ['durationchange', handleProgress],
        ['timeupdate', handleProgress],
        ['playing', handlePlaying],
        ['waiting', handleWaiting],
        ['stalled', handleWaiting],
        ['ended', handleEnded],
        ['error', handleError]
      ];
      events.forEach(([name, handler]) => video.addEventListener(name, handler));
      this.mediaCleanupCallbacks.push(() => {
        events.forEach(([name, handler]) => video.removeEventListener(name, handler));
      });
      video.play()?.catch?.(() => this.scheduleStallAdvance());
      handleProgress();
    }

    trackProviderIframe(iframe) {
      this.currentProviderFrame = iframe;
      const source = iframe.getAttribute('src') || '';
      if (source.includes('youtube.com') || source.includes('youtu.be')) {
        this.currentProvider = 'youtube';
        const register = () => {
          this.postToProvider({ event: 'listening', id: this.dataset.sectionId });
          this.postToProvider({ event: 'command', func: 'addEventListener', args: ['onStateChange'] });
          this.postToProvider({ event: 'command', func: 'addEventListener', args: ['onReady'] });
        };
        iframe.addEventListener('load', register, { once: true });
        register();
        this.providerPoll = window.setInterval(() => {
          this.postToProvider({ event: 'command', func: 'getCurrentTime', args: [] });
          this.postToProvider({ event: 'command', func: 'getDuration', args: [] });
        }, 250);
        return;
      }
      if (source.includes('vimeo.com')) {
        this.currentProvider = 'vimeo';
        const register = () => {
          ['timeupdate', 'durationchange', 'play', 'playing', 'bufferstart', 'bufferend', 'ended', 'error'].forEach((name) => {
            this.postToProvider({ method: 'addEventListener', value: name });
          });
          this.postToProvider({ method: 'getDuration' });
        };
        iframe.addEventListener('load', register, { once: true });
        register();
        return;
      }
      this.scheduleStallAdvance();
    }

    handleProviderMessage(event) {
      if (!this.currentProviderFrame || event.source !== this.currentProviderFrame.contentWindow) return;
      let payload = event.data;
      if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload);
        } catch (error) {
          return;
        }
      }
      if (!payload || typeof payload !== 'object') return;

      if (this.currentProvider === 'youtube') {
        const info = payload.info;
        if (info && typeof info === 'object') {
          const duration = Number(info.duration);
          const currentTime = Number(info.currentTime);
          const state = Number(info.playerState);
          if (Number.isFinite(duration) && duration > 0 && Number.isFinite(currentTime)) {
            this.updateProviderProgress(currentTime, duration);
          }
          this.handleProviderState(state);
        }
        if (payload.event === 'onStateChange') this.handleProviderState(Number(payload.info));
        return;
      }

      if (this.currentProvider === 'vimeo') {
        if (payload.event === 'timeupdate' || payload.event === 'durationchange') {
          const data = payload.data || {};
          const duration = Number(data.duration || this.providerDuration);
          const seconds = Number(data.seconds);
          if (Number.isFinite(duration) && duration > 0) this.providerDuration = duration;
          if (Number.isFinite(seconds) && Number.isFinite(this.providerDuration) && this.providerDuration > 0) {
            this.updateProviderProgress(seconds, this.providerDuration);
          }
        }
        if (payload.method === 'getDuration') {
          const duration = Number(payload.value);
          if (Number.isFinite(duration) && duration > 0) {
            this.providerDuration = duration;
          }
        }
        if (['play', 'playing', 'bufferend'].includes(payload.event)) this.markPlaybackHealthy();
        if (['bufferstart', 'error'].includes(payload.event)) this.scheduleStallAdvance();
        if (payload.event === 'ended') this.finishCurrentVideo();
      }
    }

    handleProviderState(state) {
      if (state === 1) this.markPlaybackHealthy();
      if (state === 3) this.scheduleStallAdvance();
      if (state === 0) this.finishCurrentVideo();
    }

    postToProvider(message) {
      this.currentProviderFrame?.contentWindow?.postMessage(JSON.stringify(message), '*');
    }

    markPlaybackHealthy() {
      this.clearStallTimer();
    }

    scheduleStallAdvance() {
      if (!this.autoplayEnabled || this.isSuspended || this.stallTimer) return;
      this.stallTimer = window.setTimeout(() => {
        this.stallTimer = null;
        this.advance();
      }, 8000);
    }

    clearStallTimer() {
      if (!this.stallTimer) return;
      window.clearTimeout(this.stallTimer);
      this.stallTimer = null;
    }

    startNativeProgressLoop(video) {
      this.stopVideoProgressLoop();
      const update = () => {
        if (this.isSuspended || this.currentNativeVideo !== video || video.paused) {
          this.videoProgressFrame = null;
          return;
        }
        const duration = video.duration;
        if (Number.isFinite(duration) && duration > 0) {
          this.setProgress(this.activeIndex, Math.min(video.currentTime / duration, 1));
        }
        this.videoProgressFrame = window.requestAnimationFrame(update);
      };
      this.videoProgressFrame = window.requestAnimationFrame(update);
    }

    updateProviderProgress(currentTime, duration) {
      this.providerDuration = duration;
      if (Number.isFinite(this.lastProviderTime) && currentTime > this.lastProviderTime) this.markPlaybackHealthy();
      if (!Number.isFinite(this.lastProviderTime) && currentTime > 0) this.markPlaybackHealthy();
      this.lastProviderTime = currentTime;
      this.setProgress(this.activeIndex, Math.min(currentTime / duration, 1));
    }

    stopVideoProgressLoop() {
      if (!this.videoProgressFrame) return;
      window.cancelAnimationFrame(this.videoProgressFrame);
      this.videoProgressFrame = null;
    }

    finishCurrentVideo() {
      if (!this.autoplayEnabled || this.isAdvancing) return;
      this.isAdvancing = true;
      this.clearStallTimer();
      this.setProgress(this.activeIndex, 1);
      this.advanceTimer = window.setTimeout(() => {
        this.advanceTimer = null;
        this.advance();
      }, 40);
    }

    advance() {
      if (!this.itemCount) return;
      this.activate((this.activeIndex + 1) % this.itemCount, { force: this.itemCount === 1 });
    }

    startTimedProgress(duration, elapsed = 0) {
      if (!this.autoplayEnabled || this.isSuspended) return;
      this.pauseTimedProgress();
      this.timedDuration = duration;
      this.timedElapsed = Math.min(elapsed, duration);
      const startedAt = performance.now() - this.timedElapsed;
      const update = (now) => {
        if (this.isSuspended) return;
        this.timedElapsed = Math.min(now - startedAt, this.timedDuration);
        this.setProgress(this.activeIndex, this.timedElapsed / this.timedDuration);
        if (this.timedElapsed >= this.timedDuration) {
          this.timedFrame = null;
          this.advance();
          return;
        }
        this.timedFrame = window.requestAnimationFrame(update);
      };
      this.timedFrame = window.requestAnimationFrame(update);
    }

    pauseTimedProgress() {
      if (!this.timedFrame) return;
      window.cancelAnimationFrame(this.timedFrame);
      this.timedFrame = null;
    }

    clearTimedProgress(reset) {
      this.pauseTimedProgress();
      if (reset) {
        this.timedElapsed = 0;
        this.timedDuration = this.imageDuration;
      }
    }

    clearMediaTracking() {
      this.stopVideoProgressLoop();
      this.clearStallTimer();
      this.mediaCleanupCallbacks.forEach((callback) => callback());
      this.mediaCleanupCallbacks = [];
      if (this.providerPoll) {
        window.clearInterval(this.providerPoll);
        this.providerPoll = null;
      }
      if (this.advanceTimer) {
        window.clearTimeout(this.advanceTimer);
        this.advanceTimer = null;
      }
      this.currentNativeVideo = null;
      this.currentProviderFrame = null;
      this.currentProvider = null;
      this.providerDuration = null;
      this.lastNativeTime = null;
      this.lastProviderTime = null;
    }

    stopIndexMedia(index) {
      this.querySelectorAll(`[data-item-index="${index}"] yg-video`).forEach((videoElement) => {
        const nativeVideo = videoElement.querySelector('video.yg-video-iframe');
        if (nativeVideo) {
          nativeVideo.pause();
          try {
            nativeVideo.currentTime = 0;
          } catch (error) {}
        }
        videoElement.pauseVideo?.();
      });
    }

    pauseCurrentMediaPreservingPosition() {
      if (this.currentNativeVideo) this.currentNativeVideo.pause();
      if (this.currentProvider === 'youtube') {
        this.postToProvider({ event: 'command', func: 'pauseVideo', args: [] });
      }
      if (this.currentProvider === 'vimeo') this.postToProvider({ method: 'pause' });
    }

    resumeCurrentMedia() {
      if (!this.autoplayEnabled) return;
      if (this.currentNativeVideo) {
        this.currentNativeVideo.play()?.catch?.(() => this.scheduleStallAdvance());
        return;
      }
      if (this.currentProvider === 'youtube') {
        this.postToProvider({ event: 'command', func: 'playVideo', args: [] });
        this.scheduleStallAdvance();
        return;
      }
      if (this.currentProvider === 'vimeo') {
        this.postToProvider({ method: 'play' });
        this.scheduleStallAdvance();
        return;
      }
      this.startActiveMedia();
    }

    resetAllProgress() {
      this.querySelectorAll('[data-progress-index]').forEach((element) => {
        element.style.setProperty('--progress', '0');
      });
    }

    setProgress(index, progress) {
      const clamped = Math.min(Math.max(Number(progress) || 0, 0), 1);
      this.querySelectorAll(`[data-progress-index="${index}"]`).forEach((element) => {
        element.style.setProperty('--progress', String(clamped));
      });
    }
  }

  if (!window.customElements.get('yg-media-control')) {
    window.customElements.define('yg-media-control', YGMediaControl);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-cut"] && !Shopify.designMode) return;
  try {
    
  class YgMediaCut extends HTMLElement {
    connectedCallback() {
      this.sticky = this.querySelector('.yg-media-cut__sticky');
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.progressFills = Array.from(this.querySelectorAll('[data-progress-fill]'));
      this.blockCount = this.panels.length;
      this.activeIndex = 0;
      this.rafId = null;
      this.resizeRafId = null;
      this.progressRafId = null;
      this.layoutRafId = null;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.tickProgress = this.tickProgress.bind(this);
      this.refreshLayout = this.refreshLayout.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.breakpointQuery = window.matchMedia('(max-width: 749px)');

      if (!this.blockCount) return;

      this.panels.forEach((panel) => {
        this.preparePanelMedia(panel);
      });

      this.measure();
      this.update();
      this.refreshLayout();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', this.refreshLayout, { once: true });
      this.addBreakpointListener();
      this.observeLazyMedia();

      this.handlePanelChange(this.activeIndex);
      this.tickProgress();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.refreshLayout);
      this.removeBreakpointListener();
      this.getLazyLoader()?.unobserve(this);

      if (this.rafId) window.cancelAnimationFrame(this.rafId);
      if (this.resizeRafId) window.cancelAnimationFrame(this.resizeRafId);
      if (this.progressRafId) window.cancelAnimationFrame(this.progressRafId);
      if (this.layoutRafId) window.cancelAnimationFrame(this.layoutRafId);

      this.panels.forEach((panel) => {
        this.getPanelVideos(panel).forEach((video) => {
          video.removeEventListener('loadedmetadata', this.refreshLayout);
          video.removeEventListener('loadeddata', this.refreshLayout);
        });
      });
    }

    get isMobileBreakpoint() {
      return !!(this.breakpointQuery && this.breakpointQuery.matches);
    }

    getLazyLoader() {
      if (!this._lazyLoader && window.IntersectionObserver) {
        this._lazyLoader = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.loadMedia();
            observer.unobserve(entry.target);
          });
        }, {
          rootMargin: '50px',
        });
      }

      return this._lazyLoader;
    }

    observeLazyMedia() {
      const lazyLoader = this.getLazyLoader();

      if (lazyLoader) {
        lazyLoader.observe(this);
      } else {
        this.loadMedia();
      }
    }

    loadMedia() {
      if (this.mediaLoaded) return;

      this.mediaLoaded = true;
      this.renderResponsiveVideos();

      if (window.MondoHomeLazyMedia && typeof window.MondoHomeLazyMedia.refresh === 'function') {
        window.MondoHomeLazyMedia.refresh(this);
      }

      this.loadActivePanelMedia();
      this.refreshLayout();
    }

    renderResponsiveVideos() {
      const breakpoint = this.isMobileBreakpoint ? 'mobile' : 'desktop';

      this.querySelectorAll('[data-media-cut-rendered-video]').forEach((element) => {
        element.remove();
      });

      this.querySelectorAll(`template[data-media-cut-video-template][data-breakpoint="${breakpoint}"]`).forEach((template) => {
        const fragment = template.content.cloneNode(true);
        const renderedElements = Array.from(fragment.children);

        renderedElements.forEach((element) => {
          element.setAttribute('data-media-cut-rendered-video', '');
        });

        template.after(fragment);
      });

      this.panels.forEach((panel) => {
        this.preparePanelMedia(panel);
      });
    }

    loadActivePanelMedia() {
      const activePanel = this.panels[this.activeIndex];

      if (!activePanel || !window.MondoHomeLazyMedia || typeof window.MondoHomeLazyMedia.loadWithin !== 'function') return;

      window.MondoHomeLazyMedia.loadWithin(activePanel, { force: true });
    }

    addBreakpointListener() {
      if (!this.breakpointQuery) return;

      if (this.breakpointQuery.addEventListener) {
        this.breakpointQuery.addEventListener('change', this.handleBreakpointChange);
      } else if (this.breakpointQuery.addListener) {
        this.breakpointQuery.addListener(this.handleBreakpointChange);
      }
    }

    removeBreakpointListener() {
      if (!this.breakpointQuery) return;

      if (this.breakpointQuery.removeEventListener) {
        this.breakpointQuery.removeEventListener('change', this.handleBreakpointChange);
      } else if (this.breakpointQuery.removeListener) {
        this.breakpointQuery.removeListener(this.handleBreakpointChange);
      }
    }

    handleBreakpointChange() {
      if (!this.mediaLoaded) return;

      this.pauseAllVideos();
      this.renderResponsiveVideos();

      if (window.MondoHomeLazyMedia && typeof window.MondoHomeLazyMedia.refresh === 'function') {
        window.MondoHomeLazyMedia.refresh(this);
      }

      this.loadActivePanelMedia();
      this.handlePanelChange(this.activeIndex);
      this.refreshLayout();
    }

    pauseAllVideos() {
      this.getPanelVideos(this).forEach((video) => {
        video.pause();
      });
    }

    onScroll() {
      if (this.rafId) return;

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    onResize() {
      if (this.resizeRafId) return;

      this.resizeRafId = window.requestAnimationFrame(() => {
        this.resizeRafId = null;
        this.refreshLayout();
      });
    }

    refreshLayout() {
      if (this.layoutRafId) return;

      this.layoutRafId = window.requestAnimationFrame(() => {
        this.layoutRafId = null;
        this.measure();
        this.update();
      });
    }

    measure() {
      const rect = this.getBoundingClientRect();
      this.viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      this.screenHeight = this.sticky ? this.sticky.offsetHeight || this.viewportHeight : this.viewportHeight;
      this.snapHoldVh = Number(this.dataset.snapHold || 0);
      this.holdDistance = this.screenHeight * this.snapHoldVh / 100;
      this.transitionDistance = this.screenHeight;
      this.phaseDistance = this.transitionDistance + this.holdDistance;
      this.sectionTop = rect.top + window.scrollY;

      const elementScrollable = Math.max(this.offsetHeight - this.viewportHeight, 1);
      const pageScrollable = Math.max(document.documentElement.scrollHeight - this.viewportHeight, 0);
      const maxReachableScroll = Math.max(0, pageScrollable - this.sectionTop);
      this.totalScrollable = Math.min(elementScrollable, maxReachableScroll);
    }

    update() {
      const rawScroll = window.scrollY - this.sectionTop;
      const boundedScroll = Math.max(0, Math.min(rawScroll, this.totalScrollable));
      const exactIndex = this.getExactIndex(boundedScroll);
      const visualIndex = Math.max(0, Math.min(this.blockCount - 1, Math.ceil(exactIndex)));

      this.panels.forEach((panel, index) => {
        const localProgress = this.getPanelProgress(index, boundedScroll);
        const translate = index === 0 ? 0 : (1 - localProgress) * 100;
        panel.style.transform = `translate3d(0px, ${translate}%, 0px)`;
        panel.classList.toggle('is-active', index === visualIndex);
        this.updatePanelText(panel, index, boundedScroll);
      });

      const nextActiveIndex = Math.max(0, Math.min(this.blockCount - 1, Math.round(exactIndex)));
      if (nextActiveIndex !== this.activeIndex) {
        this.handlePanelChange(nextActiveIndex);
        this.activeIndex = nextActiveIndex;
      }

      this.updateTitleVisibility(exactIndex);
      this.updateProgress();
    }

    handlePanelChange(activeIndex) {
      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        const videos = this.getPanelVideos(panel);

        if (isActive && this.mediaLoaded && window.MondoHomeLazyMedia && typeof window.MondoHomeLazyMedia.loadWithin === 'function') {
          this.loadActivePanelMedia();
          this.refreshLayout();
        }

        videos.forEach((video) => {
          if (!isActive) {
            video.pause();
            return;
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      });
    }

    updateTitleVisibility(exactIndex) {
      const titleVisibleIndex = this.getTitleVisibleIndex(exactIndex);

      this.panels.forEach((panel, index) => {
        const hasScrollDrivenText = panel.style.getPropertyValue('--yg-media-cut-text-opacity') !== '';
        panel.classList.toggle('is-title-visible', hasScrollDrivenText || index === titleVisibleIndex);
      });
    }

    updatePanelText(panel, index, boundedScroll) {
      const textState = this.getPanelTextState(index, boundedScroll);
      const specialTitleY = !this.isMobileBreakpoint && index < this.blockCount - 1
        ? this.getSpecialTitleTranslateY(index, boundedScroll)
        : 0;

      panel.style.setProperty('--yg-media-cut-text-opacity', textState.opacity.toFixed(3));
      panel.style.setProperty('--yg-media-cut-text-y', `${textState.translateY.toFixed(2)}px`);
      panel.style.setProperty('--yg-media-cut-special-title-y', `${specialTitleY.toFixed(2)}px`);
    }

    getSpecialTitleTranslateY(index, boundedScroll) {
      if (index >= this.blockCount - 1) return 0;

      const nextPanelProgress = this.getPanelProgress(index + 1, boundedScroll);
      return -this.screenHeight * nextPanelProgress;
    }

    getPanelTextState(index, boundedScroll) {
      const revealStart = index === 0
        ? 0
        : this.holdDistance + ((index - 1) * this.phaseDistance);
      const imageVisibleStart = index === 0
        ? 0
        : revealStart + this.transitionDistance;
      const isLastBlock = this.blockCount > 1 && index === this.blockCount - 1;

      const enterDuration = this.holdDistance > 0
        ? Math.max(this.holdDistance * 0.62, this.transitionDistance * 0.12)
        : this.transitionDistance * 0.28;

      let enterStart = isLastBlock ? (this.totalScrollable - this.holdDistance) : imageVisibleStart;
      let enterEnd = enterStart + enterDuration;

      if (isLastBlock) {
        const remainingScroll = this.totalScrollable - enterStart;
        if (remainingScroll < enterDuration) {
          const shift = enterDuration - remainingScroll;
          enterStart = Math.max(revealStart, enterStart - shift);
          enterEnd = enterStart + enterDuration;
        }
      }

      if (boundedScroll < enterStart) {
        return { opacity: 0, translateY: 56 };
      }

      if (boundedScroll < enterEnd) {
        const progress = this.easeOutCubic(this.normalizeRange(boundedScroll, enterStart, enterEnd));

        return {
          opacity: progress,
          translateY: this.lerp(56, 0, progress)
        };
      }

      if (isLastBlock) {
        return { opacity: 1, translateY: 0 };
      }

      const nextRevealStart = index < this.blockCount - 1
        ? this.holdDistance + (index * this.phaseDistance)
        : this.totalScrollable - Math.min(this.holdDistance * 0.45, this.transitionDistance * 0.22);
      const exitFadeStartOffset = this.transitionDistance * 0.4;
      const exitDuration = this.transitionDistance * 0.45;
      const exitStart = Math.max(enterEnd, nextRevealStart + exitFadeStartOffset);
      const exitEnd = exitStart + exitDuration;

      if (boundedScroll < exitStart) {
        return { opacity: 1, translateY: 0 };
      }

      if (boundedScroll < exitEnd) {
        const progress = this.easeInCubic(this.normalizeRange(boundedScroll, exitStart, exitEnd));

        return {
          opacity: 1,
          translateY: this.lerp(0, -72, progress)
        };
      }

      return { opacity: 1, translateY: -72 };
    }

    updateProgress() {
      if (!this.progressFills.length) return;

      this.progressFills.forEach((fill, index) => {
        const panel = this.panels[index];
        if (!panel) return;

        const isImagePanel = panel.dataset.panelType === 'image';
        let progress = 0;

        if (isImagePanel) {
          progress = 1;
        } else if (index !== this.activeIndex) {
          progress = 0;
        } else {
          progress = this.getActiveVideoProgress(panel);
        }

        fill.style.setProperty('--yg-media-cut-progress', `${this.clamp(progress, 0, 1)}`);
      });
    }

    getActiveVideoProgress(panel) {
      const videos = this.getPanelVideos(panel);
      const activeVideo = videos.find((video) => this.isVideoVisible(video)) || videos[0];

      if (!activeVideo) return 1;
      if (!Number.isFinite(activeVideo.duration) || activeVideo.duration <= 0) return 0;

      return activeVideo.currentTime / activeVideo.duration;
    }

    getPanelVideos(panel) {
      return Array.from(panel.querySelectorAll('video'));
    }

    isVideoVisible(video) {
      const style = window.getComputedStyle(video);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    preparePanelMedia(panel) {
      const videos = this.getPanelVideos(panel);

      videos.forEach((video) => {
        video.loop = true;
        video.addEventListener('loadedmetadata', this.refreshLayout);
        video.addEventListener('loadeddata', this.refreshLayout);
      });

      panel.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', this.refreshLayout, { once: true });
      });
    }

    getPanelProgress(index, boundedScroll) {
      if (index === 0) return 1;

      const isLastBlock = this.blockCount > 1 && index === this.blockCount - 1;

      if (isLastBlock) {
        const startScroll = (index - 1) * this.phaseDistance + this.holdDistance;
        const endScroll = this.totalScrollable - this.holdDistance;
        return this.clamp((boundedScroll - startScroll) / Math.max(endScroll - startScroll, 1), 0, 1);
      }

      const adjustedScroll = this.getAdjustedScroll(boundedScroll);
      const start = (index - 1) * this.phaseDistance;
      return this.clamp((adjustedScroll - start) / this.transitionDistance, 0, 1);
    }

    getExactIndex(boundedScroll) {
      if (this.blockCount < 2) return 0;

      const adjustedScroll = this.getAdjustedScroll(boundedScroll);

      for (let index = 0; index < this.blockCount - 1; index += 1) {
        const start = index * this.phaseDistance;
        const transitionEnd = start + this.transitionDistance;
        const holdEnd = transitionEnd + this.holdDistance;

        if (adjustedScroll < transitionEnd) {
          return index + ((adjustedScroll - start) / this.transitionDistance);
        }

        if (adjustedScroll < holdEnd) {
          return index + 1;
        }
      }

      return this.blockCount - 1;
    }

    getAdjustedScroll(boundedScroll) {
      return Math.max(0, boundedScroll - this.holdDistance);
    }

    getTitleVisibleIndex(exactIndex) {
      const roundedIndex = Math.round(exactIndex);
      const isFullySettled = Math.abs(exactIndex - roundedIndex) < 0.0001;

      if (!isFullySettled) return -1;

      return this.clamp(roundedIndex, 0, this.blockCount - 1);
    }

    tickProgress() {
      this.updateProgress();
      this.progressRafId = window.requestAnimationFrame(this.tickProgress);
    }

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    lerp(start, end, progress) {
      return start + (end - start) * this.clamp(progress, 0, 1);
    }

    normalizeRange(value, start, end) {
      return this.clamp((value - start) / Math.max(end - start, 1), 0, 1);
    }

    easeOutCubic(value) {
      const progress = this.clamp(value, 0, 1);
      return 1 - Math.pow(1 - progress, 3);
    }

    easeInCubic(value) {
      const progress = this.clamp(value, 0, 1);
      return progress * progress * progress;
    }
  }

  if (!customElements.get('yg-media-cut')) {
    customElements.define('yg-media-cut', YgMediaCut);
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-grid-v2"] && !Shopify.designMode) return;
  try {
    
  class YgMediaGridVideoListV2 extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.activeSlide = null;
      this.trackedVideo = null;
      this.trackedSlide = null;
      this.isInViewport = false;
      this.viewportObserver = null;
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.handleDesktopMediaChange = this.handleDesktopMediaChange.bind(this);
      this.handleSectionLeave = this.handleSectionLeave.bind(this);
      this.handleSlidePointerEnter = this.handleSlidePointerEnter.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleMuteClick = this.handleMuteClick.bind(this);
      this.handleTrackedVideoProgress = this.handleTrackedVideoProgress.bind(this);
      this.handleTrackedVideoReady = this.handleTrackedVideoReady.bind(this);
      this.handleTrackedVideoWaiting = this.handleTrackedVideoWaiting.bind(this);
      this.handleTrackedVideoEnded = this.handleTrackedVideoEnded.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.swiperElement = this.querySelector('.swiper');
      this.prevButton = this.closest('.yg-media-grid-container').querySelector('.yg-media-grid-video-nav--prev');
      this.nextButton = this.closest('.yg-media-grid-container').querySelector('.yg-media-grid-video-nav--next');
      this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
      this.triggerButtons = Array.from(this.querySelectorAll('.yg-media-grid-video-trigger'));
      this.muteButtons = Array.from(this.querySelectorAll('.yg-mute'));

      this.initializeProgressCircles();
      this.bindInteractions();

      if ('IntersectionObserver' in window) {
        this.lazySwiperObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.isIntersecting) {
            this.lazySwiperObserver.disconnect();
            this.lazySwiperObserver = null;
            this.loadSwiperAssets()
              .then(() => {
                this.initSwiper();
                this.setupViewportObserver();
              })
              .catch((error) => {
                console.warn('YG media grid swiper failed to load', error);
              });
          }
        }, { rootMargin: '300px' });
        this.lazySwiperObserver.observe(this);
      } else {
        this.initialized = true;
        this.loadSwiperAssets()
          .then(() => {
            this.initSwiper();
            this.setupViewportObserver();
          })
          .catch((error) => {
            console.warn('YG media grid swiper failed to load', error);
          });
      }
    }

    disconnectedCallback() {
      this.unbindInteractions();
      this.teardownViewportObserver();
      if (this.lazySwiperObserver) {
        this.lazySwiperObserver.disconnect();
        this.lazySwiperObserver = null;
      }
      this.clearTrackedVideo();
      this.stopAllVideos();
      this.destroySwiper();
      this.initialized = false;
    }

    setupViewportObserver() {
      if (this.viewportObserver || typeof IntersectionObserver === 'undefined') return;

      this.viewportObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.5
      });

      this.viewportObserver.observe(this);
    }

    teardownViewportObserver() {
      if (!this.viewportObserver) return;

      this.viewportObserver.disconnect();
      this.viewportObserver = null;
    }

    handleIntersection(entries) {
      const entry = entries[0];

      if (!entry) return;

      this.isInViewport = entry.isIntersecting;

      if (this.isDesktopMode()) return;

      if (this.isInViewport) {
        this.playActiveMobileSlide();
      } else {
        this.clearTrackedVideo();
        this.stopAllVideos();
      }
    }

    isDesktopMode() {
      return this.desktopMediaQuery.matches;
    }

    loadSwiperAssets() {
      if (window.loadMondoSwiper) {
        return window.loadMondoSwiper();
      }

      if (window.Swiper) {
        return Promise.resolve();
      }

      if (window.__ygMediaGridSwiperPromise) {
        return window.__ygMediaGridSwiperPromise;
      }

      const assets = window.themeAssetUrls || {};

      if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = assets.swiperCss;
        document.head.appendChild(stylesheet);
      }

      window.__ygMediaGridSwiperPromise = new Promise((resolve, reject) => {
        if (!assets.swiperJs) {
          reject(new Error('Missing Swiper asset URL'));
          return;
        }

        const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);

        if (existingScript) {
          if (window.Swiper) {
            resolve();
            return;
          }

          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.defer = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return window.__ygMediaGridSwiperPromise;
    }

    initSwiper() {
      if (!window.Swiper || !this.swiperElement || this.swiper) return;

      const hasMultipleSlides = this.slides.length > 1;

      this.swiper = new window.Swiper(this.swiperElement, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 450,
        // rewind: true,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        allowTouchMove: hasMultipleSlides,
        breakpoints: {
          900: {
            slidesPerView: 'auto',
            spaceBetween: 24,
            allowTouchMove: hasMultipleSlides
          },
          450: {
            slidesPerView: 1.8,
            spaceBetween: 16,
            allowTouchMove: hasMultipleSlides
          }
        },
        navigation: {
          prevEl: this.prevButton,
          nextEl: this.nextButton
        },
        on: {
          init: () => {
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          },
          slideChangeTransitionStart: () => {
            this.stopAllVideos();
          },
          slideChangeTransitionEnd: () => {
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          }
        }
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    bindInteractions() {
      this.slides.forEach((slide) => {
        slide.addEventListener('pointerenter', this.handleSlidePointerEnter);
      });

      this.triggerButtons.forEach((button) => {
        button.addEventListener('click', this.handleTriggerClick);
      });

      this.muteButtons.forEach((button) => {
        button.addEventListener('click', this.handleMuteClick);
      });

      this.addEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.addListener(this.handleDesktopMediaChange);
      }
    }

    unbindInteractions() {
      this.slides.forEach((slide) => {
        slide.removeEventListener('pointerenter', this.handleSlidePointerEnter);
      });

      this.triggerButtons.forEach((button) => {
        button.removeEventListener('click', this.handleTriggerClick);
      });

      this.muteButtons.forEach((button) => {
        button.removeEventListener('click', this.handleMuteClick);
      });

      this.removeEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.removeListener(this.handleDesktopMediaChange);
      }
    }

    initializeProgressCircles() {
      this.querySelectorAll('.yg-media-grid-video-progress-circle').forEach((circle) => {
        const length = circle.getTotalLength();
        circle.dataset.length = `${length}`;
        circle.style.strokeDasharray = `${length}`;
        circle.style.strokeDashoffset = `${length}`;
      });
    }

    handleDesktopMediaChange() {
      this.clearTrackedVideo();
      this.stopAllVideos();

      if (this.swiper) {
        this.swiper.params.allowTouchMove = !this.isDesktopMode() && this.slides.length > 1;
        this.swiper.update();
      }

      if (!this.isDesktopMode() && this.isInViewport) {
        this.playActiveMobileSlide();
      }
    }

    handleSectionLeave() {
      if (!this.isDesktopMode()) return;

      this.clearTrackedVideo();
      this.stopAllVideos();
    }

    handleSlidePointerEnter(event) {
      if (!this.isDesktopMode()) return;

      const slide = event.currentTarget;
      this.playSlide(slide);
    }

    handleTriggerClick(event) {
      event.preventDefault();
      const triggerButton = event.currentTarget;
      const slide = triggerButton.closest('.swiper-slide');

      if (!slide) return;

      const slideIndex = this.slides.indexOf(slide);

      if (!this.isDesktopMode() && this.swiper && slideIndex !== this.swiper.activeIndex) {
        this.swiper.slideTo(slideIndex);
        return;
      }

      if (triggerButton.dataset.state === 'playing') {
        this.pauseSlide(slide);
        return;
      }

      this.playSlide(slide);
    }

    handleMuteClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      const slide = button.closest('.swiper-slide');
      const nextMuted = button.dataset.muted !== 'true';

      this.setSlideMuted(slide, nextMuted);
    }

    getActiveSlide() {
      if (this.swiper) {
        return this.swiper.slides[this.swiper.activeIndex] || this.slides[0] || null;
      }

      return this.slides[0] || null;
    }

    playActiveMobileSlide() {
      if (this.isDesktopMode() || !this.isInViewport) return;

      const activeSlide = this.getActiveSlide();

      if (!activeSlide) return;

      this.playSlide(activeSlide);
    }

    playSlide(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);

      if (!videoElement) return;

      this.clearTrackedVideo();
      this.stopAllVideos(slide);
      this.activeSlide = slide;
      slide.classList.add('is-video-active');
      slide.classList.add('is-playing');
      this.setTriggerState(slide, this.isDesktopMode() ? 'playing' : 'loading');

      if (typeof videoElement.playVideo === 'function') {
        videoElement.playVideo();
        this.syncSlideMutedState(slide);
        this.trackSlideVideo(slide, videoElement);
        return;
      }

      window.customElements.whenDefined('yg-video').then(() => {
        if (!this.isConnected || this.activeSlide !== slide) return;

        videoElement.playVideo?.();
        this.syncSlideMutedState(slide);
        this.trackSlideVideo(slide, videoElement);
      });
    }

    pauseSlide(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);
      const currentVideoTag = videoElement ? this.getCurrentVideoTag(videoElement) : null;

      if (currentVideoTag) {
        currentVideoTag.pause();
      } else if (videoElement && typeof videoElement.pauseVideo === 'function') {
        videoElement.pauseVideo();
      } else if (videoElement) {
        window.customElements.whenDefined('yg-video').then(() => {
          if (!this.isConnected || this.activeSlide !== slide) return;
          videoElement.pauseVideo?.();
        });
      }

      this.clearTrackedVideo();
      this.activeSlide = null;
      this.setTriggerState(slide, 'paused');
      this.keepPausedVideoFrameVisible(slide);
      slide.classList.remove('is-playing');
    }

    stopAllVideos(exceptSlide = null) {
      this.slides.forEach((slide) => {
        if (exceptSlide && slide === exceptSlide) return;

        const videoElement = this.getVideoElement(slide);

        if (videoElement) {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          } else {
            window.customElements.whenDefined('yg-video').then(() => {
              if (!this.isConnected) return;
              videoElement.pauseVideo?.();
            });
          }
        }

        this.setTriggerState(slide, 'idle');
        this.setProgress(slide, 0);
        slide.classList.remove('is-video-active');
        slide.classList.remove('is-playing');
      });

      if (!exceptSlide) {
        this.activeSlide = null;
      }
    }

    getVideoElement(slide) {
      return slide?.querySelector('yg-video') || null;
    }

    getCurrentVideoTag(videoElement) {
      const videos = Array.from(videoElement.querySelectorAll('video.yg-video-iframe'));

      return videos.find((video) => {
        if (this.isDesktopMode()) {
          return !video.classList.contains('hide-pc');
        }

      return !video.classList.contains('hide-mobile');
      }) || null;
    }

    getMuteButton(slide) {
      return slide?.querySelector('.yg-mute') || null;
    }

    isSlideMuted(slide) {
      return this.getMuteButton(slide)?.dataset.muted === 'true';
    }

    setSlideMuted(slide, muted) {
      const button = this.getMuteButton(slide);

      if (!button) return;

      button.dataset.muted = muted ? 'true' : 'false';
      button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');

      const videoElement = this.getVideoElement(slide);
      const videos = videoElement ? Array.from(videoElement.querySelectorAll('video.yg-video-iframe')) : [];
      const iframes = videoElement ? Array.from(videoElement.querySelectorAll('iframe.yg-video-iframe')) : [];

      videos.forEach((video) => {
        video.muted = muted;
        if (muted) {
          video.setAttribute('muted', 'muted');
        } else {
          video.removeAttribute('muted');
        }
      });

      iframes.forEach((iframe) => {
        this.setIframeMuted(iframe, muted);
      });
    }

    syncSlideMutedState(slide) {
      this.setSlideMuted(slide, this.isSlideMuted(slide));
    }

    setIframeMuted(iframe, muted) {
      if (!iframe?.contentWindow) return;

      const src = iframe.getAttribute('src') || '';

      if (src.includes('youtube.com')) {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: muted ? 'mute' : 'unMute',
          args: []
        }), '*');
        return;
      }

      if (src.includes('vimeo.com')) {
        iframe.contentWindow.postMessage({
          method: 'setVolume',
          value: muted ? 0 : 1
        }, '*');
      }
    }

    keepPausedVideoFrameVisible(slide) {
      const videoElement = this.getVideoElement(slide);

      if (!videoElement) return;

      videoElement.querySelector('.yg-video-placeholder')?.classList.add('close');
      videoElement.querySelector('.yg-video-iframe-container')?.classList.remove('close');
      slide.classList.add('is-video-active');
    }

    trackSlideVideo(slide, videoElement) {
      const currentVideoTag = this.getCurrentVideoTag(videoElement);

      if (!currentVideoTag) {
        this.setTriggerState(slide, 'playing');
        this.setProgress(slide, 0);
        return;
      }

      this.clearTrackedVideo();
      this.trackedVideo = currentVideoTag;
      this.trackedSlide = slide;

      this.trackedVideo.addEventListener('timeupdate', this.handleTrackedVideoProgress);
      this.trackedVideo.addEventListener('loadedmetadata', this.handleTrackedVideoProgress);
      this.trackedVideo.addEventListener('canplay', this.handleTrackedVideoReady);
      this.trackedVideo.addEventListener('playing', this.handleTrackedVideoReady);
      this.trackedVideo.addEventListener('waiting', this.handleTrackedVideoWaiting);
      this.trackedVideo.addEventListener('stalled', this.handleTrackedVideoWaiting);
      this.trackedVideo.addEventListener('ended', this.handleTrackedVideoEnded);

      if (!this.isDesktopMode() && (this.trackedVideo.paused || this.trackedVideo.readyState < HTMLMediaElement.HAVE_CURRENT_DATA)) {
        this.setTriggerState(slide, 'loading');
      } else {
        this.handleTrackedVideoReady();
      }

      this.handleTrackedVideoProgress();
    }

    clearTrackedVideo() {
      if (!this.trackedVideo) return;

      this.trackedVideo.removeEventListener('timeupdate', this.handleTrackedVideoProgress);
      this.trackedVideo.removeEventListener('loadedmetadata', this.handleTrackedVideoProgress);
      this.trackedVideo.removeEventListener('canplay', this.handleTrackedVideoReady);
      this.trackedVideo.removeEventListener('playing', this.handleTrackedVideoReady);
      this.trackedVideo.removeEventListener('waiting', this.handleTrackedVideoWaiting);
      this.trackedVideo.removeEventListener('stalled', this.handleTrackedVideoWaiting);
      this.trackedVideo.removeEventListener('ended', this.handleTrackedVideoEnded);
      this.trackedVideo = null;
      this.trackedSlide = null;
    }

    handleTrackedVideoReady() {
      if (!this.trackedVideo || !this.trackedSlide) return;

      this.setTriggerState(this.trackedSlide, 'playing');
      this.handleTrackedVideoProgress();
    }

    handleTrackedVideoWaiting() {
      if (!this.trackedVideo || !this.trackedSlide || this.isDesktopMode()) return;

      this.setTriggerState(this.trackedSlide, 'loading');
    }

    handleTrackedVideoProgress() {
      if (!this.trackedVideo || !this.trackedSlide) return;

      const duration = this.trackedVideo.duration;

      if (!duration || !Number.isFinite(duration)) return;

      this.setProgress(this.trackedSlide, Math.min(this.trackedVideo.currentTime / duration, 1));
    }

    handleTrackedVideoEnded() {
      if (!this.trackedSlide) return;

      this.setProgress(this.trackedSlide, 1);

      if (this.isDesktopMode()) {
        this.setTriggerState(this.trackedSlide, 'idle');
        this.trackedSlide.classList.remove('is-video-active');
        this.trackedSlide.classList.remove('is-playing');
        return;
      }

      this.advanceToNextSlide();
    }

    advanceToNextSlide() {
      if (!this.swiper || this.slides.length <= 1) return;

      if (this.swiper.isEnd) {
        this.swiper.slideTo(0);
        return;
      }

      this.swiper.slideNext();
    }

    setTriggerState(slide, state) {
      const triggerButton = slide?.querySelector('.yg-media-grid-video-trigger');

      if (!triggerButton) return;

      triggerButton.dataset.state = state;
    }

    setProgress(slide, progress) {
      const triggerButton = slide?.querySelector('.yg-media-grid-video-trigger');

      if (!triggerButton) return;

      triggerButton.querySelectorAll('.yg-media-grid-video-progress-circle').forEach((circle) => {
        const length = Number(circle.dataset.length || 0) || circle.getTotalLength();
        circle.style.strokeDasharray = `${length}`;
        circle.style.strokeDashoffset = `${length * (1 - progress)}`;
      });
    }
  }

  if (!customElements.get('yg-media-grid-video-list-v2')) {
    customElements.define('yg-media-grid-video-list-v2', YgMediaGridVideoListV2);
  }

  class YgMediaGridCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.marquee = this.querySelector('.yg-media-grid-marquee');
      this.sourceGroup = this.marquee?.querySelector('.yg-media-grid-marquee__group');
      this.cloneTemplate = this.sourceGroup?.nextElementSibling;

      if (!this.marquee || !this.sourceGroup || !this.cloneTemplate) return;

      this.initialized = true;
      this.resizeObserver = new ResizeObserver(() => this.refreshMarquee());
      this.resizeObserver.observe(this);
      this.refreshMarquee();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    refreshMarquee() {
      this.marquee.querySelectorAll('.yg-media-grid-marquee__group').forEach((group, index) => {
        if (index > 1) group.remove();
      });

      const groupWidth = this.sourceGroup.getBoundingClientRect().width;
      const viewportWidth = this.getBoundingClientRect().width;

      if (!groupWidth || !viewportWidth) {
        this.marquee.style.removeProperty('--yg-media-grid-marquee-distance');
        return;
      }

      this.marquee.style.setProperty('--yg-media-grid-marquee-distance', `${groupWidth}px`);

      while (this.marquee.scrollWidth < viewportWidth + groupWidth) {
        this.marquee.append(this.cloneTemplate.cloneNode(true));
      }
    }
  }

  if (!customElements.get('yg-media-grid-carousel')) {
    customElements.define('yg-media-grid-carousel', YgMediaGridCarousel);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-grid-v3"] && !Shopify.designMode) return;
  try {
    
  class YgMediaGridVideoListV3 extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.activeSlide = null;
      this.trackedVideo = null;
      this.trackedSlide = null;
      this.isInViewport = false;
      this.viewportObserver = null;
      this.modalObserver = null;
      this.activeModalIndex = 0;
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.videoMediaQuery = window.matchMedia('(max-width: 999px)');
      this.handleDesktopMediaChange = this.handleDesktopMediaChange.bind(this);
      this.handleSectionLeave = this.handleSectionLeave.bind(this);
      this.handleSlidePointerEnter = this.handleSlidePointerEnter.bind(this);
      this.handleSlidePointerLeave = this.handleSlidePointerLeave.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleModalPrevious = this.handleModalPrevious.bind(this);
      this.handleModalNext = this.handleModalNext.bind(this);
      this.handleModalThumbnailClick = this.handleModalThumbnailClick.bind(this);
      this.handleWindowResize = this.handleWindowResize.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.swiperElement = this.querySelector('.swiper');
      this.videoControls = this.closest('.yg-media-grid-container').querySelector('.yg-media-grid-video-controls');
      this.prevButton = this.closest('.yg-media-grid-container').querySelector('.yg-media-grid-video-nav--prev');
      this.nextButton = this.closest('.yg-media-grid-container').querySelector('.yg-media-grid-video-nav--next');
      this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
      this.triggerButtons = Array.from(this.querySelectorAll('.yg-media-grid-video-trigger'));
      this.updateTriggerWidths();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.updateTriggerWidths();
      });
      this.sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
      this.modal = document.getElementById(`YgMediaGridVideoModal-${this.sectionId}`);
      this.modalPlayer = this.modal?.querySelector('[data-modal-player]') || null;
      this.modalPlayerShell = this.modal?.querySelector('.yg-media-grid-video-modal__player-shell') || null;
      this.modalSource = this.modal?.querySelector('[data-modal-source]') || null;
      this.modalTitle = this.modal?.querySelector('[data-modal-title]') || null;
      this.modalPrevious = this.modal?.querySelector('[data-modal-previous]') || null;
      this.modalNext = this.modal?.querySelector('[data-modal-next]') || null;
      this.modalTemplates = Array.from(this.modal?.querySelectorAll('[data-modal-template]') || []);
      this.modalThumbnails = Array.from(this.modal?.querySelectorAll('[data-modal-thumbnail]') || []);

      this.bindInteractions();
      this.observeModal();
      this.initialized = true;

      if ('IntersectionObserver' in window) {
        this.lazySwiperObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.isIntersecting) {
            this.lazySwiperObserver.disconnect();
            this.lazySwiperObserver = null;
            this.loadSwiperAssets()
              .then(() => {
                this.initSwiper();
                this.setupViewportObserver();
              })
              .catch((error) => {
                console.warn('YG media grid swiper failed to load', error);
              });
          }
        }, { rootMargin: '300px' });
        this.lazySwiperObserver.observe(this);
      } else {
        this.loadSwiperAssets()
          .then(() => {
            this.initSwiper();
            this.setupViewportObserver();
          })
          .catch((error) => {
            console.warn('YG media grid swiper failed to load', error);
          });
      }
    }

    disconnectedCallback() {
      this.unbindInteractions();
      this.teardownViewportObserver();
      if (this.lazySwiperObserver) {
        this.lazySwiperObserver.disconnect();
        this.lazySwiperObserver = null;
      }
      this.stopAllVideos();
      this.resetModalMedia();
      this.modalObserver?.disconnect();
      this.modalObserver = null;
      this.destroySwiper();
      this.modal?.remove();
      this.initialized = false;
    }

    setupViewportObserver() {
      if (this.viewportObserver || typeof IntersectionObserver === 'undefined') return;

      this.viewportObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.5
      });

      this.viewportObserver.observe(this);
    }

    teardownViewportObserver() {
      if (!this.viewportObserver) return;

      this.viewportObserver.disconnect();
      this.viewportObserver = null;
    }

    handleIntersection(entries) {
      const entry = entries[0];

      if (!entry) return;

      this.isInViewport = entry.isIntersecting;

      if (this.isDesktopMode()) return;

      if (this.isInViewport) {
        this.playActiveMobileSlide();
      } else {
        this.stopAllVideos();
      }
    }

    isDesktopMode() {
      return this.desktopMediaQuery.matches;
    }

    loadSwiperAssets() {
      if (window.loadMondoSwiper) {
        return window.loadMondoSwiper();
      }

      if (window.Swiper) {
        return Promise.resolve();
      }

      if (window.__ygMediaGridSwiperPromise) {
        return window.__ygMediaGridSwiperPromise;
      }

      const assets = window.themeAssetUrls || {};

      if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = assets.swiperCss;
        document.head.appendChild(stylesheet);
      }

      window.__ygMediaGridSwiperPromise = new Promise((resolve, reject) => {
        if (!assets.swiperJs) {
          reject(new Error('Missing Swiper asset URL'));
          return;
        }

        const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);

        if (existingScript) {
          if (window.Swiper) {
            resolve();
            return;
          }

          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.defer = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return window.__ygMediaGridSwiperPromise;
    }

    initSwiper() {
      if (!window.Swiper || !this.swiperElement || this.swiper) return;

      const hasMultipleSlides = this.slides.length > 1;

      this.swiper = new window.Swiper(this.swiperElement, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 450,
        // rewind: true,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        allowTouchMove: hasMultipleSlides,
        breakpoints: {
          900: {
            slidesPerView: 'auto',
            spaceBetween: 24,
            allowTouchMove: hasMultipleSlides
          },
          450: {
            slidesPerView: 1.8,
            spaceBetween: 16,
            allowTouchMove: hasMultipleSlides
          }
        },
        navigation: {
          prevEl: this.prevButton,
          nextEl: this.nextButton
        },
        on: {
          init: (swiper) => {
            this.updateVideoControls(swiper);
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          },
          lock: (swiper) => {
            this.updateVideoControls(swiper);
          },
          unlock: (swiper) => {
            this.updateVideoControls(swiper);
          },
          slideChangeTransitionStart: () => {
            this.stopAllVideos();
          },
          slideChangeTransitionEnd: () => {
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          }
        }
      });

      this.updateVideoControls(this.swiper);
    }

    updateVideoControls(swiper = this.swiper) {
      if (!this.videoControls) return;

      this.videoControls.hidden = !swiper || swiper.isLocked || this.slides.length <= 1;
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.updateVideoControls();
    }

    bindInteractions() {
      this.slides.forEach((slide) => {
        slide.addEventListener('pointerenter', this.handleSlidePointerEnter);
        slide.addEventListener('pointerleave', this.handleSlidePointerLeave);
      });

      this.triggerButtons.forEach((button) => {
        button.addEventListener('click', this.handleTriggerClick);
      });

      this.modalPrevious?.addEventListener('click', this.handleModalPrevious);
      this.modalNext?.addEventListener('click', this.handleModalNext);
      this.modalThumbnails.forEach((button) => button.addEventListener('click', this.handleModalThumbnailClick));
      window.addEventListener('resize', this.handleWindowResize);

      this.addEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.addListener(this.handleDesktopMediaChange);
      }
    }

    updateTriggerWidths() {
      this.triggerButtons.forEach((button) => {
        const label = button.querySelector('.yg-media-grid-video-trigger-label');
        if (!label) return;

        const labelWidth = Math.ceil(label.scrollWidth);
        const expandedWidth = Math.max(112, labelWidth + 57);
        button.style.setProperty('--video-trigger-label-width', `${labelWidth}px`);
        button.style.setProperty('--video-trigger-expanded-width', `${expandedWidth}px`);
      });
    }

    unbindInteractions() {
      this.slides.forEach((slide) => {
        slide.removeEventListener('pointerenter', this.handleSlidePointerEnter);
        slide.removeEventListener('pointerleave', this.handleSlidePointerLeave);
      });

      this.triggerButtons.forEach((button) => {
        button.removeEventListener('click', this.handleTriggerClick);
      });

      this.modalPrevious?.removeEventListener('click', this.handleModalPrevious);
      this.modalNext?.removeEventListener('click', this.handleModalNext);
      this.modalThumbnails.forEach((button) => button.removeEventListener('click', this.handleModalThumbnailClick));
      window.removeEventListener('resize', this.handleWindowResize);

      this.removeEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.removeListener(this.handleDesktopMediaChange);
      }
    }

    handleDesktopMediaChange() {
      this.stopAllVideos();
      if (this.modal?.hasAttribute('open')) {
        this.renderModalVideo(this.activeModalIndex);
      }

      if (this.swiper) {
        this.swiper.params.allowTouchMove = !this.isDesktopMode() && this.slides.length > 1;
        this.swiper.update();
      }

      if (!this.isDesktopMode() && this.isInViewport) {
        this.playActiveMobileSlide();
      }
    }

    handleSectionLeave() {
      if (!this.isDesktopMode()) return;

      this.stopAllVideos();
    }

    handleSlidePointerEnter(event) {
      if (!this.isDesktopMode()) return;

      const slide = event.currentTarget;
      this.playSlide(slide);
    }

    handleSlidePointerLeave(event) {
      if (!this.isDesktopMode()) return;

      this.stopSlideVideo(event.currentTarget);
    }

    handleTriggerClick(event) {
      event.preventDefault();
      const triggerButton = event.currentTarget;
      event.stopPropagation();
      const modalIndex = Number(triggerButton.dataset.modalIndex || 0);

      this.stopAllVideos();
      this.activeModalIndex = modalIndex;
      this.renderModalVideo(modalIndex);
      this.modal?.show(triggerButton);
    }

    getActiveSlide() {
      if (this.swiper) {
        return this.swiper.slides[this.swiper.activeIndex] || this.slides[0] || null;
      }

      return this.slides[0] || null;
    }

    playActiveMobileSlide() {
      if (this.isDesktopMode() || !this.isInViewport) return;

      const activeSlide = this.getActiveSlide();

      if (!activeSlide) return;

      this.playSlide(activeSlide);
    }

    playSlide(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);

      if (!videoElement) return;

      this.stopAllVideos(slide);
      this.activeSlide = slide;
      slide.classList.add('is-preview-playing');

      if (typeof videoElement.playVideo === 'function') {
        videoElement.playVideo();
        this.enforcePreviewState(videoElement);
        return;
      }

      window.customElements.whenDefined('yg-video').then(() => {
        if (!this.isConnected || this.activeSlide !== slide) return;

        videoElement.playVideo?.();
        this.enforcePreviewState(videoElement);
      });
    }

    stopSlideVideo(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);

      if (videoElement && typeof videoElement.pauseVideo === 'function') {
        videoElement.pauseVideo();
      } else if (videoElement) {
        window.customElements.whenDefined('yg-video').then(() => {
          if (!this.isConnected) return;
          videoElement.pauseVideo?.();
        });
      }

      videoElement?.querySelectorAll('video').forEach((video) => {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
          return;
        }
      });
      slide.classList.remove('is-preview-playing');

      if (this.activeSlide === slide) {
        this.activeSlide = null;
      }
    }

    stopAllVideos(exceptSlide = null) {
      this.slides.forEach((slide) => {
        if (exceptSlide && slide === exceptSlide) return;
        this.stopSlideVideo(slide);
      });

      if (!exceptSlide) {
        this.activeSlide = null;
      }
    }

    enforcePreviewState(videoElement) {
      videoElement.querySelectorAll('video').forEach((video) => {
        video.muted = false;
        video.loop = true;
        video.removeAttribute('muted');
        video.setAttribute('loop', 'loop');
      });
    }

    observeModal() {
      if (!this.modal || this.modalObserver) return;

      this.modalObserver = new MutationObserver(() => {
        if (this.modal.hasAttribute('open')) {
          this.updateModalNavigation();
          this.playModalVideo();
        } else {
          this.resetModalMedia();
          if (!this.isDesktopMode() && this.isInViewport) {
            this.playActiveMobileSlide();
          }
        }
      });
      this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
    }

    handleModalPrevious() {
      if (this.activeModalIndex <= 0) return;
      this.renderModalVideo(this.activeModalIndex - 1);
    }

    handleModalNext() {
      if (this.activeModalIndex >= this.modalTemplates.length - 1) return;
      this.renderModalVideo(this.activeModalIndex + 1);
    }

    handleModalThumbnailClick(event) {
      const modalIndex = Number(event.currentTarget.dataset.modalIndex || 0);
      this.renderModalVideo(modalIndex);
    }

    handleWindowResize() {
      if (!this.modal?.hasAttribute('open')) return;

      const template = this.modalTemplates.find(
        (item) => Number(item.dataset.modalIndex) === this.activeModalIndex
      );
      if (!template) return;

      this.applyModalAspectRatio(this.getModalAspectRatio(template));
    }

    getModalAspectRatio(template) {
      const isMobile = this.videoMediaQuery.matches;
      const isYoutube = isMobile
        ? template.dataset.youtubeMobile === 'true'
        : template.dataset.youtubeDesktop === 'true';

      if (isYoutube) return 16 / 9;

      const aspectRatio = isMobile ? template.dataset.aspectMobile : template.dataset.aspectDesktop;
      return Number(aspectRatio) || 1.777777;
    }

    renderModalVideo(index) {
      const template = this.modalTemplates.find((item) => Number(item.dataset.modalIndex) === index);
      if (!template || !this.modalSource || !this.modalPlayer) return;

      this.resetModalMedia();
      this.activeModalIndex = index;
      this.modalSource.appendChild(template.content.cloneNode(true));

      this.applyModalAspectRatio(this.getModalAspectRatio(template));

      if (this.modalTitle) {
        this.modalTitle.textContent = template.dataset.title || '';
        this.modalTitle.hidden = !template.dataset.title;
      }

      this.updateModalNavigation();
      if (this.modal?.hasAttribute('open')) {
        this.playModalVideo();
      }
    }

    playModalVideo() {
      const modalVideo = this.modalSource?.querySelector('yg-video');
      if (!modalVideo) return;

      window.customElements.whenDefined('yg-video').then(() => {
        if (!this.modal?.hasAttribute('open') || !modalVideo.isConnected) return;

        modalVideo.playVideo?.();
        modalVideo.querySelectorAll('iframe').forEach((iframe) => {
          const source = iframe.getAttribute('src');
          if (!source || !source.includes('player.vimeo.com')) return;

          const url = new URL(source);
          url.searchParams.set('background', '0');
          url.searchParams.set('controls', '1');
          url.searchParams.set('autopause', '0');
          iframe.setAttribute('src', url.toString());
        });
        modalVideo.querySelectorAll('video').forEach((video) => {
          video.controls = true;
          video.muted = false;
          video.loop = true;
          video.setAttribute('controls', 'controls');
          video.removeAttribute('muted');
          video.setAttribute('loop', 'loop');
          video.addEventListener('loadedmetadata', () => this.syncModalAspectRatio(video), { once: true });
          if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
            this.syncModalAspectRatio(video);
          }
          video.play().catch(() => {});
        });
      });
    }

    syncModalAspectRatio(video) {
      if (!video.videoWidth || !video.videoHeight || !this.modalPlayer) return;
      this.applyModalAspectRatio(video.videoWidth / video.videoHeight);
    }

    applyModalAspectRatio(aspectRatio) {
      if (!this.modalPlayer || !this.modalPlayerShell || !aspectRatio) return;

      this.activeModalAspectRatio = aspectRatio;
      this.modalPlayer.style.setProperty('--yg-media-grid-modal-aspect-ratio', `${aspectRatio}`);

      const horizontalPadding = window.innerWidth < 750 ? 40 : 160;
      const verticalAllowance = window.innerWidth < 750 ? 190 : 230;
      const maxWidth = Math.max(0, Math.min(990, window.innerWidth - horizontalPadding));
      const maxHeight = Math.max(0, window.innerHeight - verticalAllowance);
      const fittedWidth = Math.min(maxWidth, maxHeight * aspectRatio);
      this.modalPlayerShell.style.width = `${fittedWidth}px`;
    }

    updateModalNavigation() {
      this.modalPrevious?.toggleAttribute('disabled', this.activeModalIndex <= 0);
      this.modalNext?.toggleAttribute('disabled', this.activeModalIndex >= this.modalTemplates.length - 1);

      this.modalThumbnails.forEach((button) => {
        const isActive = Number(button.dataset.modalIndex) === this.activeModalIndex;
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive && this.modal?.hasAttribute('open')) {
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }

    resetModalMedia() {
      if (!this.modalSource) return;

      this.modalSource.querySelectorAll('yg-video').forEach((video) => video.pauseVideo?.());
      this.modalSource.querySelectorAll('video').forEach((video) => {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
          return;
        }
      });
      this.modalSource.replaceChildren();
    }

    getVideoElement(slide) {
      return slide?.querySelector('yg-video') || null;
    }

  }

  if (!customElements.get('yg-media-grid-video-listv3')) {
    customElements.define('yg-media-grid-video-listv3', YgMediaGridVideoListV3);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-grid"] && !Shopify.designMode) return;
  try {
    
  class YgMediaGridVideoListV1 extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.activeSlide = null;
      this.trackedVideo = null;
      this.trackedSlide = null;
      this.isInViewport = false;
      this.viewportObserver = null;
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.handleDesktopMediaChange = this.handleDesktopMediaChange.bind(this);
      this.handleSectionLeave = this.handleSectionLeave.bind(this);
      this.handleSlidePointerEnter = this.handleSlidePointerEnter.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleMuteClick = this.handleMuteClick.bind(this);
      this.handleTrackedVideoProgress = this.handleTrackedVideoProgress.bind(this);
      this.handleTrackedVideoReady = this.handleTrackedVideoReady.bind(this);
      this.handleTrackedVideoWaiting = this.handleTrackedVideoWaiting.bind(this);
      this.handleTrackedVideoEnded = this.handleTrackedVideoEnded.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.swiperElement = this.querySelector('.swiper');
      this.prevButton = this.querySelector('.yg-media-grid-video-nav--prev');
      this.nextButton = this.querySelector('.yg-media-grid-video-nav--next');
      this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
      this.triggerButtons = Array.from(this.querySelectorAll('.yg-media-grid-video-trigger'));
      this.muteButtons = Array.from(this.querySelectorAll('.yg-mute'));

      this.initializeProgressCircles();
      this.bindInteractions();

      if ('IntersectionObserver' in window) {
        this.lazySwiperObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry && entry.isIntersecting) {
            this.lazySwiperObserver.disconnect();
            this.lazySwiperObserver = null;
            this.loadSwiperAssets()
              .then(() => {
                this.initSwiper();
                this.setupViewportObserver();
              })
              .catch((error) => {
                console.warn('YG media grid swiper failed to load', error);
              });
          }
        }, { rootMargin: '300px' });
        this.lazySwiperObserver.observe(this);
      } else {
        this.initialized = true;
        this.loadSwiperAssets()
          .then(() => {
            this.initSwiper();
            this.setupViewportObserver();
          })
          .catch((error) => {
            console.warn('YG media grid swiper failed to load', error);
          });
      }
    }

    disconnectedCallback() {
      this.unbindInteractions();
      this.teardownViewportObserver();
      if (this.lazySwiperObserver) {
        this.lazySwiperObserver.disconnect();
        this.lazySwiperObserver = null;
      }
      this.clearTrackedVideo();
      this.stopAllVideos();
      this.destroySwiper();
      this.initialized = false;
    }

    setupViewportObserver() {
      if (this.viewportObserver || typeof IntersectionObserver === 'undefined') return;

      this.viewportObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.5
      });

      this.viewportObserver.observe(this);
    }

    teardownViewportObserver() {
      if (!this.viewportObserver) return;

      this.viewportObserver.disconnect();
      this.viewportObserver = null;
    }

    handleIntersection(entries) {
      const entry = entries[0];

      if (!entry) return;

      this.isInViewport = entry.isIntersecting;

      if (this.isDesktopMode()) return;

      if (this.isInViewport) {
        this.playActiveMobileSlide();
      } else {
        this.clearTrackedVideo();
        this.stopAllVideos();
      }
    }

    isDesktopMode() {
      return this.desktopMediaQuery.matches;
    }

    loadSwiperAssets() {
      if (window.loadMondoSwiper) {
        return window.loadMondoSwiper();
      }

      if (window.Swiper) {
        return Promise.resolve();
      }

      if (window.__ygMediaGridSwiperPromise) {
        return window.__ygMediaGridSwiperPromise;
      }

      const assets = window.themeAssetUrls || {};

      if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = assets.swiperCss;
        document.head.appendChild(stylesheet);
      }

      window.__ygMediaGridSwiperPromise = new Promise((resolve, reject) => {
        if (!assets.swiperJs) {
          reject(new Error('Missing Swiper asset URL'));
          return;
        }

        const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);

        if (existingScript) {
          if (window.Swiper) {
            resolve();
            return;
          }

          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.defer = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return window.__ygMediaGridSwiperPromise;
    }

    initSwiper() {
      if (!window.Swiper || !this.swiperElement || this.swiper) return;

      const hasMultipleSlides = this.slides.length > 1;

      this.swiper = new window.Swiper(this.swiperElement, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        speed: 450,
        // rewind: true,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        allowTouchMove: hasMultipleSlides,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 28,
            allowTouchMove: hasMultipleSlides
          },
          450: {
            slidesPerView: 1.5,
            spaceBetween: 20,
            allowTouchMove: hasMultipleSlides
          }
        },
        navigation: hasMultipleSlides
          ? {
              prevEl: this.prevButton,
              nextEl: this.nextButton
            }
          : false,
        on: {
          init: () => {
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          },
          slideChangeTransitionStart: () => {
            this.stopAllVideos();
          },
          slideChangeTransitionEnd: () => {
            if (!this.isDesktopMode() && this.isInViewport) {
              this.playActiveMobileSlide();
            }
          }
        }
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    bindInteractions() {
      this.slides.forEach((slide) => {
        slide.addEventListener('pointerenter', this.handleSlidePointerEnter);
      });

      this.triggerButtons.forEach((button) => {
        button.addEventListener('click', this.handleTriggerClick);
      });

      this.muteButtons.forEach((button) => {
        button.addEventListener('click', this.handleMuteClick);
      });

      this.addEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.addListener(this.handleDesktopMediaChange);
      }
    }

    unbindInteractions() {
      this.slides.forEach((slide) => {
        slide.removeEventListener('pointerenter', this.handleSlidePointerEnter);
      });

      this.triggerButtons.forEach((button) => {
        button.removeEventListener('click', this.handleTriggerClick);
      });

      this.muteButtons.forEach((button) => {
        button.removeEventListener('click', this.handleMuteClick);
      });

      this.removeEventListener('mouseleave', this.handleSectionLeave);

      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.handleDesktopMediaChange);
      } else {
        this.desktopMediaQuery.removeListener(this.handleDesktopMediaChange);
      }
    }

    initializeProgressCircles() {
      this.querySelectorAll('.yg-media-grid-video-progress-circle').forEach((circle) => {
        const length = circle.getTotalLength();
        circle.dataset.length = `${length}`;
        circle.style.strokeDasharray = `${length}`;
        circle.style.strokeDashoffset = `${length}`;
      });
    }

    handleDesktopMediaChange() {
      this.clearTrackedVideo();
      this.stopAllVideos();

      if (this.swiper) {
        this.swiper.params.allowTouchMove = !this.isDesktopMode() && this.slides.length > 1;
        this.swiper.update();
      }

      if (!this.isDesktopMode() && this.isInViewport) {
        this.playActiveMobileSlide();
      }
    }

    handleSectionLeave() {
      if (!this.isDesktopMode()) return;

      this.clearTrackedVideo();
      this.stopAllVideos();
    }

    handleSlidePointerEnter(event) {
      if (!this.isDesktopMode()) return;

      const slide = event.currentTarget;
      this.playSlide(slide);
    }

    handleTriggerClick(event) {
      event.preventDefault();
      const triggerButton = event.currentTarget;
      const slide = triggerButton.closest('.swiper-slide');

      if (!slide) return;

      const slideIndex = this.slides.indexOf(slide);

      if (!this.isDesktopMode() && this.swiper && slideIndex !== this.swiper.activeIndex) {
        this.swiper.slideTo(slideIndex);
        return;
      }

      if (triggerButton.dataset.state === 'playing') {
        this.pauseSlide(slide);
        return;
      }

      this.playSlide(slide);
    }

    handleMuteClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      const slide = button.closest('.swiper-slide');
      const nextMuted = button.dataset.muted !== 'true';

      this.setSlideMuted(slide, nextMuted);
    }

    getActiveSlide() {
      if (this.swiper) {
        return this.swiper.slides[this.swiper.activeIndex] || this.slides[0] || null;
      }

      return this.slides[0] || null;
    }

    playActiveMobileSlide() {
      if (this.isDesktopMode() || !this.isInViewport) return;

      const activeSlide = this.getActiveSlide();

      if (!activeSlide) return;

      this.playSlide(activeSlide);
    }

    playSlide(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);

      if (!videoElement) return;

      this.clearTrackedVideo();
      this.stopAllVideos(slide);
      this.activeSlide = slide;
      slide.classList.add('is-video-active');
      slide.classList.add('is-playing');
      this.setTriggerState(slide, this.isDesktopMode() ? 'playing' : 'loading');

      if (typeof videoElement.playVideo === 'function') {
        videoElement.playVideo();
        this.syncSlideMutedState(slide);
        this.trackSlideVideo(slide, videoElement);
        return;
      }

      window.customElements.whenDefined('yg-video').then(() => {
        if (!this.isConnected || this.activeSlide !== slide) return;

        videoElement.playVideo?.();
        this.syncSlideMutedState(slide);
        this.trackSlideVideo(slide, videoElement);
      });
    }

    pauseSlide(slide) {
      if (!slide) return;

      const videoElement = this.getVideoElement(slide);
      const currentVideoTag = videoElement ? this.getCurrentVideoTag(videoElement) : null;

      if (currentVideoTag) {
        currentVideoTag.pause();
      } else if (videoElement && typeof videoElement.pauseVideo === 'function') {
        videoElement.pauseVideo();
      } else if (videoElement) {
        window.customElements.whenDefined('yg-video').then(() => {
          if (!this.isConnected || this.activeSlide !== slide) return;
          videoElement.pauseVideo?.();
        });
      }

      this.clearTrackedVideo();
      this.activeSlide = null;
      this.setTriggerState(slide, 'paused');
      this.keepPausedVideoFrameVisible(slide);
      slide.classList.remove('is-playing');
    }

    stopAllVideos(exceptSlide = null) {
      this.slides.forEach((slide) => {
        if (exceptSlide && slide === exceptSlide) return;

        const videoElement = this.getVideoElement(slide);

        if (videoElement) {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          } else {
            window.customElements.whenDefined('yg-video').then(() => {
              if (!this.isConnected) return;
              videoElement.pauseVideo?.();
            });
          }
        }

        this.setTriggerState(slide, 'idle');
        this.setProgress(slide, 0);
        slide.classList.remove('is-video-active');
        slide.classList.remove('is-playing');
      });

      if (!exceptSlide) {
        this.activeSlide = null;
      }
    }

    getVideoElement(slide) {
      return slide?.querySelector('yg-video') || null;
    }

    getCurrentVideoTag(videoElement) {
      const videos = Array.from(videoElement.querySelectorAll('video.yg-video-iframe'));

      return videos.find((video) => {
        if (this.isDesktopMode()) {
          return !video.classList.contains('hide-pc');
        }

      return !video.classList.contains('hide-mobile');
      }) || null;
    }

    getMuteButton(slide) {
      return slide?.querySelector('.yg-mute') || null;
    }

    isSlideMuted(slide) {
      return this.getMuteButton(slide)?.dataset.muted === 'true';
    }

    setSlideMuted(slide, muted) {
      const button = this.getMuteButton(slide);

      if (!button) return;

      button.dataset.muted = muted ? 'true' : 'false';
      button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');

      const videoElement = this.getVideoElement(slide);
      const videos = videoElement ? Array.from(videoElement.querySelectorAll('video.yg-video-iframe')) : [];
      const iframes = videoElement ? Array.from(videoElement.querySelectorAll('iframe.yg-video-iframe')) : [];

      videos.forEach((video) => {
        video.muted = muted;
        if (muted) {
          video.setAttribute('muted', 'muted');
        } else {
          video.removeAttribute('muted');
        }
      });

      iframes.forEach((iframe) => {
        this.setIframeMuted(iframe, muted);
      });
    }

    syncSlideMutedState(slide) {
      this.setSlideMuted(slide, this.isSlideMuted(slide));
    }

    setIframeMuted(iframe, muted) {
      if (!iframe?.contentWindow) return;

      const src = iframe.getAttribute('src') || '';

      if (src.includes('youtube.com')) {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: muted ? 'mute' : 'unMute',
          args: []
        }), '*');
        return;
      }

      if (src.includes('vimeo.com')) {
        iframe.contentWindow.postMessage({
          method: 'setVolume',
          value: muted ? 0 : 1
        }, '*');
      }
    }

    keepPausedVideoFrameVisible(slide) {
      const videoElement = this.getVideoElement(slide);

      if (!videoElement) return;

      videoElement.querySelector('.yg-video-placeholder')?.classList.add('close');
      videoElement.querySelector('.yg-video-iframe-container')?.classList.remove('close');
      slide.classList.add('is-video-active');
    }

    trackSlideVideo(slide, videoElement) {
      const currentVideoTag = this.getCurrentVideoTag(videoElement);

      if (!currentVideoTag) {
        this.setTriggerState(slide, 'playing');
        this.setProgress(slide, 0);
        return;
      }

      this.clearTrackedVideo();
      this.trackedVideo = currentVideoTag;
      this.trackedSlide = slide;

      this.trackedVideo.addEventListener('timeupdate', this.handleTrackedVideoProgress);
      this.trackedVideo.addEventListener('loadedmetadata', this.handleTrackedVideoProgress);
      this.trackedVideo.addEventListener('canplay', this.handleTrackedVideoReady);
      this.trackedVideo.addEventListener('playing', this.handleTrackedVideoReady);
      this.trackedVideo.addEventListener('waiting', this.handleTrackedVideoWaiting);
      this.trackedVideo.addEventListener('stalled', this.handleTrackedVideoWaiting);
      this.trackedVideo.addEventListener('ended', this.handleTrackedVideoEnded);

      if (!this.isDesktopMode() && (this.trackedVideo.paused || this.trackedVideo.readyState < HTMLMediaElement.HAVE_CURRENT_DATA)) {
        this.setTriggerState(slide, 'loading');
      } else {
        this.handleTrackedVideoReady();
      }

      this.handleTrackedVideoProgress();
    }

    clearTrackedVideo() {
      if (!this.trackedVideo) return;

      this.trackedVideo.removeEventListener('timeupdate', this.handleTrackedVideoProgress);
      this.trackedVideo.removeEventListener('loadedmetadata', this.handleTrackedVideoProgress);
      this.trackedVideo.removeEventListener('canplay', this.handleTrackedVideoReady);
      this.trackedVideo.removeEventListener('playing', this.handleTrackedVideoReady);
      this.trackedVideo.removeEventListener('waiting', this.handleTrackedVideoWaiting);
      this.trackedVideo.removeEventListener('stalled', this.handleTrackedVideoWaiting);
      this.trackedVideo.removeEventListener('ended', this.handleTrackedVideoEnded);
      this.trackedVideo = null;
      this.trackedSlide = null;
    }

    handleTrackedVideoReady() {
      if (!this.trackedVideo || !this.trackedSlide) return;

      this.setTriggerState(this.trackedSlide, 'playing');
      this.handleTrackedVideoProgress();
    }

    handleTrackedVideoWaiting() {
      if (!this.trackedVideo || !this.trackedSlide || this.isDesktopMode()) return;

      this.setTriggerState(this.trackedSlide, 'loading');
    }

    handleTrackedVideoProgress() {
      if (!this.trackedVideo || !this.trackedSlide) return;

      const duration = this.trackedVideo.duration;

      if (!duration || !Number.isFinite(duration)) return;

      this.setProgress(this.trackedSlide, Math.min(this.trackedVideo.currentTime / duration, 1));
    }

    handleTrackedVideoEnded() {
      if (!this.trackedSlide) return;

      this.setProgress(this.trackedSlide, 1);

      if (this.isDesktopMode()) {
        this.setTriggerState(this.trackedSlide, 'idle');
        this.trackedSlide.classList.remove('is-video-active');
        this.trackedSlide.classList.remove('is-playing');
        return;
      }

      this.advanceToNextSlide();
    }

    advanceToNextSlide() {
      if (!this.swiper || this.slides.length <= 1) return;

      if (this.swiper.isEnd) {
        this.swiper.slideTo(0);
        return;
      }

      this.swiper.slideNext();
    }

    setTriggerState(slide, state) {
      const triggerButton = slide?.querySelector('.yg-media-grid-video-trigger');

      if (!triggerButton) return;

      triggerButton.dataset.state = state;
    }

    setProgress(slide, progress) {
      const triggerButton = slide?.querySelector('.yg-media-grid-video-trigger');

      if (!triggerButton) return;

      triggerButton.querySelectorAll('.yg-media-grid-video-progress-circle').forEach((circle) => {
        const length = Number(circle.dataset.length || 0) || circle.getTotalLength();
        circle.style.strokeDasharray = `${length}`;
        circle.style.strokeDashoffset = `${length * (1 - progress)}`;
      });
    }
  }
  
  if (!customElements.get('yg-media-grid-video-list-v1')) {
    customElements.define('yg-media-grid-video-list-v1', YgMediaGridVideoListV1);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-number-grid"] && !Shopify.designMode) return;
  try {
    
  class YGNumberGrid extends HTMLElement {
    connectedCallback() {
      if (this.isSetup) return;

      this.isSetup = true;
      this.duration = 1200;
      this.counters = Array.from(this.querySelectorAll('[data-yg-number]'))
        .map((element) => this.createCounter(element))
        .filter(Boolean);

      if (!this.counters.length) return;
      if (this.hasAnimated) {
        this.renderFinalValues();
        return;
      }

      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const target = this.querySelector('.yg-number-grid__item');

      if (reduceMotion || !target || !('IntersectionObserver' in window)) {
        this.hasAnimated = true;
        this.renderFinalValues();
        return;
      }

      this.counters.forEach((counter) => this.renderCounter(counter, 0));
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.hasAnimated = true;
          this.observer?.disconnect();
          this.animationFrame = window.requestAnimationFrame((timestamp) => this.animate(timestamp));
        },
        { threshold: 0.2 }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      this.isSetup = false;
      this.observer?.disconnect();
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.observer = null;
      this.animationFrame = null;
    }

    createCounter(element) {
      const rawValue = element.dataset.ygNumber?.trim() || '';
      const match = rawValue.match(/-?\d[\d,]*(?:\.\d+)?/);
      if (!match) return null;

      const numericText = match[0];
      const numericValue = Number(numericText.replaceAll(',', ''));
      if (!Number.isFinite(numericValue)) return null;

      const decimalPart = numericText.split('.')[1];
      return {
        element,
        value: numericValue,
        prefix: rawValue.slice(0, match.index),
        suffix: rawValue.slice((match.index || 0) + numericText.length),
        decimals: decimalPart ? decimalPart.length : 0,
        useGrouping: numericText.includes(','),
      };
    }

    formatValue(counter, value) {
      const fixedValue = value.toFixed(counter.decimals);
      if (!counter.useGrouping) return fixedValue;

      const parts = fixedValue.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    renderCounter(counter, value) {
      counter.element.textContent = `${counter.prefix}${this.formatValue(counter, value)}${counter.suffix}`;
    }

    renderFinalValues() {
      this.counters.forEach((counter) => this.renderCounter(counter, counter.value));
    }

    animate(timestamp) {
      if (!this.startTime) this.startTime = timestamp;

      const progress = Math.min((timestamp - this.startTime) / this.duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      this.counters.forEach((counter) => this.renderCounter(counter, counter.value * easedProgress));

      if (progress < 1) {
        this.animationFrame = window.requestAnimationFrame((nextTimestamp) => this.animate(nextTimestamp));
        return;
      }

      this.renderFinalValues();
      this.animationFrame = null;
    }
  }

  if (!window.customElements.get('yg-number-grid')) {
    window.customElements.define('yg-number-grid', YGNumberGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!window.YGProductDetails) {
    window.YGProductDetails = {
      cleanSegment(segment) {
        const container = document.createElement('div');
        container.innerHTML = segment.trim();
        container.querySelectorAll('p, div').forEach((element) => {
          if (!element.textContent.trim() && !element.querySelector('img, svg, br')) {
            element.remove();
          }
        });

        if (container.children.length === 1 && container.firstElementChild.tagName === 'P') {
          return container.firstElementChild.innerHTML.trim();
        }

        return container.innerHTML.trim();
      },

      buildRows(content) {
        if (content.dataset.productDetailsParsed === 'true') return;
        const source = content.querySelector('[data-product-details-source]');
        const rowsContainer = content.querySelector('[data-product-details-rows]');
        if (!source || !rowsContainer || !source.innerHTML.includes('||')) return;

        const rows = [];
        source.innerHTML.split('||').forEach((segment) => {
          const segmentContainer = document.createElement('div');
          segmentContainer.innerHTML = segment;
          const labelElements = Array.from(segmentContainer.querySelectorAll('strong, b'));
          const label = labelElements.map((element) => element.textContent.trim()).filter(Boolean).join(' ');
          labelElements.forEach((element) => element.remove());
          const description = this.cleanSegment(segmentContainer.innerHTML);
          if (!label && !description) return;
          rows.push({ label, description });
        });

        if (rows.length === 0) return;
        const fragment = document.createDocumentFragment();
        rows.forEach((row) => {
          const rowElement = document.createElement('div');
          const labelElement = document.createElement('div');
          const descriptionElement = document.createElement('div');
          rowElement.className = 'yg-product-details-content-row';
          labelElement.className = 'yg-product-details-content-label';
          descriptionElement.className = 'yg-product-details-content-description';
          labelElement.textContent = row.label;
          descriptionElement.innerHTML = row.description;
          rowElement.append(labelElement, descriptionElement);
          fragment.append(rowElement);
        });

        rowsContainer.replaceChildren(fragment);
        content.classList.add('is-enhanced');
        content.dataset.productDetailsParsed = 'true';
      },

      initialize(root) {
        if (root.dataset.productDetailsInitialized === 'true') return;
        root.querySelectorAll('[data-product-details-content]').forEach((content) => this.buildRows(content));
        const button = root.querySelector('.yg-product-details-button');
        const hiddenContent = root.querySelector('.yg-product-details-hide');
        const enableClickPositioning = root.dataset.enableClickPositioning === 'true';
        let contentAnimation = null;

        const setHiddenContentExpanded = (isExpanded) => {
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const currentStyles = window.getComputedStyle(hiddenContent);
          const currentHeight = hiddenContent.hidden ? 0 : hiddenContent.getBoundingClientRect().height;
          const currentMarginTop = hiddenContent.hidden ? 0 : Number.parseFloat(currentStyles.marginTop) || 0;
          const currentOpacity = hiddenContent.hidden ? 0 : Number.parseFloat(currentStyles.opacity) || 1;

          contentAnimation?.cancel();

          if (isExpanded) {
            hiddenContent.hidden = false;
          }

          if (prefersReducedMotion || typeof hiddenContent.animate !== 'function') {
            hiddenContent.hidden = !isExpanded;
            return;
          }

          const expandedMarginTop = Number.parseFloat(window.getComputedStyle(hiddenContent).marginTop) || 0;
          const targetHeight = isExpanded ? hiddenContent.scrollHeight : 0;
          const targetMarginTop = isExpanded ? expandedMarginTop : 0;
          const targetOpacity = isExpanded ? 1 : 0;

          hiddenContent.style.overflow = 'hidden';
          contentAnimation = hiddenContent.animate(
            [
              {
                height: String(currentHeight) + 'px',
                marginTop: String(currentMarginTop) + 'px',
                opacity: currentOpacity,
              },
              {
                height: String(targetHeight) + 'px',
                marginTop: String(targetMarginTop) + 'px',
                opacity: targetOpacity,
              },
            ],
            {
              duration: 360,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'both',
            }
          );

          const activeAnimation = contentAnimation;
          activeAnimation.addEventListener(
            'finish',
            () => {
              if (!isExpanded) {
                hiddenContent.hidden = true;
              }
              activeAnimation.cancel();
              hiddenContent.style.removeProperty('overflow');
              if (contentAnimation === activeAnimation) {
                contentAnimation = null;
              }
            },
            { once: true }
          );
        };

        if (button && hiddenContent) {
          button.addEventListener('click', () => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;
            const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

            setHiddenContentExpanded(nextExpanded);
            button.setAttribute('aria-expanded', String(nextExpanded));
            button.classList.toggle('is-expanded', nextExpanded);
            const text = button.querySelector('[data-product-details-button-text]');
            if (text) {
              text.textContent = nextExpanded ? button.dataset.lessText : button.dataset.moreText;
            }

            window.requestAnimationFrame(() => {
              if (enableClickPositioning && !nextExpanded) {
                root.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
              }
            });
          });
        }

        root.addEventListener('click', (event) => {
          const dropdownTitle = event.target.closest?.('.yg-dropdown-title-container');
          if (!dropdownTitle || !root.contains(dropdownTitle)) return;
          if (!enableClickPositioning) return;

          const dropdown = dropdownTitle.closest('yg-dropdown');
          if (!dropdown) return;

          window.requestAnimationFrame(() => {
            if (!dropdown.hasAttribute('open')) return;

            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';
            const scrollTitleIntoView = () => {
              const stickyNavigation = document.querySelector('.shopify-section.yg-anchor-tab.is-visible');
              const stickyNavigationHeight = stickyNavigation?.getBoundingClientRect().height || 0;
              const targetTop = dropdownTitle.getBoundingClientRect().top + window.scrollY - stickyNavigationHeight;
              window.scrollTo({ top: Math.max(targetTop, 0), behavior: scrollBehavior });
            };

            if (prefersReducedMotion) {
              scrollTitleIntoView();
              return;
            }

            const contentContainer = dropdown.querySelector(':scope > .yg-dropdown-content-container');
            if (!contentContainer) {
              scrollTitleIntoView();
              return;
            }

            let fallbackTimer = null;
            const cleanup = () => {
              contentContainer.removeEventListener('transitionend', handleTransitionEnd);
              if (fallbackTimer !== null) {
                window.clearTimeout(fallbackTimer);
                fallbackTimer = null;
              }
            };
            const handleTransitionEnd = (transitionEvent) => {
              if (transitionEvent.target !== contentContainer || transitionEvent.propertyName !== 'height') return;
              cleanup();
              scrollTitleIntoView();
            };

            contentContainer.addEventListener('transitionend', handleTransitionEnd);
            fallbackTimer = window.setTimeout(() => {
              cleanup();
              scrollTitleIntoView();
            }, 350);
          });
        });

        root.dataset.productDetailsInitialized = 'true';
      },

      init(scope = document) {
        scope.querySelectorAll('[data-yg-product-details]').forEach((root) => this.initialize(root));
      }
    };

    document.addEventListener('DOMContentLoaded', () => window.YGProductDetails.init());
    document.addEventListener('shopify:section:load', (event) => window.YGProductDetails.init(event.target));
  }

  window.YGProductDetails.init();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
  class YGTabs03 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.contentSwiper = null;
      this.mountTimer = null;
      this.videoPlaybackFrame = null;
      this.inactiveVideoPauseFrame = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleMediaTransitionEnd = this.handleMediaTransitionEnd.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handlePreviousTabClick = this.handlePreviousTabClick.bind(this);
      this.handleNextTabClick = this.handleNextTabClick.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        tabsShell: this.querySelector('[data-tabs-shell]'),
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
        previousTabButton: this.querySelector('.yg-tabs-03__tab-arrow--prev'),
        nextTabButton: this.querySelector('.yg-tabs-03__tab-arrow--next'),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
        contentSwiper: this.querySelector('[data-content-swiper]'),
        contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      this.sectionElements.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      this.sectionElements.previousTabButton?.addEventListener('click', this.handlePreviousTabClick);
      this.sectionElements.nextTabButton?.addEventListener('click', this.handleNextTabClick);
      window.addEventListener('resize', this.handleResize);

      if (typeof ResizeObserver !== 'undefined') {
        this.tabResizeObserver = new ResizeObserver(() => this.scheduleTabsLayoutUpdate());
        this.sectionElements.tabs.forEach((tab) => this.tabResizeObserver.observe(tab));
      }

      this.updateTabArrows();
      this.mountSwipers();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      this.sectionElements.previousTabButton?.removeEventListener('click', this.handlePreviousTabClick);
      this.sectionElements.nextTabButton?.removeEventListener('click', this.handleNextTabClick);
      window.removeEventListener('resize', this.handleResize);
      this.tabResizeObserver?.disconnect();

      if (this.tabsLayoutFrame) {
        window.cancelAnimationFrame(this.tabsLayoutFrame);
        this.tabsLayoutFrame = null;
      }

      if (this.mountTimer) {
        window.clearTimeout(this.mountTimer);
        this.mountTimer = null;
      }

      if (this.videoPlaybackFrame) {
        window.cancelAnimationFrame(this.videoPlaybackFrame);
        this.videoPlaybackFrame = null;
      }

      if (this.inactiveVideoPauseFrame) {
        window.cancelAnimationFrame(this.inactiveVideoPauseFrame);
        this.inactiveVideoPauseFrame = null;
      }

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper.off('transitionEnd', this.handleMediaTransitionEnd);
        if (!this.mediaSwiper.destroyed) {
          this.mediaSwiper.destroy(true, true);
        }
        this.mediaSwiper = null;
      }

      if (this.contentSwiper) {
        if (!this.contentSwiper.destroyed) {
          this.contentSwiper.destroy(true, true);
        }
        this.contentSwiper = null;
      }

      if (this._sectionElements?.mediaSwiper) {
        this._sectionElements.mediaSwiper.swiper = null;
      }

      if (this._sectionElements?.contentSwiper) {
        this._sectionElements.contentSwiper.swiper = null;
      }

      this._sectionElements = null;
      this.initialized = false;
    }

    scheduleSwiperMount(attempt) {
      if (!this.isConnected || attempt > 100) {
        return;
      }

      if (this.mountTimer) {
        window.clearTimeout(this.mountTimer);
      }

      this.mountTimer = window.setTimeout(() => {
        this.mountTimer = null;
        this.mountSwipers(attempt);
      }, 100);
    }

    async mountSwipers(attempt = 0) {
      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      const contentSwiperElement = this.sectionElements.contentSwiper;

      if (!mediaSwiperElement || !contentSwiperElement) {
        return;
      }

      if (!window.Swiper) {
        if (typeof window.loadMondoSwiper !== 'function') {
          this.scheduleSwiperMount(attempt + 1);
          return;
        }

        try {
          await window.loadMondoSwiper();
        } catch (error) {
          console.error('Failed to load Swiper for YG Tabs 03.', error);
          return;
        }
      }

      if (!this.isConnected) {
        return;
      }

      try {
        if (!mediaSwiperElement.swiper && typeof mediaSwiperElement.initSwiper === 'function') {
          mediaSwiperElement.swiper = mediaSwiperElement.initSwiper(mediaSwiperElement);
        }

        if (!contentSwiperElement.swiper && typeof contentSwiperElement.initSwiper === 'function') {
          contentSwiperElement.swiper = contentSwiperElement.initSwiper(contentSwiperElement);
        }
      } catch (error) {
        console.error('Failed to initialize Swiper for YG Tabs 03.', error);
        return;
      }

      if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
        this.scheduleSwiperMount(attempt + 1);
        return;
      }

      if (!this.mediaSwiper) {
        this.mediaSwiper = mediaSwiperElement.swiper;
        this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper.on('transitionEnd', this.handleMediaTransitionEnd);
      }

      if (!this.contentSwiper) {
        this.contentSwiper = contentSwiperElement.swiper;
      }

      this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.contentSwiper.allowTouchMove = false;
      this.contentSwiper.params.allowTouchMove = false;
      this.contentSwiper.params.autoHeight = true;

      this.setActiveState(0, {
        syncSwiper: false,
        scrollBehavior: 'auto',
        resetInactiveVideos: true,
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.tabIndex);

      this.setActiveState(index);
    }

    handlePreviousTabClick() {
      this.activateRelativeTab(-1);
    }

    handleNextTabClick() {
      this.activateRelativeTab(1);
    }

    activateRelativeTab(offset) {
      const targetTab = this.sectionElements.tabs[this.activeIndex + offset];

      if (targetTab) {
        targetTab.click();
      }
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const currentIndex = this.activeIndex;
      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = currentIndex;

      if (event.key == 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      } else if (event.key == 'ArrowRight') {
        nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      } else if (event.key == 'Home') {
        nextIndex = 0;
      } else if (event.key == 'End') {
        nextIndex = lastIndex;
      }

      event.preventDefault();

      const nextTab = this.sectionElements.tabs[nextIndex];
      if (nextTab) {
        nextTab.focus();
      }

      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
        ? this.mediaSwiper.realIndex
        : this.mediaSwiper.activeIndex;

      if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
        this.contentSwiper.slideTo(nextIndex);
      }

      this.setActiveState(nextIndex, {
        syncSwiper: false,
      });
    }

    handleMediaTransitionEnd() {
      this.scheduleInactiveVideoPause();
    }

    handleResize() {
      this.updateOverflowState();
      this.updateIndicator();
      this.updateTabArrows();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView('auto');
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }

    scheduleTabsLayoutUpdate() {
      if (this.tabsLayoutFrame) {
        window.cancelAnimationFrame(this.tabsLayoutFrame);
      }

      this.tabsLayoutFrame = window.requestAnimationFrame(() => {
        this.tabsLayoutFrame = null;
        this.updateOverflowState();
        this.updateIndicator();
        this.updateTabArrows();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        }
      });
    }

    isTabsOverflowing() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return false;
      }

      return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
    }

    scrollActiveTabIntoView(behavior = 'smooth') {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!activeTab || !scrollContainer) {
        return;
      }

      if (this.isTabsOverflowing()) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = activeTab.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior: behavior,
          });
        } else {
          scrollContainer.scrollLeft = nextScrollLeft;
        }
      }
    }

    updateOverflowState() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return;
      }

      scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
    }

    updateTabArrows() {
      const tabsShell = this.sectionElements.tabsShell;
      const previousTabButton = this.sectionElements.previousTabButton;
      const nextTabButton = this.sectionElements.nextTabButton;

      if (!tabsShell || !previousTabButton || !nextTabButton) {
        return;
      }

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const isOverflowing = this.isTabsOverflowing();
      const lastIndex = this.sectionElements.tabs.length - 1;
      const hasPrevious = isMobile && isOverflowing && this.activeIndex > 0;
      const hasNext = isMobile && isOverflowing && this.activeIndex < lastIndex;

      previousTabButton.hidden = !hasPrevious;
      nextTabButton.hidden = !hasNext;
      tabsShell.classList.toggle('has-previous-tab', hasPrevious);
      tabsShell.classList.toggle('has-next-tab', hasNext);
    }

    updateIndicator() {
      const tabsTrack = this.sectionElements.tabsTrack;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!tabsTrack || !activeTab) {
        return;
      }

      tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
      tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
    }

    pauseInactiveVideos(activeVideo) {
      this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
        if (videoElement !== activeVideo && typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    scheduleInactiveVideoPause() {
      if (this.inactiveVideoPauseFrame) {
        window.cancelAnimationFrame(this.inactiveVideoPauseFrame);
      }

      this.inactiveVideoPauseFrame = window.requestAnimationFrame(() => {
        this.inactiveVideoPauseFrame = window.requestAnimationFrame(() => {
          this.inactiveVideoPauseFrame = null;
          this.pauseInactiveVideos(this.getActiveVideo());
        });
      });
    }

    getActiveVideo() {
      const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);

      return activeSlide?.querySelector('yg-video') || null;
    }

    playActiveVideo() {
      const activeVideo = this.getActiveVideo();
      const requestedIndex = this.activeIndex;

      if (this.videoPlaybackFrame) {
        window.cancelAnimationFrame(this.videoPlaybackFrame);
      }

      if (!activeVideo) {
        this.videoPlaybackFrame = null;
        return;
      }

      this.videoPlaybackFrame = window.requestAnimationFrame(() => {
        this.videoPlaybackFrame = null;

        if (!this.isConnected || this.activeIndex !== requestedIndex) {
          return;
        }

        if (typeof activeVideo.resumeAutoplayVideo === 'function') {
          activeVideo.resumeAutoplayVideo();
        } else if (typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      });
    }

    setActiveState(index, options = {}) {
      const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';

      this.activeIndex = safeIndex;

      if (syncSwiper) {
        if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
          this.mediaSwiper.slideTo(safeIndex);
        }

        if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
          this.contentSwiper.slideTo(safeIndex);
        }
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
      });

      this.updateOverflowState();
      this.updateIndicator();
      this.updateTabArrows();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView(scrollBehavior);
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      this.playActiveVideo();

      if (options.resetInactiveVideos === true) {
        this.pauseInactiveVideos(this.getActiveVideo());
      }

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }
  }

  if (!window.customElements.get('yg-tabs-03')) {
    window.customElements.define('yg-tabs-03', YGTabs03);
  }

  } catch(e) { console.error(e); }
})();
})();
